export default [
    {
        text: 'Tina arbeitet bei einer Schuhfabrik.',
        stubs: [1, 2, 3],
        translations: {
            eng: 'Tina works at a shoe factory'
        },
        tags: [
            'arbeiten',
            'bei'
        ]
    },
    {
        text: 'Der Tischler arbeitet an einem Möbelstück.',
        stubs: [2, 3, 4],
        translations: {
            eng: 'The carpenter is working on a piece of furniture'
        },
        tags: [
            'arbeiten',
            'an'
        ]
    },
    {
        text: 'Du musst mir bei dieser Arbeit helfen.',
        stubs: [2, 3, 4, 6],
        translations: {
            eng: 'You have to help me with this work'
        },
        tags: [
            'helfen',
            'bei',
            'dies'
        ]
    },
    {
        text: 'Meine Tante hilft meiner Schwester bei ihren Hausaufgaben.',
        stubs: [0, 2, 3, 5, 6],
        translations: {
            eng: 'My aunt helps my sister with her homework'
        },
        tags: [
            'helfen',
            'bei'
        ]
    },
    {
        text: 'Der Vater hat sich bei der Schule informiert.',
        stubs: [0, 2, 3, 4, 5, 7],
        translations: {
            eng: 'The father was informed by the school'
        },
        tags: [
            'informieren',
            'bei',
            'reflexive',
            'haben'
        ]
    },
    {
        text: 'Wir sind über den Unfall informiert.',
        stubs: [1, 2, 3, 5],
        translations: {
            eng: 'We are informed about the accident.'
        },
        tags: [
            'über',
            'informieren',
            'sein'
        ]
    },
    {
        text: 'Ich bleibe bei meiner Meinung.',
        stubs: [1, 2, 3],
        translations: {
            eng: 'I stand by my opinion.'
        },
        tags: [
            'bleiben',
            'bei'
        ]
    },
    {
        text: 'Du musst noch beim Reisebüro anrufen.',
        stubs: [3, 5],
        translations: {
            eng: 'You must still call the travel agency.'
        },
        tags: [
            'anrufen',
            'an-',
            '-rufen',
            'bei',
            'müssen'
        ]
    },
    {
        text: 'Ich spreche mit deiner Schwester.',
        stubs: [1, 2, 3],
        translations: {
            eng: 'I am speaking with your sister'
        },
        tags: [
            'sprechen',
            'mit'
        ]
    },
    {
        text: 'Wir müssen über den Zeitplan sprechen.',
        stubs: [2, 3, 5],
        translations: {
            eng: 'We need to talk about the schedule'
        },
        tags: [
            'sprechen',
            'über',
            'müssen'
        ]
    },
    {
        text: 'Sie hat von dir gesprochen.',
        stubs: [1, 2, 3, 4],
        translations: {
            eng: 'She has spoken of you'
        },
        tags: [
            'present-perfect',
            'active-voice',
            'sprechen',
            'von',
            'haben'
        ]
    },
    {
        text: 'Ich freue mich auf die Reise.',
        stubs: [2, 3, 4],
        translations: {
            eng: 'I\'m looking forward to the trip'
        },
        tags: [
            'freuen',
            'auf',
            'reflexive'
        ]
    },
    {
        text: 'Ich habe mich auf mein neues Leben gefreut.',
        stubs: [1, 2, 3, 4, 5, 7],
        translations: {
            eng: 'I was looking forward to my new life.'
        },
        tags: [
            'present-perfect',
            'active-voice',
            'freuen',
            'auf',
            'reflexive',
            'haben'
        ]
    },
    {
        text: 'Bei der Wohnungssuche hat mir ein Bekannter geholfen.',
        stubs: [0, 1, 4, 5, 7],
        translations: {
            eng: 'An acquaintance helped me with the house hunting.'
        },
        tags: [
            'present-perfect',
            'active-voice',
            'helfen',
            'bei'
        ]
    },
    {
        text: 'Ich warte seit Monaten auf den Besuch meiner besten Freundin.',
        stubs: [1, 4, 5, 7, 8],
        translations: {
            eng: 'I have been waiting for months for my best friend\'s visit.'
        },
        tags: [
            'warten',
            'auf'
        ]
    },
    {
        text: 'Er spricht von den Nachrichten.',
        stubs: [1, 2, 3],
        translations: {
            eng: 'He speaks about the news.'
        },
        tags: [
            'sprechen',
            'von'
        ]
    },
    {
        text: 'Zeit, dass ich an meine Ferien denke.',
        stubs: [3, 4, 6],
        translations: {
            eng: 'Time for me to think about my holiday.'
        },
        tags: [
            'denken',
            'an',
            'dass'
        ]
    },
    {
        text: 'Ich sitze hier rum ganz allein in der Kälte.',
        stubs: [1, 6, 7],
        translations: {
            eng: 'I sit around here all alone in the cold.'
        },
        tags: [
            'sitzen',
            'in'
        ]
    },
    {
        text: 'Ich möchte mich für deine Hilfe bedanken.',
        stubs: [1, 2, 3, 4, 6],
        translations: {
            eng: 'I would like to thank you for your help.'
        },
        tags: [
            'be-',
            'bedanken',
            'für',
            'reflexive',
            'möchten'
        ]
    },
    {
        text: 'Wir möchten uns bei Ihnen bedanken.',
        stubs: [1, 2, 3, 4, 5],
        translations: {
            eng: 'We would like to thank you (formal).'
        },
        tags: [
            'be-',
            'bedanken',
            'bei',
            'reflexive',
            'möchten'
        ]
    },
    {
        text: 'Wir mussten nach der Adresse fragen.',
        stubs: [2, 3, 5],
        translations: {
            eng: 'We had to ask for the address.'
        },
        tags: [
            'fragen',
            'nach',
            'müssen'
        ]
    },
    {
        text: 'Kann ich dich um Rat fragen?',
        stubs: [2, 3, 5],
        translations: {
            eng: 'Can I ask you for advice?'
        },
        tags: [
            'fragen',
            'um',
            'reflexive',
            'können'
        ]
    },
    {
        text: 'Die Touristen fragen einen Passanten nach dem Weg.',
        stubs: [2, 3, 5, 6],
        translations: {
            eng: 'The tourists are asking a passerby for directions.'
        },
        tags: [
            'fragen',
            'nach'
        ]
    },
    {
        text: 'Aus deinem Verhalten schließe ich, dass du schuld bist.',
        stubs: [0, 1, 3, 5, 8],
        translations: {
            eng: 'From your behavior I conclude that you are to blame.'
        },
        tags: [
            'schließen',
            'aus',
            'dass'
        ]
    },
    {
        text: 'Die Ereigniße der Zukunft können wir nicht aus den gegenwärtigen erschließen.',
        stubs: [7, 8, 10],
        translations: {
            eng: 'We can\'t infer the events of the future from those of the present.'
        },
        tags: [
            'erschließen',
            'er-',
            'aus',
            'können'
        ]
    },
    {
        text: 'Auch auf dem höchsten Thron sitzt man auf dem eigenen Hintern.',
        stubs: [1, 2, 3, 5, 7, 8],
        translations: {
            eng: 'Even on the highest throne, you still sit on your own butt.'
        },
        tags: [
            'sitzen',
            'auf'
        ]
    },
    {
        text: 'Ich lerne Deutsch auf der Straße.',
        stubs: [1, 3, 4],
        translations: {
            eng: 'I learn German on the street.'
        },
        tags: [
            'lernen',
            'auf'
        ]
    },
    {
        text: 'Ich wollte die Blumen auf das Fensterbrett stellen.',
        stubs: [1, 2, 4, 5, 7],
        translations: {
            eng: 'I wanted to put the flowers on the windowsill.'
        },
        tags: [
            'stellen',
            'auf',
            'wollen',
            'wollten'
        ]
    },
    {
        text: 'Die Buntstiften sind auf den Boden gefallen.',
        stubs: [2, 3, 4, 6],
        translations: {
            eng: 'The crayons fell to the ground.'
        },
        tags: [
            'present-perfect',
            'active-voice',
            'fallen',
            'auf',
            'sein'
        ]
    },
    {
        text: 'Sie können Ihren Mantel an die Garderobe hängen.',
        stubs: [4, 5, 7],
        translations: {
            eng: 'You (formal) can hang your coat on the coat rack.'
        },
        tags: [
            'lernen',
            'an',
            'hängen',
            'können'
        ]
    },
    {
        text: 'Die Blumen liegen auf dem Fensterbrett.',
        stubs: [2, 3, 4],
        translations: {
            eng: 'The flowers are on the windowsill.'
        },
        tags: [
            'liegen',
            'auf'
        ]
    },
    {
        text: 'Das Papier liegt unter dem Tisch.',
        stubs: [2, 3, 4],
        translations: {
            eng: 'The paper is under the table.'
        },
        tags: [
            'liegen',
            'unter'
        ]
    },
    {
        text: 'Du kannst die Papiere in meine Schublade legen.',
        stubs: [4, 5, 7],
        translations: {
            eng: 'You can place the papers in my drawer.'
        },
        tags: [
            'legen',
            'in',
            'können'
        ]
    },
    {
        text: 'Die Perser glaubten sogar, dass die Erde aus einem riesigen Ei geschlüpft ist.',
        stubs: [2, 4, 7, 8, 11, 12],
        translations: {
            eng: 'The Persians even believed that Earth hatched from a giant egg.'
        },
        tags: [
            'present-perfect',
            'active-voice',
            'schlüpfen',
            'aus',
            'dass',
            ', dass',
            'glauben',
            'preterite',
            'wo?'
        ]
    },
    {
        text: 'Die alten Ägypter glaubten an ein Weiterleben nach dem Tod und an eine Art Seele, die im Augenblick des Todes den Körper verlässt.',
        stubs: [3, 4, 5, 7, 8, 10, 11, 12, 15, 16, 18, 20, 22],
        translations: {
            eng: 'The ancient Egyptians believed in a life after death and a kind of soul which abandons the body at the moment of death.'
        },
        tags: [
            'glauben',
            'verlassen',
            '-lassen',
            'ver-',
            'an',
            'nach',
            ', article'
        ]

    },
    // {
    //     text: 'Wussten Sie schon, dass Sie in Berlin nie weiter als 500 Meter von der nächsten Haltestelle, dem nächsten Bahnhof oder der nächsten Station entfernt sind?',
    //     stubs: [0, 3, 5, 9, 12, 13, 16, 20, 23, 24],
    //     translations: {
    //         eng: 'Did you (formal) already know that in Berlin you are never more than 500 meters from the next bus stop, the next rail station or the train station?'
    //     },
    //     tags: [
    //         'entfernen',
    //         'von',
    //         'in',
    //         'dass',
    //         'als'
    //     ]
    // },
    {
        text: 'Heute habe ich endlich mit Englisch Sprechen aufgehört.',
        stubs: [1, 4, 7],
        translations: {
            eng: 'Today I finally stopped speaking English.'
        },
        tags: [
            'aufhören',
            'auf-',
            'mit',
            'haben'
        ]
    },
    {
        text: 'Sie filmt mit ihrem Smartphone die Menschenmenge und die Redner auf der Leinwand.',
        stubs: [1, 2, 3, 5, 7, 8, 10, 11],
        translations: {
            eng: 'She\'s filming the crowd and the speakers on the screen with her smartphone.'
        },
        tags: [
            'filmen',
            'mit',
            'auf'
        ]
    },
    {
        text: 'Aus allen Richtungen strömen Menschen auf den Platz am Rheinufer.',
        stubs: [0, 1, 3, 5, 6, 8],
        translations: {
            eng: 'People from all over flock to the plaza on the banks of the Rhine'
        },
        tags: [
            'strömen',
            'aus',
            'auf',
            'an',
            'all'
        ]
    },
    {
        text: 'Kleine Kinder sitzen auf den Schultern ihrer Eltern.',
        stubs: [2, 3, 4, 6],
        translations: {
            eng: 'Small children are sitting on the shoulders of their parents'
        },
        tags: [
            'sitzen',
            'auf',
            'genitive'
        ]
    },
    {
        text: 'Sie gedenken an die Opfer in München.',
        stubs: [1, 2, 3, 5],
        translations: {
            eng: 'They are commemorating the victims in Munich.'
        },
        tags: [
            'gedenken',
            'ge-',
            'an',
            'in'
        ]
    },
    {
        text: 'Der Politiker spricht sich für Reformen aus.',
        stubs: [2, 3, 4, 6],
        translations: {
            eng: 'The politician is calling for reforms.'
        },
        tags: [
            'aussprechen',
            'aus-',
            '-sprechen',
            'sprechen',
            'für',
            'reflexive'
        ]
    },
    {
        text: 'Wer strebt nicht nach einem besseren Leben?',
        stubs: [1, 3, 4, 5],
        translations: {
            eng: 'Who doesn\'t strive for a better life?'
        },
        tags: [
            'streben',
            'nach'
        ]
    },
    {
        text: 'Er ist an einem Herzinfarkt gestorben.',
        stubs: [1, 2, 3, 5],
        translations: {
            eng: 'He died of a heart attack.'
        },
        tags: [
            'present-perfect',
            'active-voice',
            'sterben',
            'an',
            'sein'
        ]
    },
    {
        text: 'Wir teilen den Kuchen in acht Stücke.',
        stubs: [1, 2, 4],
        translations: {
            eng: 'We are dividing the cake into eight pieces.'
        },
        tags: [
            'teilen',
            'in',
            'present-simple',
            'active-voice'
        ]
    },
    {
        text: 'Sie hat sich von ihrem Freund getrennt.',
        stubs: [1, 2, 3, 4, 6],
        translations: {
            eng: 'She broke up with her boyfriend.'
        },
        tags: [
            'present-perfect',
            'active-voice',
            'trennen',
            'von',
            'haben',
            'reflexive'
        ]
    },
    {
        text: 'Später treffe ich mich mit meinem Mann.',
        stubs: [1, 3, 4, 5],
        translations: {
            eng: 'I\'m meeting with my husband later.'
        },
        tags: [
            'present-simple',
            'active-voice',
            'treffen',
            'mit',
            'reflexive'
        ]
    },
    {
        text: 'Das kann noch zu einem Problem werden.',
        stubs: [3, 4, 6],
        translations: {
            eng: 'That can still become a problem.'
        },
        tags: [
            'werden',
            'zu',
            'können',
            'present-simple',
            'active-voice'
        ]
    },
    {
        text: 'Was weißt du über den Skandal?',
        stubs: [1, 3, 4],
        translations: {
            eng: 'What do you know about the skandal?'
        },
        tags: [
            'wissen',
            'über'
        ]
    },
    {
        text: 'Zwei Wochen nach dem Putschversuch in der Türkei sind fast 1400 Soldaten aus den Streitkräften entlassen worden.',
        stubs: [2, 3, 5, 6, 8, 12, 13, 15, 16],
        translations: {
            eng: 'Two weeks after the failed coup in Turkey, almost 1400 soldiers have been dismissed from the armed forces.'
        },
        tags: [
            'nach',
            'in',
            'aus',
            'entlassen',
            'ent-',
            '-lassen',
            'worden',
            'sein',
            'present-perfect',
            'passive-voice'
        ]
    },
    {
        text: 'Bei den Bienen sind nur die Weibchen mit einem Stachel bewaffnet, den sie in Notwehr gegen ihre Feinde einsetzen.',
        stubs: [0, 1, 7, 8, 13, 15, 16, 18],
        translations: {
            eng: 'Among bees only the females are armed with a sting, which they use in self-defense against their enemies.'
        },
        tags: [
            'bei',
            'mit',
            'in',
            'gegen',
            'ein-',
            '-setzen',
            'einsetzen'
        ]
    },
    {
        text: 'Beim Abflug wird der komplette Stechapparat mit der Giftblase aus dem Hinterleib der Biene herausgerissen.',
        stubs: [0, 2, 3, 4, 6, 7, 9, 10, 12, 14],
        translations: {
            eng: 'On departure, the entire stinging apparatus, along with the poison sac, is torn out of the abdomen of the bee.'
        },
        tags: [
            'bei',
            'mit',
            'aus',
            'herausreißen',
            'werden',
            'present-simple',
            'passive-voice'
        ]
    },
    {
        text: 'Ich bin oft gefragt worden.',
        stubs: [1, 3, 4, 5],
        translations: {
            eng: 'I have often been asked.'
        },
        tags: [
            'present-perfect',
            'passive-voice',
            'fragen',
            'sein',
            'worden'
        ]
    },
    {
        text: 'Ich bin in Deutschland gewesen.',
        stubs: [1, 2, 4],
        translations: {
            eng: 'I have been in Germany.'
        },
        tags: [
            'present-perfect',
            'active-voice',
            'sein',
            'in',
            'gewesen'
        ]
    },
    {
        text: 'Meine Mutter ist lange bei uns geblieben.',
        stubs: [0, 2, 4, 6],
        translations: {
            eng: 'My mother stayed with us for a long time.'
        },
        tags: [
            'present-perfect',
            'active-voice',
            'sein',
            'bleiben',
            'bei'
        ]
    },
    {
        text: 'Es ist dunkel geworden.',
        stubs: [1, 3],
        translations: {
            eng: 'It has become dark.'
        },
        tags: [
            'present-perfect',
            'active-voice',
            'sein',
            'geworden'
        ]
    },
    {
        text: 'Er ist schüchtern geworden.',
        stubs: [1, 3],
        translations: {
            eng: 'He has become timid.'
        },
        tags: [
            'present-perfect',
            'active-voice',
            'sein',
            'geworden'
        ]
    },
    {
        text: 'Wir sind durch den Saal getanzt.',
        stubs: [1, 2, 3, 5],
        translations: {
            eng: 'We danced through the hall.'
        },
        tags: [
            'present-perfect',
            'active-voice',
            'sein',
            'durch',
            'tanzen'
        ]
    },
    {
        text: 'Wir haben die ganze Nacht im Saal getanzt.',
        stubs: [1, 5, 7],
        translations: {
            eng: 'We danced in the hall the whole night.'
        },
        tags: [
            'present-perfect',
            'active-voice',
            'haben',
            'in',
            'tanzen',
            'wo?'
        ]
    },
    {
        text: 'Das Kind hat die Schokolade kaufen wollen.',
        stubs: [2, 3, 5, 6],
        translations: {
            eng: 'The child wanted to buy the chocolate.'
        },
        tags: [
            'haben',
            'kaufen',
            'wollen',
            'active-voice',
            'present-perfect',
            'double-infinitive'
        ]
    },
    {
        text: 'Die Verwandten haben sich gezankt.',
        stubs: [2, 3, 4],
        translations: {
            eng: 'The relatives quarreled.'
        },
        tags: [
            'present-perfect',
            'active-voice',
            'zanken',
            'haben',
            'reflexive'
        ]
    },
    {
        text: 'Ich bin nach Italien gereist.',
        stubs: [1, 2, 4],
        translations: {
            eng: 'I have traveled to Italy.'
        },
        tags: [
            'present-perfect',
            'active-voice',
            'sein',
            'nach',
            'reisen'
        ]
    },
    {
        text: 'Er hat sich geduscht.',
        stubs: [1, 2, 3],
        translations: {
            eng: 'He showered.'
        },
        tags: [
            'active-voice',
            'present-perfect',
            'haben',
            'reflexive',
            'duschen'
        ]
    },
    {
        text: 'Haben Sie das Auto gekauft?',
        stubs: [0, 2, 4],
        translations: {
            eng: 'Did you (formal) buy the car?'
        },
        tags: [
            'active-voice',
            'present-perfect',
            'haben',
            'kaufen'
        ]
    },
    {
        text: 'Ich habe nichts sagen dürfen.',
        stubs: [1, 3, 4],
        translations: {
            eng: 'I wasn\'t allowed to say anything.'
        },
        tags: [
            'haben',
            'sagen',
            'dürfen',
            'active-voice',
            'present-perfect',
            'double-infinitive'
        ]
    },
    {
        text: 'Wer hat das wissen können?',
        stubs: [1, 3, 4],
        translations: {
            eng: 'Who could\'ve known that?'
        },
        tags: [
            'haben',
            'wissen',
            'können',
            'active-voice',
            'present-perfect',
            'double-infinitive'
        ]
    },
    {
        text: 'Alle Kinder haben helfen müssen.',
        stubs: [2, 3, 4],
        translations: {
            eng: 'All the children had to help.'
        },
        tags: [
            'haben',
            'helfen',
            'müssen',
            'present-perfect',
            'active-voice',
            'double-infinitive'
        ]
    },
    {
        text: 'Er hat mehr tun sollen.',
        stubs: [1, 3, 4],
        translations: {
            eng: 'He was supposed to do more.'
        },
        tags: [
            'haben',
            'tun',
            'sollen',
            'present-perfect',
            'active-voice',
            'double-infinitive'
        ]
    },
    {
        text: 'Ich habe so etwas immer machen wollen.',
        stubs: [1, 5, 6],
        translations: {
            eng: 'I always wanted to do something like that.'
        },
        tags: [
            'haben',
            'machen',
            'wollen',
            'present-perfect',
            'active-voice',
            'double-infinitive'
        ]
    },
    {
        text: 'Sie haben mich nach Hause tragen müssen.',
        stubs: [1, 2, 5, 6],
        translations: {
            eng: 'They had to carry me home.'
        },
        tags: [
            'haben',
            'tragen',
            'müssen',
            'present-perfect',
            'active-voice',
            'double-infinitive'
        ]
    },
    {
        text: 'Sie müssen mich nach Hause getragen haben.',
        stubs: [1, 2, 5, 6],
        translations: {
            eng: 'They must have carried me home.'
        },
        tags: [
            'present-perfect',
            'haben',
            'sagen',
            'dürfen',
            'present-perfect',
            'active-voice'
        ]
    },
    {
        text: 'Ich gehe heute nicht in die Schule, weil ich krank bin.',
        stubs: [1, 4, 5, 7, 10],
        translations: {
            eng: 'I\'m not going to school today because I am sick.'
        },
        tags: [
            'gehen',
            'in',
            'weil',
            'present-simple',
            'active-voice'
        ]
    },
    {
        text: 'Mein Vater geht früh ins Bett, weil er morgen aufstehen muss.',
        stubs: [0, 2, 4, 6, 9, 10],
        translations: {
            eng: 'My dad is going to bed early because he has to get up early.'
        },
        tags: [
            'gehen',
            'in',
            'weil',
            'aufstehen',
            'auf-',
            '-stehen',
            'müssen',
            'past-simple',
            'active-voice'
        ]
    },
    {
        text: 'Sie wollte bewundert werden.',
        stubs: [1, 2, 3],
        translations: {
            eng: 'She wanted to be admired.'
        },
        tags: [
            'wollten',
            'bewundern',
            'werden',
            'past-simple',
            'passive-voice'
        ]
    },
    {
        text: 'Die Wohnung sollte geräumt werden.',
        stubs: [2, 3, 4],
        translations: {
            eng: 'The flat was supposed to be cleaned.'
        },
        tags: [
            'sollten',
            'räumen',
            'werden',
            'past-simple',
            'passive-voice',
        ]
    },
    {
        text: 'Ihm konnte nicht geholfen werden.',
        stubs: [0, 1, 3, 4],
        translations: {
            eng: 'He could not be helped.'
        },
        tags: [
            'pronoun-dative',
            'konnten',
            'helfen',
            'werden',
            'past-simple',
            'passive-voice'
        ]
    },
    {
        text: 'Das wird repariert werden müssen.',
        stubs: [1, 2, 3, 4],
        translations: {
            eng: 'That will need to be repaired.'
        },
        tags: [
            'werden',
            'reparieren',
            'müssen',
            'future-simple',
            'passive-voice'
        ]
    },
    {
        text: 'Er isst einen Apfel, weil er Hunger hat.',
        stubs: [1, 2, 4, 7],
        translations: {
            eng: 'He\'s eating an apple because he\'s hungry.'
        },
        tags: [
            'essen',
            'weil',
            'present-simple',
            'active-voice'
        ]
    },
    {
        text: 'Es werden viele Häuser aus Holz gebaut.',
        stubs: [0, 1, 2, 4, 6],
        translations: {
            eng: 'There are many houses built out of wood.'
        },
        tags: [
            'werden',
            'aus',
            'bauen',
            'viel',
            'present-simple',
            'passive-voice'
        ]
    },
    {
        text: 'Heute werden viele Häuser aus Holz gebaut.',
        stubs: [1, 2, 4, 6],
        translations: {
            eng: 'Today many houses are built out of wood.'
        },
        tags: [
            'werden',
            'aus',
            'bauen',
            'viel',
            'present-simple',
            'passive-voice'
        ]
    },
    {
        text: 'Es wird uns geholfen.',
        stubs: [0, 1, 3],
        translations: {
            eng: 'We are being helped.'
        },
        tags: [
            'werden',
            'helfen',
            'present-simple',
            'passive-voice'
        ]
    },
    {
        text: 'Ich kann dir leider nicht helfen.',
        stubs: [1, 2, 5],
        translations: {
            eng: 'Unfortunately, I can\'t help you.'
        },
        tags: [
            'können',
            'helfen',
            'pronoun-dative',
            'present-simple',
            'active-voice'
        ]
    },
    {
        text: 'Mir wird geholfen.',
        stubs: [1, 2],
        translations: {
            eng: 'I am being helped.'
        },
        tags: [
            'werden',
            'geholfen',
            'present-simple',
            'passive-voice'
        ]
    },
    {
        text: 'Das wird von den Kindern gemacht werden können.',
        stubs: [1, 2, 3, 5, 6, 7],
        translations: {
            eng: 'That will be able to be done by the children.'
        },
        tags: [
            'von',
            'werden',
            'machen',
            'können',
            'future-simple',
            'passive-voice'
        ]
    },
    {
        text: 'Maria wartet darauf, dass der Bus kommt.',
        stubs: [2],
        translations: {
            eng: 'Maria is waiting for the bus to come.'
        },
        tags: [
            'da-'
        ]
    },
    {
        text: 'Ich freue mich darauf, von dir zu hören.',
        stubs: [3],
        translations: {
            eng: 'I\'m looking forward to hearing from you.'
        },
        tags: [
            'da-'
        ]
    },
    {
        text: 'Ich freue mich darüber, von dir zu hören.',
        stubs: [3],
        translations: {
            eng: 'I\'m happy to hear from you.'
        },
        tags: [
            'da-'
        ]
    },
    // {
    //     text: 'Ich bin sauer darauf, dass mein Mitbewohner nie saubermacht.',
    //     stubs: [3, 4, 5, 8],
    //     translations: {
    //         eng: 'I\'m angry that my flatmate never cleans.'
    //     },
    //     tags: [
    //         'da-',
    //         'sauber-',
    //         '-machen',
    //         'saubermachen',
    //         ', dass'
    //     ]
    // },
    {
        text: 'Das Portrait ist nicht perfekt, aber ich bin zufrieden damit.',
        stubs: [0, 5, 6, 7, 8, 9],
        translations: {
            eng: 'The portrait is not perfect, but I\'m satisfied with it.'
        },
        tags: [
            ', aber',
            'zufrieden',
            'sein',
            'da-'
        ]
    },

    {
        text: 'Im Kino kommen erst Trailer. Der Film kommt danach.',
        stubs: [8],
        translations: {
            eng: 'In the cinema, first come the trailers. The movie comes after that.'
        },
        tags: [
            'da-'
        ]
    },
    {
        text: 'Meine Freundin will Sushi essen, aber ich bin dagegen.',
        stubs: [8],
        translations: {
            eng: 'My girlfriend wants to eat sushi but I\'m against that.'
        },
        tags: [
            'da-'
        ]
    },
    {
        text: 'Ich bestehe darauf, dass du dich entschuldigst.',
        stubs: [2],
        translations: {
            eng: 'I\'m insisting that you apologize.'
        },
        tags: [
            'da-'
        ]
    },
    {
        text: 'Bist du sicher, dass sie das Buch hat lesen können?',
        stubs: [3, 7, 8, 9],
        translations: {
            eng: 'Are you sure that she was able to read the book?'
        },
        tags: [
            'dass',
            'lesen',
            'haben',
            'können'
        ]
    },
    {
        text: 'Wir sind nach Hause gegangen, weil wir keine Karten haben kaufen können.',
        stubs: [1, 4, 5, 7, 9, 10, 11],
        translations: {
            eng: 'We went home because we couldn\'t buy any tickets.'
        },
        tags: [
            'present-perfect',
            'active-voice',
            'double-infinitive',
            'sein',
            'gehen',
            'weil',
            'haben',
            'kaufen',
            'können'
        ]
    },
    {
        text: 'Er hatte kein Geld mehr, weil er ein neues Haus hatte bauen lassen.',
        stubs: [1, 2, 5, 7, 8, 10, 11, 12],
        translations: {
            eng: 'He didn\'t have any more money, because he had had a new house built.'
        },
        tags: [
            'preterite',
            'past-perfect',
            'active-voice',
            'double-infinitive',
            'weil',
            'bauen',
            'lassen',
            'hatten'
        ]
    },
    {
        text: 'Sie erinnert sich nicht daran, dass ich ihr habe kochen helfen.',
        stubs: [1, 2, 4, 5, 7, 8, 9, 10],
        translations: {
            eng: 'She doesn\'t remember that I had helped her cook.'
        },
        tags: [
            'da-',
            'erinnern',
            'reflexive',
            'dass',
            'kochen',
            'helfen',
            'pronoun-dative',
            'present-simple',
            'present-perfect',
            'active-voice',
            'double-infinitive'
        ]
    },
    {
        text: 'Ich will, dass du dein Zimmer aufräumst.',
        stubs: [1, 2, 4, 6],
        translations: {
            eng: 'I want you to clean up your room.'
        },
        tags: [
            'present-simple',
            'active-voice',
            'wollen',
            'dass',
            'aufräumen',
            'auf-'
        ]
    },
    {
        text: 'Die Idee, dass ich plötzlich für alles verantwortlich sein sollte, war mir neu.',
        stubs: [2, 5, 6, 8, 9, 10, 11],
        translations: {
            eng: 'The idea that I was suddenly supposed to be responsible for everything was new to me.'
        },
        tags: [
            'dass',
            'sein',
            'war',
            'sollten',
            'all'
        ]
    },
    {
        text: 'Ich glaube, dass wir genug Geld für diese Wohnung haben.',
        stubs: [2, 6, 7, 9],
        translations: {
            eng: 'I think that we have enough money for this apartment.'
        },
        tags: [
            'dass',
            'für',
            'dies'
        ]
    },

    {
        text: 'Bei der Ausgrabungsstätte, müssen wir Gegenstände in der Erde freischaufeln.',
        stubs: [5, 9],
        translations: {
            eng: 'At the excavation site, we have to dig objects out of the ground.'
        },
        tags: [
            'vocab-cristina'
        ]
    },
    {
        text: 'Der Organisation, die mich an diese Projekt vermittelt hat, muss ich eine Gebühr von 100 Euro bezahlen.',
        stubs: [2, 5, 7, 12],
        translations: {
            eng: 'I have to pay the organization that organized this project a 100 Euro fee.'
        },
        tags: [
            'vocab-cristina'
        ]
    },
    {
        text: 'Ich hatte heute morgen eine Behandlung mit Akupunkturnadeln.',
        stubs: [5],
        translations: {
            eng: 'I had an acupuncture needle treatment this morning.'
        },
        tags: [
            'vocab-cristina'
        ]
    },
    {
        text: 'Im nächsten Frühling machen wir einen Spaziergang über die Wiesen.',
        stubs: [9],
        translations: {
            eng: 'Next spring we\'ll go for a walk in the meadows.'
        },
        tags: [
            'vocab-cristina'
        ]
    },
    {
        text: 'Du strahlst ja so. Hast du im Lotto gewonnen?',
        stubs: [1],
        translations: {
            eng: 'You are beaming. Did you win the lottery?'
        },
        tags: [
            'vocab-cristina'
        ]
    },
    {
        text: 'Ich bin nicht sicher. Ich schätze mal so 20 kilometer von hier.',
        stubs: [5],
        translations: {
            eng: 'I\'m not sure. I guess something like 20 kilometers from here.'
        },
        tags: [
            'vocab-cristina'
        ]
    },
    {
        text: 'Die Pfosten sind im Abstand von einem Meter aufgestellt.',
        stubs: [2, 3, 5, 6, 8],
        translations: {
            eng: 'The posts were set up in intervals of one meter.'
        },
        tags: [
            'aufstellen',
            'auf-',
            '-stellen',
            'sein'
        ]
    },
    {
        text: 'Das Auto lässt sich leicht reparieren.',
        stubs: [2, 3, 5],
        translations: {
            eng: 'The car can (literally: lets itself) be repaired easily.'
        },
        tags: [
            'lassen',
            'reflexive',
            'reparieren'
        ]
    },
    {
        text: 'Lassen uns morgen schwimmen gehen.',
        stubs: [0, 3, 4],
        translations: {
            eng: 'Let\'s go swimming tomorrow.'
        },
        tags: [
            'lassen',
            'schwimmen',
            'gehen'
        ]
    },
    {
        text: 'Lässt du ein Haus bauen?',
        stubs: [0, 4],
        translations: {
            eng: 'Are you having a house built?'
        },
        tags: [
            'lassen',
            'bauen'
        ]
    },
    {
        text: 'Ich lasse das Kind bei meinen Eltern.',
        stubs: [1, 4, 5],
        translations: {
            eng: 'I\'m leaving the kid with my parents.'
        },
        tags: [
            'lassen',
            'bei'
        ]
    },
    {
        text: 'Sie hat ihr Buch im Büro gelassen.',
        stubs: [1, 2, 4, 6],
        translations: {
            eng: 'She left her book at the office.'
        },
        tags: [
            'present-perfect',
            'active-voice',
            'lassen',
            'in',
            'haben'
        ]
    },
    {
        text: 'Wir lassen alles beim Alten.',
        stubs: [1, 3],
        translations: {
            eng: 'We\'re leaving everything as it was.'
        },
        tags: [
            'lassen',
            'bei',
            'all'
        ]
    },
    {
        text: 'Ich ließ er etwas anderes machen.',
        stubs: [1, 5],
        translations: {
            eng: 'I let him do something else.'
        },
        tags: [
            'lassen',
            'machen',
            'ander'
        ]
    },
    {
        text: 'Lassen Sie uns wissen, wie es Ihnen geht.',
        stubs: [0, 3, 4, 6, 7],
        translations: {
            eng: 'Let us know how you\'re doing.'
        },
        tags: [
            'lassen',
            'wissen',
            'gehen',
            'wie'
        ]
    },
    {
        text: 'Seine Antwort lässt mich glauben, dass er nichts verstanden hat.',
        stubs: [0, 2, 3, 4, 5, 8, 9],
        translations: {
            eng: 'His answer leads me to believe that he didn\'t understand anything.'
        },
        tags: [
            'lassen',
            'glauben',
            'dass',
            'verstehen',
            'ver-',
            '-stehen'
        ]
    },
    {
        text: 'Darf ich dich fragen, wie viel du berechnest?',
        stubs: [0, 2, 3, 4, 7],
        translations: {
            eng: 'May I ask how much you charge?'
        },
        tags: [
            'dürfen',
            'fragen',
            'berechnen',
            'be-',
            'wie'
        ]
    },
    {
        text: 'Tabakrauch enthält über 70 Stoffe, die erwiesenermaßen krebserregend sind.',
        stubs: [1, 2, 5, 6, 8],
        translations: {
            eng: 'Tobacco smoke contains over 70 substances that are evidently carcinogenic.'
        },
        tags: [
            'enthalten',
            'über',
            'sein',
            ', article'
        ]
    },
    // {
    //     text: 'Er wurde dort bekannt, als er die Drogengangs aus vielen Favelas der Stadt verdrängen ließ.',
    //     stubs: [1, 4, 8, 9, 11, 13, 14],
    //     translations: {
    //         eng: 'He became known there when he displaced the drug gangs out of many favelas in the city.'
    //     },
    //     tags: [
    //         'wurden',
    //         ', als',
    //         'verdrängen',
    //         'ver-',
    //         'aus',
    //         'lassen'
    //     ]
    // },
    {
        text: 'Viele Athleten machen sich ernste Sorgen wegen der Sicherheit während der Spiele.',
        stubs: [2, 3, 6, 7, 9, 10],
        translations: {
            eng: 'Many athletes are seriously concerned due to the security during the games.'
        },
        tags: [
            'machen',
            'reflexive',
            'wegen',
            'während'
        ]
    },
    {
        text: 'Das wusste er schon vor den Anschlägen, die sich in den Monaten davor in Europa ereignet hatten.',
        stubs: [1, 4, 5, 7, 8, 9, 10, 12, 13, 15, 16],
        translations: {
            eng: 'He already knew that before the attacks that have occurred in recent months in Europe.'
        },
        tags: [
            'wissen',
            'wussten',
            'ereignen',
            'vor',
            'davor',
            'in',
            'hatten',
            ', article'
        ]
    },
    {
        text: 'Deshalb bereiten sich die Verantwortlichen schon lange auf Anschläge vor.',
        stubs: [1, 2, 3, 7, 9],
        translations: {
            eng: 'Therefore, those in charge are already preparing themselves for attacks.'
        },
        tags: [
            'bereiten',
            'auf',
            'vor-',
            'vorbereiten',
            'reflexive'
        ]
    },
    {
        text: 'Manche Athleten glauben, dass es während der Olympischen Spiele gefährlich werden könnte.',
        stubs: [0, 2, 3, 5, 6, 10, 11],
        translations: {
            eng: 'Some athletes believe that, during the Olympics, it could become dangerous.'
        },
        tags: [
            'manch',
            'glauben',
            'dass',
            'während',
            'werden',
            'könnten',
            'können',
            'past-simple',
            'active-voice'
        ]
    },
    {
        text: 'Die schwierigste Aufgabe ist es, während der Spiele die Polizeigewalt zu verhindern.',
        stubs: [1, 5, 6, 8, 10, 11],
        translations: {
            eng: 'The most difficult task is to avoid police violence during the game.'
        },
        tags: [
            'adjective-nominative',
            'während',
            ', während',
            'verhindern',
            'ver-',
            'zu'
        ]
    },
    {
        text: 'Er will zeigen, dass Rio nicht so gefährlich ist, wie die Welt glaubt.',
        stubs: [1, 2, 3, 8, 9, 12],
        translations: {
            eng: 'He wants to demonstrate that Rio is not as dangerous as the world thinks.'
        },
        tags: [
            'wollen',
            'zeigen',
            'dass',
            'sind',
            'wie',
            'glauben'
        ]
    },
    {
        text: 'Seit den Anschlägen in Europa bereitet sich die Polizei auch auf Terrorismus vor.',
        stubs: [0, 1, 3, 5, 6, 10, 12],
        translations: {
            eng: 'Since the attacks in Europe, the police have also been preparing for terrorism.'
        },
        tags: [
            'seit',
            'vor-',
            '-bereiten',
            'vorbereiten',
            'in',
            'auf',
            'reflexive'
        ]
    },
    {
        text: 'Welche Wörter müssen in die Lücken eingesetzt werden?',
        stubs: [0, 2, 3, 4, 6, 7],
        translations: {
            eng: 'Which words need to be inserted in the gaps?'
        },
        tags: [
            'welch',
            'müssen',
            'in',
            'einsetzen',
            'ein-',
            '-setzen',
            'werden',
            'present-simple',
            'passive-voice'
        ]
    },
    {
        text: 'Das liegt daran, dass ich kein Französisch spreche.',
        stubs: [1, 2, 3, 5, 7],
        translations: {
            eng: 'This is due to the fact that I can\'t speak French.'
        },
        tags: [
            'liegen',
            'da-',
            'dass'
        ]
    },
    {
        text: 'Weißt du, wann die Gebäude dort gebaut wurden?',
        stubs: [0, 2, 6, 7],
        translations: {
            eng: 'Do you know when the buildings there were built?'
        },
        tags: [
            'wissen',
            'wann',
            ', wann',
            'bauen',
            'werden',
            'past-simple',
            'passive-voice'
        ]
    },
    {
        text: 'Die Bürokratie war sehr hoch, sodass ich die Entscheidung getroffen habe, in einer anderen Firma zu arbeiten.',
        stubs: [2, 5, 9, 10, 11, 12, 13, 15, 16],
        translations: {
            eng: 'The bureaucracy was very strong (literally: high), so I made the decision to work with another company.'
        },
        tags: [
            'war',
            ', sodass',
            'treffen',
            'haben',
            'in',
            'zu',
            'arbeiten',
            'vocab-walter',
            'ander'
        ]
    },
    {
        text: 'Gestern war mein letzter Arbeitstag bei meiner Firma.',
        stubs: [1, 2, 3, 5, 6],
        translations: {
            eng: 'Yesterday was my last day of work at my company.'
        },
        tags: [
            'war',
            'bei'
        ]
    },
    {
        text: 'Es war die größte Firma, bei der ich gearbeitet habe.',
        stubs: [1, 2, 3, 5, 6, 8, 9],
        translations: {
            eng: 'That was the largest company that I\'ve worked for.'
        },
        tags: [
            'war',
            'bei',
            ', bei',
            'haben'
        ]
    },
    {
        text: 'In meinen vorherigen Firmen hatte ich um die 15 Kollegen, aber in dieser letzten Firma hatte ich über 400.',
        stubs: [0, 1, 2, 4, 6, 7, 10, 11, 12, 13, 15, 17],
        translations: {
            eng: 'In my previous companies I had about 15 colleagues, but in this last company I had over 400.'
        },
        tags: [
            'in',
            'hatten',
            'vor-',
            'um',
            ', aber',
            'in',
            'dies'
        ]
    },
    {
        text: 'Da habe ich die Arbeit sehr träge gefunden, weil jede Entscheidung viele Kollegen gebraucht hat.',
        stubs: [7, 8, 9, 11, 13, 14],
        translations: {
            eng: 'There I found the work to be very slow because every decision required many colleagues.'
        },
        tags: [
            'finden',
            'weil',
            'brauchen',
            'haben',
            'jed'
        ]
    },
    {
        text: 'Meine neue Firma verkauft Möbel, was ich nicht interessant finde, aber ich finde die Arbeiter klug.',
        stubs: [0, 1, 5, 9, 10, 11, 13],
        translations: {
            eng: 'My new company sells furniture, which I don\'t find interesting, but I think the workers are smart.'
        },
        tags: [
            ', was',
            'finden',
            ', aber'
        ]
    },
    {
        text: 'Das hat mir sehr geholfen.',
        stubs: [1, 2, 4],
        translations: {
            eng: 'That helped me very much.'
        },
        tags: [
            'haben',
            'helfen',
            'vocab-walter'
        ]
    },
    {
        text: 'Es steht zwar im Text, aber er hat das nicht gesagt.',
        stubs: [1, 2, 3, 5, 7, 10],
        translations: {
            eng: 'That\'s indeed in the text, but he didn\'t say that.'
        },
        tags: [
            'stehen',
            'in',
            ', aber',
            'haben',
            'sagen'
        ]
    },
    {
        text: 'Es ist richtig, weil er für andere Veranstaltungen verantwortlich sein wird.',
        stubs: [3, 5, 6, 9, 10],
        translations: {
            eng: 'That\'s true because he will be in charge of other events.'
        },
        tags: [
            'weil',
            'für',
            'sein',
            'werden',
            'ander',
            'future-simple',
            'active-voice'
        ]
    },
    {
        text: 'Es ist falsch, weil er für andere Veranstaltungen verantwortlich war.',
        stubs: [3, 5, 6, 9],
        translations: {
            eng: 'That\'s false because he used to be (literally: was) in charge of other events.'
        },
        tags: [
            'weil',
            'für',
            'war',
            'ander'
        ]
    },
    {
        text: 'Wir haben die Chance zu zeigen, dass wir nicht nur die gefährliche Stadt sind, wie uns die Welt kennt.',
        stubs: [4, 5, 6, 10, 11, 13, 14, 15, 18],
        translations: {
            eng: 'We have the chance to show that we\'re not just the dangerous city that the world knows us as.'
        },
        tags: [
            'zu',
            'zeigen',
            'dass',
            ', wie',
            'kennen'
        ]
    },
    {
        text: 'Journalisten haben bei solchen Ereignissen eine schwierige Aufgabe.',
        stubs: [1, 2, 3, 5, 6],
        translations: {
            eng: 'Journalists have a difficult task in such incidents.'
        },
        tags: [
            'bei',
            'solch'
        ]
    },
    {
        text: 'Als in einem Einkaufszentrum in München Schüsse zu hören waren, wusste niemand, was passiert war.',
        stubs: [0, 1, 2, 4, 7, 8, 9, 10, 12, 14],
        translations: {
            eng: 'As shots were heard in a shopping center in Munich, no one knew what had happened.'
        },
        tags: [
            'als',
            'in',
            'zu',
            'hören',
            'waren',
            'war',
            ', was',
            'wussten'
        ]
    },
    {
        //     0       1   2       3    4  5       6    7        8   9   10             11   12      13       14   15     16     17   18     19  20             21 22      23     24
        text: 'Während die Polizei dort im Einsatz war, forderte sie die Öffentlichkeit über Twitter dringend auf: <Keine Videos oder Bilder von Polizeikräften im Einsatz online stellen. Helft nicht den Tätern!".',
        stubs: [0, 1, 4, 6],
        translations: {
            eng: 'While the police were deployed there, they strongly urged the public through Twitter: "Place no videos or images of the deployed police forces online. Do not help the perpetrators!"'
        },
        tags: [
            ', während',
            'definite-article-nominative',
            'in',
            'waren'
        ]
    },
    {
        //     0       1   2       3    4  5       6    7        8   9   10             11   12      13       14   15     16     17   18     19  20             21 22      23     24
        text: 'Während die Polizei dort im Einsatz war, forderte sie die Öffentlichkeit über Twitter dringend auf: <Keine Videos oder Bilder von Polizeikräften im Einsatz online stellen. Helft nicht den Tätern!".',
        stubs: [7, 8, 9, 11, 14],
        translations: {
            eng: 'While the police were deployed there, they strongly urged the public through Twitter: "Place no videos or images of the deployed police forces online. Do not help the perpetrators!"'
        },
        tags: [
            'auffordern',
            'auf-',
            '-fordern',
            'über',
            'definite-article-accusative'
        ]
    },
    {
        //     0       1   2       3    4  5       6    7        8   9   10             11   12      13       14   15     16     17   18     19  20             21 22      23     24
        text: 'Während die Polizei dort im Einsatz war, forderte sie die Öffentlichkeit über Twitter dringend auf: <Keine Videos oder Bilder von Polizeikräften im Einsatz online stellen. Helft nicht den Tätern!".',
        stubs: [19, 21, 24, 25, 27],
        translations: {
            eng: 'While the police were deployed there, they strongly urged the public through Twitter: "Place no videos or images of the deployed police forces online. Do not help the perpetrators!"'
        },
        tags: [
            'über',
            'von',
            'in',
            'stellen',
            'helfen',
            'definite-article-dative'
        ]
    },
    {
        text: 'Lernen erfordert ständige Wiederholung.',
        stubs: [1, 3],
        translations: {
            eng: 'Learning requires constant repetition.'
        },
        tags: [
            'erfordern',
            'er-',
            '-fordern',
            'wiederholen',
            'wieder-',
            '-holen'
        ]
    },
    {
        text: 'Sowohl Bürger als auch Medien stellten weiter Bilder ins Internet oder sendeten sie live.',
        stubs: [0, 2, 5, 8, 11, 12],
        translations: {
            eng: 'Both citizens and also the media continued to place images on the Internet or to broadcast them live.'
        },
        tags: [
            'sowohl als',
            'stellen',
            'senden',
            'in'
        ]
    },
    {
        text: 'Besonders die Medien stehen bei solchen Ereignissen wie in München unter gewaltigem Druck.',
        stubs: [3, 4, 5, 7, 8, 10, 11],
        translations: {
            eng: 'In particular, the media is, in such incidents as in Munich, under huge pressure.'
        },
        tags: [
            'stehen',
            'solch',
            'bei',
            'wie',
            'in',
            'unter'
        ]
    },
    {
        text: 'Erst später stellte sich heraus, dass es der Amoklauf eines einzelnen Täters gewesen war.',
        stubs: [2, 3, 4, 5, 9, 10, 12, 13],
        translations: {
            eng: 'Not until later did it turn out that it had been the rampage of a single perpetrator.'
        },
        tags: [
            'herausstellen',
            'heraus-',
            '-stellen',
            'dass',
            ', dass',
            'gewesen',
            'war',
            'past-simple',
            'active-voice'
        ]
    },
    {
        //     0   1            2     3  4  5     6         7   8        9    10  11   12       13            14 15        16      17    18       19
        text: 'Die Journalisten haben in so einer Situation das Problem, dass sie ihre Aufgabe, Informationen zu besorgen, einfach nicht erfüllen können.',
        stubs: [0, 2, 3, 4, 5, 7],
        translations: {
            eng: 'The journalists have, in such a situation, the problem that they simply can\'t fulfill their duty to obtain information.'
        },
        tags: [
            'definite-article-nominative',
            'in',
            'indefinite-article-dative',
            'wo?',
            'definite-article-accusative'
        ]
    },
    {
        //     0   1            2     3  4  5     6         7   8        9    10  11   12       13            14 15        16      17    18       19
        text: 'Die Journalisten haben in so einer Situation das Problem, dass sie ihre Aufgabe, Informationen zu besorgen, einfach nicht erfüllen können.',
        stubs: [9, 10, 11, 14, 15, 18, 19],
        translations: {
            eng: 'The journalists have, in such a situation, the problem that they simply can\'t fulfill their duty to obtain information.'
        },
        tags: [
            ', dass',
            'pronoun-dative',
            'zu',
            'zu verb',
            ', adverb',
            'besorgen',
            'be-',
            '-sorgen',
            'erfüllen',
            'er-',
            '-füllen',
            'können'
        ]
    },
    {
        //     0     1      2     3   4   5          6     7         8             9      10 11      12    13  14    15   16  17  18
        text: 'Unter diesem Druck ist die Versuchung groß, besonders sensationelle Bilder zu zeigen: etwas vom Täter oder von den Opfern.',
        stubs: [0, 1, 3, 4, 8, 10, 11],
        translations: {
            eng: 'Under this pressure, the temptation is great to show especially sensational images: something from the perpetrator or the victims.'
        },
        tags: [
            'unter',
            'dies',
            'zu',
            'zu verb',
            'zeigen'
        ]
    },
    {
        //     0     1      2     3   4   5          6     7         8             9      10 11      12    13  14    15   16  17  18
        text: 'Unter diesem Druck ist die Versuchung groß, besonders sensationelle Bilder zu zeigen: etwas vom Täter oder von den Opfern.',
        stubs: [13, 16, 17],
        translations: {
            eng: 'Under this pressure, the temptation is great to show especially sensational images: something from the perpetrator or the victims.'
        },
        tags: [
            'von',
            'definite-article-dative'
        ]
    },
    {
        text: 'Die Medien müssen berichten, wenn sie eine Chance gegen die Konkurrenz haben wollen.',
        stubs: [2, 3, 4, 5, 6, 8, 9, 11, 12],
        translations: {
            eng: 'The media must report if they want to have a chance against the competition.'
        },
        tags: [
            'müssen',
            'berichten',
            'wenn',
            ', wenn',
            'gegen',
            'haben',
            'wollen'
        ]
    },
    {
        text: 'Journalisten können oft einfach keine neue Informationen besorgen.',
        stubs: [1, 4, 5, 7],
        translations: {
            eng: 'Journalists often simply can\'t obtain new information.'
        },
        tags: [
            'können',
            'besorgen'
        ]
    },
    {
        text: 'Wenn sie nicht wissen, was passiert ist, können sie nur spekulieren.',
        stubs: [0, 3, 4, 5, 6, 7, 10],
        translations: {
            eng: 'If they don\'t know what has happened, they can only speculate.'
        },
        tags: [
            'wenn',
            ', wenn',
            'wissen',
            'passieren',
            ', was',
            'haben',
            'können',
            'spekulieren'
        ]
    },
    {
        //     0   1      2      3   4  5           6        7        8     9    10  11   12    13   14  15       16         17
        text: 'Sie denken alles, was in Deutschland passiert betrifft mich, weil sie sich nicht über die deutsche Geographie auskennen.',
        stubs: [1, 2, 3, 4, 6, 7, 8],
        translations: {
            eng: 'They think everything which occurs in Germany applies to me because they don\'t know about German geography.'
        },
        tags: [
            'denken',
            'all',
            ', was',
            'in',
            'wo?',
            'passieren',
            'betreffen',
            'pronoun-accusative'
        ]
    },
    {
        //     0   1      2      3   4  5           6        7        8     9    10  11   12    13   14  15       16         17
        text: 'Sie denken alles, was in Deutschland passiert betrifft mich, weil sie sich nicht über die deutsche Geographie auskennen.',
        stubs: [9, 10, 11, 13, 14, 15, 17],
        translations: {
            eng: 'They think everything which occurs in Germany applies to me because they don\'t know about German geography.'
        },
        tags: [
            ', weil',
            'reflexive',
            'über',
            'adjective-accusative',
            'auskennen',
            'aus-',
            '-kennen'
        ]
    },
    {
        text: 'Jetzt kann ich über meine Familie lästern.',
        stubs: [1, 3, 4, 6],
        translations: {
            eng: 'Now I can gossip about my family.'
        },
        tags: [
            'können',
            'über',
            'lästern'
        ]
    },
    {
        text: 'Es ist falsch, weil es nicht die Aufgabe der Polizei ist.',
        stubs: [3, 8, 10],
        translations: {
            eng: 'That\'s false because that\'s not the duty of the police.'
        },
        tags: [
            'weil',
            ', weil',
            'definite-article-genitive'
        ]
    },
    {
        text: 'Ich gehe nach Hause, damit ich nicht nass werde.',
        stubs: [1, 2, 4, 8],
        translations: {
            eng: 'I\'m going home in order to not become wet.'
        },
        tags: [
            'gehen',
            'nach',
            ', damit',
            'werden',
            'present-simple',
            'active-voice'
        ]
    },
    {
        text: 'Ich gehe nach Hause, weil ich nicht nass werden möchte.',
        stubs: [1, 2, 4, 8, 9],
        translations: {
            eng: 'I\'m going home because I wouldn\'t like to get wet.'
        },
        tags: [
            'gehen',
            'nach',
            'weil',
            ', weil',
            'möchten',
            'present-simple',
            'active-voice'
        ]
    },
    {
        text: 'Im Artikel steht, dass Journalisten oft nur spekulieren können.',
        stubs: [0, 2, 3, 7, 8],
        translations: {
            eng: 'The article states that journalists can often only speculate.'
        },
        tags: [
            'in',
            'stehen',
            ', dass',
            'spekulieren',
            'können'
        ]
    },
    {
        text: 'Der Kaffee ist getrunken worden.',
        stubs: [0, 3, 4],
        translations: {
            eng: 'The coffee has been drunk.'
        },
        tags: [
            'worden',
            'present-perfect',
            'passive-voice'
        ]
    },
    {
        text: 'Die Berichterstattung während des Amoklaufs in München wurde stark kritisiert.',
        stubs: [2, 3, 5, 7, 9],
        translations: {
            eng: 'The news coverage during the rampage in Munich has been heavily criticized.'
        },
        tags: [
            'in',
            'wurden',
            'past-simple',
            'passive-voice',
            'kritisieren'
        ]
    },
    {
        text: 'Mein Opa hat seine Brille verlegt.',
        stubs: [0, 2, 3, 5],
        translations: {
            eng: 'My grandpa misplaced his glasses.'
        },
        tags: [
            'ver-',
            'verlegen',
            'present-perfect',
            'active-voice'
        ]
    },
    {
        text: 'Wann stehst du normalerweise auf?',
        stubs: [0, 1, 4],
        translations: {
            eng: 'When do you normally get up?'
        },
        tags: [
            'auf-',
            '-stehen',
            'aufstehen',
            'present-simple',
            'active-voice'
        ]
    },
    {
        text: 'Ich habe dort meine Tante besucht.',
        stubs: [0, 1, 3, 5],
        translations: {
            eng: 'I was visiting my aunt there.'
        },
        tags: [
            'haben',
            'be-',
            '-suchen',
            'besuchen',
            'present-perfect',
            'active-voice'
        ]
    },
    {
        text: 'Gestern habe ich mich erkältet.',
        stubs: [1, 3, 4],
        translations: {
            eng: 'Yesterday I caught a cold'
        },
        tags: [
            'haben',
            'er-',
            '-kälten',
            'erkälten',
            'reflexive',
            'present-perfect',
            'active-voice'
        ]
    },
    {
        text: 'Wen wollt ihr zur Party einladen?',
        stubs: [0, 1, 2, 3, 5],
        translations: {
            eng: 'Who do you (plural) want to invite to the party?'
        },
        tags: [
            'wen',
            'wollen',
            'ihr',
            'zu',
            'ein-',
            '-laden',
            'einladen',
            'present-simple',
            'active-voice'
        ]
    },
    {
        text: 'Leider muss ich mit meinem Yogakurs aufhören.',
        stubs: [1, 3, 4, 6],
        translations: {
            eng: 'Unfortunately I have to quit my yoga class.'
        },
        tags: [
            'müssen',
            'mit',
            'auf-',
            '-hören',
            'aufhören',
            'present-simple',
            'active-voice'
        ]
    },
    {
        //     0         1        2   3     4  5   6       7   8      9  10           11     12 13           14   15 16  17   18      19 20
        text: 'Politiker benutzen sie auch, um die Meinung des Volkes in umstrittenen Fragen zu beeinflussen oder um für sich Werbung zu machen.',
        stubs: [1, 4, 7, 9, 12, 13],
        translations: {
            eng: 'Politicians also make use of them in order to influence the public\'s opinion in controversial issues or in order to advertise themselves.'
        },
        tags: [
            'be-',
            '-nutzen',
            'nutzen',
            ', um zu',
            'definite-article-genitive',
            'in',
            'be-',
            'ein-',
            '-flussen',
            'beeinflussen'
        ]
    },
    {
        //     0         1        2   3     4  5   6       7   8      9  10           11     12 13           14   15 16  17   18      19 20
        text: 'Politiker benutzen sie auch, um die Meinung des Volkes in umstrittenen Fragen zu beeinflussen oder um für sich Werbung zu machen.',
        stubs: [15, 16, 17, 19, 20],
        translations: {
            eng: 'Politicians also make use of them in order to influence the public\'s opinion in controversial issues or in order to advertise themselves.'
        },
        tags: [
            ',um zu',
            'für',
            'machen'
        ]
    },
    {
        text: 'Sie können auch konstruktiv gebraucht werden.',
        stubs: [1, 4, 5],
        translations: {
            eng: 'They can also be used constructively.'
        },
        tags: [
            'können',
            'gebraucht',
            'werden',
            'passive-voice',
            'active-voice'
        ]
    },
    {
        text: 'Der Bot sucht und findet zum Beispiel User, die über Korruption klagen. Und dann fragt der Bot die User, wie wir Korruption bekämpfen können.',
        stubs: [0, 2, 4, 8, 9, 11, 14, 15, 17, 19, 22, 23],
        translations: {
            eng: 'The bot searches and finds, for example, users who complain about corruption. And then, the bot asks the users how we can fight corruption.'
        },
        tags: [
            'suchen',
            'finden',
            'über',
            'klagen',
            'fragen',
            'be-',
            '-kämpfen',
            'bekämpfen',
            ', wie',
            ', article'
        ]
    },
    {
        text: 'Sie ist sich sicher, dass solche Aktivistenbots in Zukunft sehr erfolgreich sein werden.',
        stubs: [1, 2, 4, 5, 7, 11, 12],
        translations: {
            eng: 'She is certain that such activist-bots, in the future, will be very successful.'
        },
        tags: [
            ', dass',
            'in',
            'werden',
            'solch',
            'future-simple',
            'active-voice'
        ]
    },
    {
        text: 'Er erzählt seinen Kindern eine Geschichte.',
        stubs: [1, 2, 4],
        translations: {
            eng: 'He\'s telling his children a story.'
        },
        tags: [
            'er-',
            '-zählen',
            'erzählen',
            'dative'
        ]
    },
    {
        text: 'Sie schreibt mir eine E-mail.',
        stubs: [1, 2, 3],
        translations: {
            eng: 'She\'s writing me an email.'
        },
        tags: [
            'schreiben',
            'dative'
        ]
    },
    {
        text: 'Er erklärte seiner Frau, warum er ihr ganzes Geld auf dieses Pferd setzte.',
        stubs: [1, 2, 4, 5, 6, 7, 9, 10, 12],
        translations: {
            eng: 'He explained to his wife why he put all her money on this horse.'
        },
        tags: [
            'er-',
            'erklären',
            ', warum',
            'auf',
            'setzen',
            'dies'
        ]
    },
    {
        text: 'Was schenken Sie Ihrem Vater zum Geburtstag?',
        stubs: [1, 3, 5],
        translations: {
            eng: 'What are you (formal) gifting your (formal) father for his birthday?'
        },
        tags: [
            'schenken',
            'zu',
            'dative'
        ]
    },
    {
        text: 'Kannst du das der Polizei beweisen?',
        stubs: [0, 3, 5],
        translations: {
            eng: 'Can you prove that to the police?'
        },
        tags: [
            'können',
            'be-',
            '-weisen',
            'beweisen',
            'dative'
        ]
    },
    {
        text: 'Sie glaubt meine Antwort nicht.',
        stubs: [1, 2],
        translations: {
            eng: 'She doesn\'t believe my answer.'
        },
        tags: [
            'glauben',
            'accusative'
        ]
    },
    {
        text: 'Sie glaubt mir nicht.',
        stubs: [1, 2],
        translations: {
            eng: 'She doesn\'t believe me.'
        },
        tags: [
            'glauben',
            'dative'
        ]
    },
    {
        text: 'Kannst du mir verzeihen?',
        stubs: [0, 2, 3],
        translations: {
            eng: 'Can you forgive me?'
        },
        tags: [
            'können',
            'ver-',
            '-zeihen',
            'verzeihen',
            'dative'
        ]
    },
    {
        text: 'Es gibt ein paar Möglichkeiten, wie man einen Bot identifizieren kann.',
        stubs: [5, 7, 9, 10],
        translations: {
            eng: 'There are a few ways that one can identify a bot.',
        },
        tags: [
            ', wie',
            'identifizieren',
            'können'
        ]
    },
    {
        text: 'Es kann passieren, dass Bots die Beliebtheit eines Politikers größer erscheinen lassen.',
        stubs: [2, 3, 5, 7, 9, 10, 11],
        translations: {
            eng: 'It\'s possible (literally: it can occur) for bots to make (literally: to let) the popularity of a politician appear larger.'
        },
        tags: [
            'können',
            'passieren',
            ', dass',
            'genitive',
            'er-',
            '-scheinen',
            'erscheinen',
            'lassen'
        ]
    },
    // {
    //     text: 'Bots sind für Politiker nützlich, um bei Wahlen Stimmen sammeln zu können.',
    //     stubs: [2, 4, 5, 6, 9, 10, 11],
    //     translations: {
    //         eng: 'Bots are useful for politicians in order to gather votes in elections.'
    //     }
    // },
    {
        text: 'Die Frage ist, ob in Zukunft nur die Parteien mit den besseren Bots gewinnen werden.',
        stubs: [3, 4, 7, 9, 10, 11, 13, 14],
        translations: {
            eng: 'The question is whether, in the future, only the parties with the better bots will win.',
        },
        tags: [
            ', ob',
            'ob',
            'mit',
            'gewinnen',
            'werden',
            'future-simple',
            'active-voice'
        ]
    },
    {
        text: 'Bots sind gefährlich, weil sie Diskussionen im Internet stark beeinflussen können.',
        stubs: [3, 4, 6, 9, 10],
        translations: {
            eng: 'Bots are dangerous because they can strongly influence discussions on the internet.'
        },
        tags: [
            ', weil',
            'weil',
            'in',
            'be-',
            'ein-',
            'beeinflussen',
            'können'
        ]
    },
    {
        text: 'Sie stellt das Glas auf den Tisch.',
        stubs: [1, 2, 4, 5],
        translations: {
            eng: 'She is placing (upright) the glass on the table.'
        },
        tags: [
            'stellen',
            'auf'
        ]
    },
    {
        text: 'Das Glas steht auf dem Tisch.',
        stubs: [0, 2, 3, 4],
        translations: {
            eng: 'The glass is (upright) on the table.'
        },
        tags: [
            'stehen',
            'auf'
        ]
    },
    {
        text: 'Ich lege die Gabel auf den Tisch.',
        stubs: [1, 2, 4, 5],
        translations: {
            eng: 'I\'m placing (horizontally) the fork on the table'
        },
        tags: [
            'legen',
            'auf'
        ]
    },
    {
        text: 'Die Gabel liegt auf dem Tisch.',
        stubs: [0, 2, 3, 4],
        translations: {
            eng: 'The fork is lying on the table.'
        },
        tags: [
            'liegen',
            'auf'
        ]
    },
    {
        text: 'Ich hänge den Spiegel an die Wand.',
        stubs: [1, 2, 4, 5],
        translations: {
            eng: 'I\'m hanging the mirror on the wall.'
        },
        tags: [
            'hängen',
            'an',
            'accusative'
        ]
    },
    {
        text: 'Der Spiegel hängt an der Wand.',
        stubs: [2, 3, 4],
        translations: {
            eng: 'The mirror is hanging on the wall.'
        },
        tags: [
            'hängen',
            'an',
            'dative'
        ]
    },
    {
        text: 'Sie ist sauer auf er, denn er hat ihr etwas verheimlicht.',
        stubs: [3, 4, 5, 6, 7, 8, 10],
        translations: {
            eng: 'She is mad at him because he had kept a secret from her.'
        },
        tags: [
            'accusative',
            'pronoun-accusative',
            'pronoun-dative',
            'auf',
            'ver-',
            '-heimlichen',
            'verheimlichen',
            ', denn'
        ]
    },
    {
        text: 'Er hat ihr nicht erzählt, dass sie seine Ex-Freundin ist.',
        stubs: [2, 4, 5, 7, 9],
        translations: {
            eng: 'He hadn\'t told her that she is his ex-girlfriend.'
        },
        tags: [
            'pronoun-dative',
            'er-',
            '-zählen',
            'erzählen',
            ', dass'
        ]
    },
    {
        text: 'Es gibt etwas, das er ihr nicht gesagt hat.',
        stubs: [3, 4, 5, 7, 8],
        translations: {
            eng: 'There is something that he hasn\'t told her'
        },
        tags: [
            'pronoun-dative',
            'sagen',
            ', article'
        ]
    },
    {
        text: 'Ihr Vater hat sie als Fotografin für das Projekt empfohlen!',
        stubs: [0, 3, 4, 6, 7, 9],
        translations: {
            eng: 'Her father has recommended her as the photographer for the project.'
        },
        tags: [
            'accusative',
            'pronoun-accusative',
            'für',
            'als',
            'empfohlen',
            'emp-',
            '-fohlen'
        ]
    },
    {
        text: 'Die anderen wissen nicht, dass sie seine Tochter ist. Und sie möchte es ihnen auf keinen Fall erzählen.',
        stubs: [1, 2, 4, 5, 6, 13, 14, 15, 17],
        translations: {
            eng: 'The others don\'t know that she is his daughter. And she doesn\'t want to tell them on any account.'
        },
        tags: [
            'pronoun-dative',
            ', dass',
            'auf',
            'er-',
            '-zählen',
            'erzählen',
            'ander'
        ]
    },
    {
        text: 'Sie hat ihm nicht gesagt, dass sie schwanger ist.',
        stubs: [2, 4, 5, 8],
        translations: {
            eng: 'She hasn\'t said to him that she\'s pregnant.'
        },
        tags: [
            'sagen',
            'pronoun',
            'pronoun-dative',
            ', dass'
        ]
    },
    {
        text: 'Es tut ihm leid, dass er nicht gleich für sie da war.',
        stubs: [2, 4, 8, 9, 11],
        translations: {
            eng: 'He\'s sorry that he wasn\'t there for her sooner.'
        },
        tags: [
            ', dass',
            'pronoun',
            'pronoun-dative',
            'für',
            'war',
            'gleich'
        ]
    },
    {
        text: 'Sie werden nie die Woche vergessen, die sie krank im Bett verbracht haben.',
        stubs: [1, 5, 6, 7, 9, 11],
        translations: {
            eng: 'They\'ll never forget the week they spent sick in bed.',
        },
        tags: [
            'werden',
            'ver-',
            '-gessen',
            'vergessen',
            ', article',
            'in',
            '-bringen',
            'verbringen',
            'future-simple',
            'active-voice',
            'present-perfect'
        ]
    },
    {
        text: 'Sie hat sich verliebt: in jemanden, den sie noch nie gesehen hat.',
        stubs: [1, 2, 3, 4, 5, 6, 10, 11],
        translations: {
            eng: 'She has fallen in love with someone that she has never seen.'
        },
        tags: [
            'reflexive',
            'ver-',
            '-lieben',
            'verlieben',
            'in',
            ', article',
            'sehen'
        ]
    },
    {
        text: 'Können Sie vielleicht auch ein Foto von mir machen?',
        stubs: [4, 6, 7, 8],
        translations: {
            eng: "Can you (formal) take a picture of me?"
        },
        tags: [
            'von',
            'pronoun-dative',
            'machen'
        ]
    },
    {
        text: 'Sie ist gerade in Köln angekommen und findet die Stadt sehr schön.',
        stubs: [3, 5, 7, 8],
        translations: {
            eng: 'She has just arrived in Cologne and found the city very nice.'
        },
        tags: [
            'in',
            'an-',
            '-kommen',
            'ankommen',
            'finden'
        ]
    },
    {
        text: 'Hier merkt sie, dass in Deutschland nicht alle Leute freundlich sind.',
        stubs: [3, 4, 7, 10],
        translations: {
            eng: 'Here she takes note that in Germany not all people are friendly.'
        },
        tags: [
            'merken',
            ', dass',
            'in',
            'all'
        ]
    },
    {
        text: 'Aber sie ist froh, dass ihr Geld nicht weg ist.',
        stubs: [0, 1, 2, 4, 5, 8, 9],
        translations: {
            eng: 'But she\'s happy that her money isn\'t gone.'
        },
        tags: [
            ', dass',
            ', aber'
        ]
    },
    {
        text: 'Danach nimmt sie ein Taxi, weil sie eine Verabredung hat.',
        stubs: [0, 1, 3, 5, 7, 9],
        translations: {
            eng: 'After that, she takes a taxi because she has an appointment.'
        },
        tags: [
            'da-',
            'nehmen',
            ', weil'
        ]
    },
    {
        text: 'Auch der Taxifahrer muss um fünf zu Hause sein.',
        stubs: [3, 4, 6, 8],
        translations: {
            eng: 'The taxi-driver also needs to be home in five.'
        },
        tags: [
            'müssen',
            'um',
            'zu',
            'sein'
        ]
    },
    {
        text: 'Wir haben den Zug genommen.',
        stubs: [1, 2, 4],
        translations: {
            eng: 'We took the train.',
            spa: 'Hemos tomado el tren.'
        },
        tags: [
            'nehmen',
            'present-perfect',
            'active-voice',
            'haben'
        ]
    },
    {
        text: 'Jemand hat das Geld gefunden.',
        stubs: [0, 1, 4],
        translations: {
            eng: 'Someone found the money.',
            spa: 'Alguien ha encontrado el dinero.'
        },
        tags: [
            'jemand',
            'present-perfect',
            'active-voice',
            'finden',
            'haben'
        ]
    },
    {
        text: 'Niemand hat mir geholfen.',
        stubs: [1, 3],
        translations: {
            eng: 'Noone helped me.',
            spa: 'Nadie me ha ayudado'
        },
        tags: [
            'niemand',
            'haben',
            'present-perfect',
            'active-voice',
            'helfen'
        ]
    },
    {
        text: 'Das Wetter ist besser geworden.',
        stubs: [2, 4],
        translations: {
            eng: 'The weather\'s improved (literally: has become better).',
            spa: 'El clima ha mejorado.'
        },
        tags: [
            'sein',
            'present-perfect',
            'active-voice',
            'geworden'
        ]
    },
    {
        text: 'Er ist zu Hause geblieben.',
        stubs: [1, 2, 4],
        translations: {
            eng: 'He has stayed at home.'
        },
        tags: [
            'sein',
            'present-perfect',
            'active-voice',
            'bleiben'
        ]
    },
    {
        text: 'Es ist immer so gewesen.',
        stubs: [1, 4],
        translations: {
            eng: 'It has always been so.'
        },
        tags: [
            'sein',
            'present-perfect',
            'active-voice',
            'gewesen'
        ]
    },
    {
        text: 'Der Mann ist mir nach Hause gefolgt.',
        stubs: [2, 3, 4, 6],
        translations: {
            eng: 'The man has followed me home.'
        },
        tags: [
            'sein',
            'pronoun-dative',
            'nach',
            'folgen',
            'present-perfect',
            'active-voice'
        ]
    },
    {
        text: 'Wir sind nach Madrid geflogen.',
        stubs: [1, 2, 4],
        translations: {
            eng: 'We have flown to Madrid.'
        },
        tags: [
            'sein',
            'nach',
            'present-perfect',
            'active-voice'
        ]
    },
    {
        text: 'Der Pilot hat das Flugzeug allein geflogen.',
        stubs: [2, 6],
        translations: {
            eng: 'The pilot has flown the plane alone.'
        },
        tags: [
            'haben',
            'fliegen',
            'present-perfect',
            'active-voice'
        ]
    },
    {
        text: 'Ich habe mir den Film angesehen.',
        stubs: [1, 2, 3, 5],
        translations: {
            eng: 'I watched the Film.',
            spa: 'He visto la pelicula.'
        },
        tags: [
            'reflexive',
            'haben',
            'active-voice',
            'present-perfect',
            'an-',
            '-sehen',
            'ansehen'
        ]
    },
    {
        text: 'Sie haben die Kinder nicht mitgenommen.',
        stubs: [1, 2, 5],
        translations: {
            eng: 'They haven\'t taken the kids with them.'
        },
        tags: [
            'haben',
            'active-voice',
            'present-perfect',
            'mit-',
            '-nehmen',
            'mitnehmen'
        ]
    },
    {
        text: 'Er hat einfach weitergeschrieben.',
        stubs: [1, 3],
        translations: {
            eng: 'He has simply continued writing.',
            spa: 'Él simplemente ha continuado escribiendo.'
        },
        tags: [
            'haben',
            'weiter-',
            '-schreiben',
            'weiterschreiben',
            'active-voice',
            'present-perfect'
        ]
    },
    {
        text: 'Wir haben den Brief gestern bekommen.',
        stubs: [1, 2, 5],
        translations: {
            eng: 'We received the letter yesterday.',
            spa: 'Recibimos la carta ayer.'
        },
        tags: [
            'haben',
            'present-perfect',
            'active-voice',
            'be-',
            '-kommen',
            'bekommen'
        ]
    },
    {
        text: 'Wir haben uns lange unterhalten.',
        stubs: [1, 4],
        translations: {
            eng: 'We talked for a long time.',
            spa: 'Hemos conversado durante mocho tiempo.'
        },
        tags: [
            'reflexive',
            'haben',
            'unter-',
            '-halten',
            'unterhalten',
            'present-perfect',
            'active-voice'
        ]
    },
    {
        text: 'Der Artzt hat mir das Rauchen verboten.',
        stubs: [2, 3, 6],
        translations: {
            eng: 'The doctor has forbidden me from smoking.',
            spa: 'El médico me ha prohibido fumar.'
        },
        tags: [
            'haben',
            'verbieten',
            'ver-',
            '-bieten',
            'present-perfect',
            'active-voice'

        ]
    },
    {
        text: 'Am Wochenende sind wir in die Berge gefahren.',
        stubs: [0, 2, 4, 5, 7],
        translations: {
            eng: 'On the weekend we went to the mountains.',
            spa: 'Durante el fin de semana hemos ido a la montaña.'

        },
        tags: [
            'an',
            'sein',
            'present-perfect',
            'active-voice',
            'in',
            'fahren'
        ]
    },
    {
        text: 'Der Zug ist mit Verspätung abgefahren.',
        stubs: [2, 3, 5],
        translations: {
            eng: 'The train departed behind schedule.',
            spa: 'El tren ha salido con retraso.'
        },
        tags: [
            'sein',
            'present-perfect',
            'active-voice',
            'mit',
            'ab-',
            '-fahren',
            'abfahren'
        ]
    },
    {
        text: 'Der Zug ist mit einer Verspätung abgefahren.',
        stubs: [2, 3, 4, 6],
        translations: {
            eng: 'The train departed with a delay.'
        },
        tags: [
            'sein',
            'present-perfect',
            'active-voice',
            'mit',
            'ab-',
            '-fahren',
            'abfahren'
        ]
    },
    {
        text: 'Heute sind nicht viele Schüler gekommen.',
        stubs: [1, 3, 5],
        translations: {
            eng: 'Today not many schoolkids have come.',
            spa: 'Hoy no han venido muchos alumnos.'

        },
        tags: [
            'sein',
            'present-perfect',
            'active-voice',
            'kommen'
        ]
    },
    {
        text: 'Die Kinder sind nicht mitgekommen.',
        stubs: [2, 4],
        translations: {
            eng: 'The kids didn\'t come along.',
            spa: 'Los niños no han venido.'
        },
        tags: [
            'sein',
            'present-perfect',
            'active-voice',
            'mit-',
            '-kommen',
            'mitkommen'
        ]
    },
    {
        text: 'Wir sind um den ganzen See gelaufen.',
        stubs: [1, 2, 3, 4, 6],
        translations: {
            eng: 'We ran around the entire lake.',
            spa: 'Hemos corrido alrededor de todo el lago.'
        },
        tags: [
            'sein',
            'um',
            'laufen',
            'present-perfect',
            'active-voice'
        ]
    },
    {
        text: 'Oma ist die Treppe hinuntergefallen.',
        stubs: [1, 2, 4],
        translations: {
            eng: 'Grandma has fallen down the stairs.'
        },
        tags: [
            'sein',
            'present-perfect',
            'active-voice',
            'hin-',
            'unter-',
            'fallen',
            'hinunterfallen'
        ]
    },
    {
        text: 'Gestern sind wir ins Theater gegangen.',
        stubs: [1, 2, 3, 5],
        translations: {
            eng: 'Yesterday we went to the theater.',
            spa: 'Ayer fuimos al teatro.'
        },
        tags: [
            'sein',
            'in',
            'gehen',
            'active-voice',
            'present-perfect'
        ]
    },
    {
        text: 'Er ist um 6 Uhr aufgewacht.',
        stubs: [1, 2, 5],
        translations: {
            eng: 'He woke up at 6 am.',
            spa: 'Él se ha despertado a las 6.'
        },
        tags: [
            'sein',
            'um',
            'auf-',
            '-wachen',
            'aufwachen',
            'active-voice',
            'present-perfect'
        ]
    },
    {
        text: 'Wir sind ihm im Park begegnet.',
        stubs: [1, 2, 3, 5],
        translations: {
            eng: 'We came across him at the park.',
            spa: 'Le hemos encontrado (casualmente) en el parque.'
        },
        tags: [
            'sein',
            'present-perfect',
            'active-voice',
            'in',
            'pronoun-dative',
            'begegnen',
            'wo?'
        ]
    },
    {
        text: 'Die Gruppe ist nach Buenos Aires geflogen.',
        stubs: [2, 3, 6],
        translations: {
            eng: 'The group flew to Buenos Aires.',
            spa: 'El grupo ha volado a Buenos Aires.'
        },
        tags: [
            'sein',
            'present-perfect',
            'active-voice',
            'fliegen',
            'nach'
        ]
    },
    {
        text: 'Früher sind wir gern gereist.',
        stubs: [1, 4],
        translations: {
            eng: 'We used to enjoy traveling.',
            spa: 'Antes nos gustaba mucho viajar.'
        },
        tags: [
            'sein',
            'reisen',
            'active-voice',
            'present-perfect'
        ]
    },
    {
        text: 'Ich bin um 3 Uhr eingeschlafen.',
        stubs: [1, 2, 5],
        translations: {
            eng: 'I fell asleep at 3 am.'
        },
        tags: [
            'sein',
            'active-voice',
            'present-perfect',
            'ein-',
            '-schlafen',
            'einschlafen',
            'um'
        ]
    },
    {
        text: 'Wir sind um 11 Uhr aufgewacht.',
        stubs: [1, 2, 5],
        translations: {
            eng: 'We woke up at 11 a.m.'
        },
        tags: [
            'auf-',
            '-wachen',
            'aufwachen',
            'sein',
            'present-perfect',
            'active-voice',
            'um'
        ]
    },
    {
        text: 'Das Unkraut ist schnell gewachsen.',
        stubs: [2, 4],
        translations: {
            eng: 'The weed has grown quickly.'
        },
        tags: [
            'sein',
            'wachsen',
            'present-perfect',
            'active-voice'
        ]
    },
    {
        text: 'Fast jeder Nutzer eines sozialen Netzwerkes begegnet irgendwann Bots – das sind Programme, die ohne menschliche Hilfe funktionieren.',
        stubs: [1, 3, 4, 6, 7, 10, 13, 15, 17],
        translations: {
            eng: 'Almost every user of a social network eventually encounters bots - which are programs that work without human assistance.'
        },
        tags: [
            'jed',
            'begegnen',
            'irgend-',
            ', article',
            'funktionieren'
        ]
    },
    {
        text: 'Meist werden sie für Werbung genutzt, doch mittlerweile sind Bots auch bei Politikern beliebt.',
        stubs: [1, 3, 5, 6, 7, 11, 13],
        translations: {
            eng: 'Most are used for advertisement, but by now Bots are also favored by politicians.'
        },
        tags: [
            'werden',
            'für',
            'nutzen',
            'present-perfect',
            'passive-voice',
            'bei',
            ', doch'
        ]
    },
    {
        text: 'Wenn ein User in deinem Netzwerk tausende Follower zu haben scheint, aber selbst nur einer Person folgt, dann ist es wahrscheinlich ein Bot.',
        stubs: [0, 1, 3, 4, 8, 9, 10, 11, 14, 16, 17, 18, 19, 21],
        translations: {
            eng: 'If a user in your network appears to have thousands of followers, but it only follows one person, then it is probably a bot.'
        },
        tags: [
            ', wenn',
            'in',
            'zu',
            'haben',
            'scheinen',
            ', aber',
            'folgen',
            ', dann'
        ]
    },
    {
        text: 'Automatisierte Accounts können als Follower die Unterstützung eines Politikers höher erscheinen lassen, als sie tatsächlich ist.',
        stubs: [0, 2, 3, 5, 7, 9, 10, 11, 12, 13, 15],
        translations: {
            eng: 'Automated accounts can, as a follower, make the support of a politician appear larger (literally: higher) than it really is.'
        },
        tags: [
            'können',
            'als',
            ', als',
            'comparative-adj',
            'er-',
            '-scheinen',
            'erscheinen'
        ]
    },
    {
        text: 'Es gibt aber einige Hinweise, mit denen man sie identifizieren kann.',
        stubs: [2, 3, 5, 6, 8, 9, 10],
        translations: {
            eng: 'But there are some clues with which one can identify them.'
        },
        tags: [
            'aber',
            ', preposition',
            'identifizieren',
            'können'
        ]
    },
    {
        text: 'Sie nutzt sie, um die Bürger politisch zu mobilisieren.',
        stubs: [1, 3, 4, 7, 8],
        translations: {
            eng: 'She uses them in order to politically mobilize citizens.'
        },
        tags: [
            'nutzen',
            ', preposition',
            'mobilisieren',
            'um zu'
        ]
    },
    {
        text: 'Bots benutzt man nicht nur in der Werbung, sondern auch in der Politik.',
        stubs: [1, 5, 6, 8, 10, 11],
        translations: {
            eng: 'Bots are used not only in advertisement but also in politics.'
        },
        tags: [
            'be-',
            '-nutzen',
            'benutzen',
            'in',
            ', sondern'
        ]
    },
    // {
    //     text: 'Wird in Zukunft etwa nur noch der Politiker mit den besten Bots gewählt?',
    //     stubs: [0, 1, 6, 8, 9, 10, 11],
    //     translations: {
    //         eng: 'In the future will, for instance, only the politicians with the best bots be elected?'
    //     },
    //     tags: [
    //         'werden',
    //         'in',
    //         'mit',
    //         'wählen',
    //         'present-perfect'
    //     ]
    // },
    {
        text: 'Manche Wissenschaftler glauben nicht, dass man mit den automatisierten Accounts die Meinung des Volkes verändern kann.',
        stubs: [0, 2, 4, 6, 7, 8, 10, 12, 14, 15],
        translations: {
            eng: 'Some scientists don\'t believe that one can alter, with the automated accounts, the opinion of the public.'
        },
        tags: [
            'glauben',
            ', dass',
            'mit',
            'verändern',
            'ver-',
            '-ändern',
            'können',
            'manch'
        ]
    },
    {
        text: 'Aber die Bots können die Debatte über ein Thema behindern oder die Aussagen der gegnerischen Partei kritisieren.',
        stubs: [0, 1, 3, 4, 6, 7, 9, 11, 13, 14, 16],
        translations: {
            eng: 'But the bots can impede the debate of an issue or can criticize the statements of the opposing party.'
        },
        tags: [
            'aber',
            'können',
            'über',
            'be-',
            '-hindern',
            'behindern',
            'kritisieren'
        ]
    },
    {
        text: 'Trotzdem kann der Gebrauch von Bots auch konstruktiv sein.',
        stubs: [0, 1, 2, 4, 7, 8],
        translations: {
            eng: 'Nevertheless, the purpose of bots can also be constructive.'
        },
        tags: [
            'können',
            'von',
            ', trotzdem'
        ]
    },
    {
        text: 'Die Sonne schien, aber trotzdem war es kalt.',
        stubs: [3, 4, 5, 6, 7],
        translations: {
            eng: 'The sun had shone, but nevertheless it was cold.'
        },
        tags: [
            'scheinen',
            ', aber',
            'trotzdem'
        ]
    },
    {
        text: 'Sie will die User und Userinnen mit den Aktivistenbots mobilisieren.',
        stubs: [1, 2, 6, 7, 9],
        translations: {
            eng: 'She wants to mobilize the male and female users with the activist-bots.'
        },
        tags: [
            'wollen',
            'mit',
            'mobilisieren'
        ]
    },
    {
        text: 'Dieser Bot hat ihn sehr bekannt gemacht.',
        stubs: [0, 2, 3, 6],
        translations: {
            eng: 'This bot has made him very popular.'
        },
        tags: [
            'haben',
            'present-perfect',
            'active-voice',
            'machen',
            'pronoun-accusative'
        ]
    },
    {
        text: 'Es ist ein Hinweis um Bots zu erkennen.',
        stubs: [2, 4, 6, 7],
        translations: {
            eng: 'It\'s a clue so as to recognize bots.'
        },
        tags: [
            'um zu',
            'er-',
            '-kennen',
            'erkennen'
        ]
    },
    {
        text: 'Ich bin nicht sicher, ob er es gesagt hat.',
        stubs: [4, 5, 6, 7, 8],
        translations: {
            eng: 'I\'m not sure whether he said that.',
        },
        tags: [
            ', ob',
            'present-perfect',
            'active-voice',
            'sagen'
        ]
    },
    {
        text: 'Wir haben keinen Bot identifizieren können, der die öffentliche Meinung in einer bestimmten Frage in eine besondere Richtung drehen konnte.',
        stubs: [1, 2, 4, 5, 6, 7, 8, 10, 11, 12, 14, 15, 16, 18, 19],
        translations: {
            eng: 'We haven\'t been able to identify a bot that could turn the public opinion of a specific issue in a particular direction.',
        },
        tags: [
            'können',
            'double-infinitive',
            ', article',
            'in',
            'drehen',
            'könnten'
        ]
    },
    {
        text: 'Das ist richtig, weil es im Text steht, dass er es gesagt hat.',
        stubs: [3, 4, 5, 7, 8, 9, 10, 11, 12],
        translations: {
            eng: 'That is correct because it states in the text that he said that.'
        },
        tags: [
            ', weil',
            'in',
            ', dass',
            'sagen',
            'present-perfect',
            'active-voice'
        ]
    },
    {
        text: 'Ich habe den Grund genannt, warum es falsch ist.',
        stubs: [1, 2, 4, 5, 6, 8],
        translations: {
            eng: 'I mentioned the reason why it\'s wrong.'
        },
        tags: [
            ', warum',
            'present-perfect',
            'active-voice',
            'nennen'
        ]
    },
    // {
    //     text: 'Sie möchte mit diesen Bots die Leute politisch mobilisieren, und sie anregen, dass sie mehr über Korruption sprechen.',
    //     stubs: [],
    //     translations: {
    //         eng: 'She would like to politically mobilize the people with these bots and make them '
    //     }
    // },
    {
        text: 'Es ist falsch, weil sie nichts darüber gesagt hat.',
        stubs: [3, 6, 7, 8],
        translations: {
            eng: 'It\'s false because she didn\'t say anything about that.'
        },
        tags: [
            ', weil',
            'da-',
            'sagen',
            'active-voice',
            'present-perfect'
        ]
    },
    {
        text: 'Ich habe das Backblech mit Margarine eingefettet.',
        stubs: [1, 2, 4, 6],
        translations: {
            eng: 'I have greased the baking tray with margarine.'
        },
        tags: [
            'mit',
            'einfetten',
            'ein-',
            '-fetten',
            'active-voice',
            'present-perfect'
        ]
    },
    {
        text: 'Sie müssen zwei Teigblätter mit vorbereitete Sauce befeuchten und auf Backblech schichten.',
        stubs: [4, 5, 7, 9, 11],
        translations: {
            eng: 'You (formal) must moisten two sheets of dough with prepared sauce and layer them on the baking sheet.'
        },
        tags: [
            'mit',
            'vor-',
            '-bereiten',
            'vorbereiten',
            'be-',
            'befeuchten',
            'auf',
            'schichten'
        ]
    },
    {
        text: 'Die vorbereitete Füllung über die Teigblätter verteilen.',
        stubs: [1, 3, 4, 6],
        translations: {
            eng: 'Spread the prepared filling on the dough sheets.'
        },
        tags: [
            'vor-',
            '-bereiten',
            'vorbereiten',
            'über',
            'verteilen',
            'ver-',
            '-teilen',
            'verteilen'
        ]
    },
    {
        text: 'Sie sucht die Wohnung, in der sie ein Zimmer gemietet hat.',
        stubs: [4, 5, 6, 7, 9, 10],
        translations: {
            eng: 'She\'s searching for the flat in which she has rented a room.'
        },
        tags: [
            'suchen',
            'in',
            'mieten',
            'active-voice',
            'present-perfect'
        ]
    },
    {
        text: 'Er hat sich vor Kurzem von seiner Freundin getrennt.',
        stubs: [1, 2, 3, 5, 6, 8],
        translations: {
            eng: 'He has recently broken up with his girlfriend.'
        },
        tags: [
            'reflexive',
            'present-perfect',
            'active-voice',
            'vor',
            'von',
            'trennen'
        ]
    },
    {
        text: 'Am Ende darf er bleiben, weil sie dringend Geld brauchen, um die Miete zu bezahlen.',
        stubs: [0, 2, 4, 5, 9, 10, 13, 14],
        translations: {
            eng: 'By the end he\'s allowed to stay because they desperately need the money in order to pay the rent.'
        },
        tags: [
            'dürfen',
            'bleiben',
            ', weil',
            'brauchen',
            'um zu',
            ' be-',
            '-zahlen',
            'bezahlen',
            'am'
        ]
    },
    {
        text: 'Achte auf die Szenen, die in den Bildern dargestellt sind.',
        stubs: [0, 1, 2, 4, 5, 6, 8, 9],
        translations: {
            eng: 'Pay attention to the scenes that are depicted in the images.'
        },
        tags: [
            'achten',
            'auf',
            'in',
            ', article',
            'dar-',
            '-stellen',
            'darstellen',
            'present-perfect',
            'active-voice'
        ]
    },
    {
        text: 'Lese die Sätze und wähle die richtigen Begriffe aus.',
        stubs: [0, 1, 4, 5, 6, 8],
        translations: {
            eng: 'Read the sentences and pick out the correct terms.'
        },
        tags: [
            'lesen',
            '-wählen',
            'aus-',
            'auswählen'
        ]
    },
    {
        text: 'Das Wichtigste ist, nicht die Geduld zu verlieren.',
        stubs: [0, 2, 4, 6, 7],
        translations: {
            eng: 'The most important thing is not to lose patience.'
        },
        tags: [
            'zu',
            'ver-',
            '-lieren',
            'verlieren'
        ]
    },
    {
        text: 'Viele Ausländer verbringen in den ersten Wochen in Deutschland viel Zeit, Formulare auszufüllen.',
        stubs: [0, 2, 3, 4, 5, 7, 12],
        translations: {
            eng: 'Many foreigners spend a lot of time during their first weeks in Germany filling out forms.'
        },
        tags: [
            'ver-',
            '-bringen',
            'verbringen',
            'in',
            'aus-',
            'zu-',
            'auszu-',
            '-füllen',
            'auszufüllen'
        ]
    },
    {
        text: 'Sie stehen vor dem Restaurant und reden.',
        stubs: [1, 2, 3, 6],
        translations: {
            eng: 'They are standing in front of the restuarant and talking.'
        },
        tags: [
            'stehen',
            'vor',
            'reden'
        ]
    },
    {
        text: 'Der Umweg hat sich ja gelohnt.',
        stubs: [2, 3, 4, 5],
        translations: {
            eng: 'The detour was indeed worth it.'
        },
        tags: [
            'lohnen',
            'active-voice',
            'present-perfect',
            'active-voice',
            'ja'
        ]
    },
    {
        text: 'Sie reden darüber, wer den Einkauf macht.',
        stubs: [1, 2, 3, 4, 6],
        translations: {
            eng: 'They are talking about who will do the shopping.'
        },
        tags: [
            'reden',
            'darüber',
            'wer',
            'machen'
        ]
    },
    {
        text: 'Er legt viel Wert auf gesunde Ernährung.',
        stubs: [1, 4, 5],
        translations: {
            eng: 'He places much importance on healthy eating.'
        },
        tags: [
            '-legen',
            'auf-',
            'auflegen'
        ]
    },
    {
        text: 'Wer durchfällt, muss sein Glück an einer anderen Hochschule versuchen oder sich einen anderen Studiengang suchen.',
        stubs: [0, 1, 2, 5, 6, 7, 9, 11, 12, 13, 15],
        translations: {
            eng: 'Who fails must try their luck at another university or find another degree program.'
        },
        tags: [
            'wer',
            'durch-',
            '-fallen',
            'durchfallen',
            'müssen',
            'an',
            'ver-',
            '-suchen',
            'versuchen',
            'reflexive',
            'suchen',
            'ander'
        ]
    },
    {
        text: 'Es wurde vor drei Jahren von Freds Onkel erbaut, der Architekt ist.',
        stubs: [1, 2, 5, 8, 9, 11],
        translations: {
            eng: 'It was built three years ago by Fred\'s uncle, who\'s an architect.'
        },
        tags: [
            'wurden',
            'von',
            'vor',
            'past-simple',
            'passive-voice',
            ', article'
        ]
    },
    {
        text: 'Besonders an den Wochenenden übernachten viele Touristen aus verschiedenen Ländern in dem Hotel.',
        stubs: [1, 2, 4, 5, 7, 8, 10, 11],
        translations: {
            eng: 'Especially on weekends, many tourists from different countries stay at the hotel.'
        },
        tags: [
            'über-',
            '-nachten',
            'übernachten',
            'an',
            'aus',
            'ver-',
            '-schieden',
            'verschieden',
            'in'
        ]
    },
    {
        text: 'Das Hotel befindet sich außerhalb des Stadtzentrums, aber die Touristen können mit dem Bus in die Stadt fahren.',
        stubs: [2, 3, 4, 5, 7, 8, 10, 11, 12, 14, 15, 17],
        translations: {
            eng: 'The hotel is located outside the city center but the tourists can ride with the bus into the city.'
        },
        tags: [
            'be-',
            '-finden',
            'befinden',
            'außerhalb',
            'reflexive',
            'genitive',
            ', aber',
            'können',
            'mit',
            'in',
            'fahren',
            'present-simple',
            'active-voice'
        ]
    },
    {
        text: 'Die Bushaltestelle ist auf der anderen Seite der Straße, also müssen die Touristen erst über die Straße gehen.',
        stubs: [3, 4, 5, 7, 9, 10, 11, 14, 15, 17],
        translations: {
            eng: 'The bus stop is on the other side of the street, so the tourists first have to go across the road.'
        },
        tags: [
            'auf',
            'genitive',
            ', also',
            'müssen',
            'über',
            'gehen',
            'ander'
        ]
    },
    {
        text: 'Aber außerhalb der Wochenenden nutzt fast niemand diesen Bus, außer Fred, der oft zu seiner Bibliothek fährt.',
        stubs: [0, 1, 2, 4, 7, 9, 11, 13, 14, 16],
        translations: {
            eng: 'But apart from weekends, almost no one uses this bus except for Fred, who often goes (literally: rides) to his library.'
        },
        tags: [
            ', aber',
            'außerhalb',
            'außer',
            ', article',
            'zu',
            'fahren',
            'dies'
        ]
    },
    {
        text: 'Am Wochenende fahren wir in die Berge.',
        stubs: [0, 2, 4, 5],
        translations: {
            eng: 'On the weekend we\'re going to the mountains.'
        },
        tags: [
            'an',
            'in',
            'fahren'
        ]
    },
    {
        text: 'Am Wochenende werden wir in die Berge fahren.',
        stubs: [0, 2, 4, 5, 7],
        translations: {
            eng: 'On the weekend we\'ll go (literally: ride) to the mountains.'
        },
        tags: [
            'an',
            'in',
            'werden',
            'future-simple',
            'active-voice',
            'fahren'
        ]
    },
    {
        text: 'Du wirst die Prüfung nicht bestehen.',
        stubs: [1, 5],
        translations: {
            eng: 'You won\'t pass the exam.'
        },
        tags: [
            'werden',
            'be-',
            '-stehen',
            'future-simple',
            'active-voice',
            'bestehen'
        ]
    },
    {
        text: 'Morgen wird es noch kälter werden.',
        stubs: [1, 2, 3, 4, 5],
        translations: {
            eng: 'Tomorrow it\'ll be even colder.'
        },
        tags: [
            'werden',
            'noch',
            'comparison',
            'future-simple',
            'active-voice'
        ]
    },
    {
        text: 'Ich werde dir das Buch morgen zurückgeben.',
        stubs: [1, 2, 3, 6],
        translations: {
            eng: 'I\'ll give you back the book tomorrow.'
        },
        tags: [
            'pronoun-dative',
            'werden',
            'zurückgeben',
            'zurück-',
            'future-simple',
            'active-voice',
            '-geben'
        ]
    },
    {
        text: 'Wenn du dich nicht beeilst, wirst du den Zug verpassen.',
        stubs: [0, 2, 4, 5, 7, 9],
        translations: {
            eng: 'If you don\'t hurry, you\'ll miss the train.'
        },
        tags: [
            'wenn',
            'reflexive',
            'be-',
            '-eilen',
            'beeilen',
            'werden',
            'ver-',
            '-passen',
            'future-simple',
            'verpassen'
        ]
    },
    {
        text: 'Die Kinder werden wohl schon zu Hause sein.',
        stubs: [2, 5, 7],
        translations: {
            eng: 'The children will probably already be home.'
        },
        tags: [
            'future-simple',
            'active-voice',
            'werden',
            'zu',
            'sein'
        ]
    },
    {
        text: 'Der Student wird operiert werden.',
        stubs: [2, 3, 4],
        translations: {
            eng: 'The student will be operated.'
        },
        tags: [
            'future-simple',
            'passive-voice',
            'werden',
            'operieren'
        ]
    },
    {
        text: 'Sie ging zur Schule, nachdem sie gefrühstückt hatte.',
        stubs: [1, 2, 4, 6, 7],
        translations: {
            eng: 'She went to school after she had had breakfast.'
        },
        tags: [
            'past-perfect',
            'active-voice',
            ', nachdem',
            'frühstücken',
            'hatten',
            'zu',
            'gehen'
        ]
    },
    {
        text: 'Ich kann ihm nicht verzeihen.',
        stubs: [1, 2, 4],
        translations: {
            eng: 'I can\'t forgive him.'
        },
        tags: [
            'present-simple',
            'active-voice',
            'können',
            'verzeihen',
            'ver-',
            '-zeihen',
            'pronoun-dative'
        ]
    },
    {
        text: 'Dein Hemd gefällt mir.',
        stubs: [2, 3],
        translations: {
            eng: 'I like your shirt.'
        },
        tags: [
            'present-simple',
            'active-voice',
            'gefallen',
            'pronoun-dative'
        ]
    },
    {
        text: 'Ich bedarf deiner Hilfe.',
        stubs: [1, 2],
        translations: {
            eng: 'I require your help.'
        },
        tags: [
            'bedürfen',
            'be-',
            '-dürfen',
            'pronoun-genitive',
            'present-simple',
            'active-voice'
        ]
    },
    {
        text: 'Sie schämen sich ihres Irrtums.',
        stubs: [1, 2, 3, 4],
        translations: {
            eng: 'They are ashamed of their error.'
        },
        tags: [
            'schämen',
            'reflexive',
            'pronoun-genitive',
            'present-simple',
            'active-voice'
        ]
    },
    {
        text: 'Er wird viel Arbeit gehabt haben.',
        stubs: [1, 4, 5],
        translations: {
            eng: 'He will have had a lot of work.'
        },
        tags: [
            'werden',
            'haben',
            'future-perfect',
            'active-voice'
        ]
    },
    {
        text: 'Sie wird in Urlaub gewesen sein.',
        stubs: [1, 2, 4, 5],
        translations: {
            eng: 'She will have been on vacation.'
        },
        tags: [
            'werden',
            'in',
            'gewesen',
            'sein',
            'future-perfect',
            'active-voice'
        ]
    },
    {
        text: 'Wenn du zurückkommst, werde ich die Koffer gepackt haben.',
        stubs: [0, 2, 3, 5, 7, 8],
        translations: {
            eng: 'When you come back, I will have packed the bags.'
        },
        tags: [
            ', wenn',
            'werden',
            ', werden',
            'future-perfect',
            'active-voice',
            'packen',
            'zurückkommen',
            'zurück-',
            '-kommen'
        ]
    },
    {
        text: 'Bevor wir nach Hause kommen, werden sie alles aufgegessen haben.',
        stubs: [0, 2, 4, 5, 7, 8, 9],
        translations: {
            eng: 'Before we arrive at home they will have eaten everything up.'
        },
        tags: [
            ', bevor',
            'nach',
            'kommen',
            'werden',
            'auf-',
            '-essen',
            'aufessen',
            'haben',
            'future-perfect',
            'active-voice',
            'all'
        ]
    },
    {
        text: 'Sie wird schon weggegangen sein.',
        stubs: [1, 2, 3, 4],
        translations: {
            eng: 'She will have already gone away.'
        },
        tags: [
            'werden',
            'schon',
            'weg-',
            '-gehen',
            'weggehen',
            'sein',
            'active-voice',
            'future-perfect'
        ]
    },
    {
        text: 'Werden Sie das gemacht haben, bevor wir Sie abholen?',
        stubs: [0, 3, 4, 5, 8],
        translations: {
            eng: 'Will you (formal) have done that before we pick you up?'
        },
        tags: [
            'werden',
            'machen',
            'haben',
            ', bevor',
            'ab-',
            '-holen',
            'abholen',
            'active-voice',
            'future-perfect'
        ]
    },
    {
        text: 'Er wird das wohl gewusst haben.',
        stubs: [1, 4, 5],
        translations: {
            eng: 'He will probably have known that.'
        },
        tags: [
            'werden',
            'wissen',
            'haben',
            'active-voice',
            'future-perfect'
        ]
    },
    {
        text: 'Ich werde das Spiel gespielt haben.',
        stubs: [1, 4, 5],
        translations: {
            eng: 'I will have played the game.'
        },
        tags: [
            'active-voice',
            'future-perfect',
            'werden',
            'spielen',
            'haben'
        ]
    },
    {
        text: 'Das Spiel wird von mir gespielt worden sein.',
        stubs: [2, 3, 4, 5, 6, 7],
        translations: {
            eng: 'The game will have been played by me.'
        },
        tags: [
            'werden',
            'von',
            'pronoun-dative',
            'spielen',
            'worden',
            'sein',
            'passive-voice',
            'future-perfect'
        ]
    },
    {
        text: 'Wer rastet der rostet.',
        stubs: [0, 1, 2, 3],
        translations: {
            eng: 'Who rests, rusts.'
        },
        tags: [
            'wer',
            'rasten',
            'rosten'
        ]
    },
    {
        text: 'Wem kaufst du den Computer?',
        stubs: [0, 1, 3],
        translations: {
            eng: 'For whom are you buying the computer?'
        },
        tags: [
            'wem',
            'kaufen'
        ]
    },
    {
        text: 'Wen hast du gesehen?',
        stubs: [0, 1, 3],
        translations: {
            eng: 'Who have you seen?'
        },
        tags: [
            'wen',
            'active-voice',
            'present-perfect',
            'sehen'
        ]
    },
    {
        text: 'Wer kommt morgen zur Party?',
        stubs: [0, 1, 3],
        translations: {
            eng: 'Who\'s comming tomorrow to the party?'
        },
        tags: [
            'wer',
            'kommen',
            'zu'
        ]
    },
    {
        text: 'Wen hast du eingeladen?',
        stubs: [0, 1, 3],
        translations: {
            eng: 'Who have you invited?'
        },
        tags: [
            'wen',
            'active-voice',
            'present-perfect',
            'ein-',
            'laden',
            'einladen'
        ]
    },
    {
        text: 'Wem hast du das Buch gegeben?',
        stubs: [0, 1, 3, 5],
        translations: {
            eng: 'To whom have you given the book?'
        },
        tags: [
            'wem',
            'active-voice',
            'present-perfect',
            'geben'
        ]
    },
    {
        text: 'Die Rechnungen müssen noch bezahlt werden.',
        stubs: [2, 3, 4, 5],
        translations: {
            eng: 'The invoices still need to be paid.'
        },
        tags: [
            'müssen',
            'noch',
            'be-',
            '-zahlen',
            'bezahlen',
            'werden',
            'passive-voice'
        ]
    },
    {
        text: 'Das Auto kann nicht mehr reparieren werden.',
        stubs: [2, 5, 6],
        translations: {
            eng: 'The car can\'t be repaired anymore.'
        },
        tags: [
            'passive-voice',
            'reparieren',
            'können',
            'werden'
        ]
    },
    {
        text: 'Der Koffer kann nicht abgeschlossen werden.',
        stubs: [2, 4, 5],
        translations: {
            eng: 'The suitcase can\'t be opened.'
        },
        tags: [
            'können',
            'ab-',
            '-schließen',
            'abschließen',
            'werden',
            'passive-voice'
        ]
    },
    {
        text: 'Das Angebot kann nicht akzeptiert werden.',
        stubs: [2, 4, 5],
        translations: {
            eng: 'The offer can\'t be accepted.'
        },
        tags: [
            'passive-voice',
            'werden',
            'können',
            'akzeptieren'
        ]
    },
    {
        text: 'Die Bank war gestern nicht geöffnet.',
        stubs: [2, 5],
        translations: {
            eng: 'The bank was not open yesterday.'
        },
        tags: [
            'passive-voice',
            'war'
        ]
    },
    {
        text: 'Ich wollte nicht gestört werden.',
        stubs: [1, 3, 4],
        translations: {
            eng: 'I didn\'t want to be bothered.'
        },
        tags: [
            'wollten',
            'stören',
            'werden',
            'passive-voice',
            'present-perfect'
        ]
    },
    {
        text: 'Das Spiel ist um 8 Uhr gewesen.',
        stubs: [2, 3, 6],
        translations: {
            eng: 'The game has been at 8 a.m.'
        },
        tags: [
            'sein',
            'present-perfect',
            'active-voice',
            'um'
        ]
    },
    {
        text: 'Das Spiel war um 8 Uhr.',
        stubs: [2, 3],
        translations: {
            eng: 'The game was at 8 a.m.'
        },
        tags: [
            'war',
            'um',
            'past-simple',
            'active-voice'
        ]
    },
    {
        text: 'Ich habe gesagt, dass ich nicht gestört werden wollte.',
        stubs: [1, 2, 3, 6, 7, 8],
        translations: {
            eng: 'I said that I didn\'t want to be bothered.'
        },
        tags: [
            ', dass',
            'present-perfect',
            'active-voice',
            'passive-voice',
            'preterite',
            'stören',
            'werden',
            'wollten'
        ]
    },
    {
        text: 'Andere Flüsse fließen ins Landesinnere, wo sie dann verdunsten.',
        stubs: [0, 2, 3, 5, 7, 8],
        translations: {
            eng: 'Other rivers flow inland, where they then evaporate.'
        },
        tags: [
            'fließen',
            'in',
            'dann',
            ', wo',
            'verdunsten',
            'ver-',
            'ander',
            '-dunsten'
        ]
    },
    {
        text: 'Das Wasser der Donau versickert teilweise und taucht an anderer Stelle wieder auf.',
        stubs: [4, 7, 8, 9, 12],
        translations: {
            eng: 'The water of the Danube partly drains out and then reemerges in another location.'
        },
        tags: [
            'ver-',
            '-sickern',
            '-tauchen',
            'auf-',
            'auftauchen',
            'wieder',
            'an',
            'ander'
        ]
    },
    {
        //     0    1    2     3        4    5          6   7     8       9        10  11  12     13  14
        text: 'Hier geht jedes Elektron eine Verbindung mit einem anderen Teilchen ein und bildet ein Molekül.',
        stubs: [0, 1, 2, 4, 6, 7, 8, 10],
        translations: {
            eng: 'Here, every electron enters a bond with another particle and creates a molecule.'
        },
        tags: [
            'jed',
            'ver-',
            'mit',
            'indefinite-article-dative',
            'ander',
            'ein-',
            '-gehen',
            'eingehen'
        ]
    },
    {
        //     0    1    2     3        4    5          6   7     8       9        10  11  12     13  14
        text: 'Hier geht jedes Elektron eine Verbindung mit einem anderen Teilchen ein und bildet ein Molekül.',
        stubs: [12, 13],
        translations: {
            eng: 'Here, every electron enters a bond with another particle and creates a molecule.'
        },
        tags: [
            'bilden',
            'indefinite-article-accusative'
        ]
    },
    {
        text: 'Dazwischen entstehen Hohlräume, die das für uns sichtbare Licht ungehindert durchdringen kann.',
        stubs: [0, 1, 3, 4, 5, 7, 9, 10, 11],
        translations: {
            eng: 'Cavities form in between, where light that\'s visible to us can penetrate unhindered.'
        },
        tags: [
            'dazwischen',
            'ent-',
            '-stehen',
            'entstehen',
            ', article',
            'für',
            'un-',
            '-hindern',
            'unhindern',
            'durch-',
            '-dringen',
            'durchdringen',
            'können'
        ]
    },
    {
        text: 'Du wirst beobachtet.',
        stubs: [1, 2],
        translations: {
            eng: 'You are being observed.'
        },
        tags: [
            'werden',
            'beobachten',
            'passive-voice',
            'passive-present'
        ]
    },
    {
        text: 'Das Auto wird abgeschleppt.',
        stubs: [2, 3],
        translations: {
            eng: 'The car is being towed away.'
        },
        tags: [
            'werden',
            'ab-',
            '-schleppen',
            'abschleppen',
            'passive-voice',
            'passive-present'
        ]
    },
    {
        text: 'Der Diebstahl wird angezeigt.',
        stubs: [2, 3],
        translations: {
            eng: 'The burglary is being reported.'
        },
        tags: [
            'werden',
            'an-',
            '-zeigen',
            'anzeigen',
            'passive-voice',
            'passive-present'
        ]
    },
    {
        text: 'Du wurdest gesehen.',
        stubs: [1, 2],
        translations: {
            eng: 'You were seen.'
        },
        tags: [
            'wurden',
            'sehen',
            'passive-voice',
            'preterite'
        ]
    },
    {
        text: 'Ein Fehler wurde begangen.',
        stubs: [2, 3],
        translations: {
            eng: 'A mistake was committed.'
        },
        tags: [
            'wurden',
            'be-',
            '-gehen',
            'begehen',
            'passive-voice',
            'preterite'
        ]
    },
    {
        text: 'Rom wurde nicht an einem Tag erbaut.',
        stubs: [1, 3, 4, 6],
        translations: {
            eng: 'Rome wasn\'t built in one day.'
        },
        tags: [
            'wurden',
            'an',
            'er-',
            '-bauen',
            'erbauen',
            'passive-voice',
            'preterite'
        ]
    },
    {
        text: 'Er las ein Buch.',
        stubs: [1],
        translations: {
            eng: 'He read a book.'
        },
        tags: [
            'lesen',
            'active-voice',
            'preterite',
            'past-simple'
        ]
    },
    {
        text: 'Ein Buch wurde von ihm gelesen.',
        stubs: [2, 3, 4, 5],
        translations: {
            eng: 'A book was read by him.'
        },
        tags: [
            'lesen',
            'wurden',
            'von',
            'pronoun-dative',
            'passive-voice',
            'preterite',
            'past-simple'
        ]
    },
    {
        text: 'Ich hatte ein Buch gelesen.',
        stubs: [1, 4],
        translations: {
            eng: 'I had read a book.'
        },
        tags: [
            'hatten',
            'preterite',
            'active-voice',
            'past-perfect'
        ]
    },
    {
        text: 'Im letzten Jahr machte ich Urlaub in Deutschland.',
        stubs: [0, 1, 3, 6],
        translations: {
            eng: 'In the last year I took a vacation (literally: made vacation)  in Germany.'
        },
        tags: [
            'in',
            'machten',
            'preterite',
            'past-simple',
            'active-voice'
        ]
    },
    {
        text: 'Im letzten Jahr habe ich Urlaub in Deutschland gemacht.',
        stubs: [0, 1, 3, 6, 8],
        translations: {
            eng: 'In the last year I had taken a (literally: had made) vacation in Germany.'
        },
        tags: [
            'in',
            'machen',
            'present-perfect',
            'active-voice'
        ]
    },
    {
        text: 'Die Strecke war fantastisch.',
        stubs: [2],
        translations: {
            eng: 'The route was fantastic.'
        },
        tags: [
            'waren',
            'preterite',
            'past-simple',
            'active-voice'
        ]
    },
    {
        text: 'Ich hatte den ganzen Tag gearbeitet.',
        stubs: [1, 2, 3, 5],
        translations: {
            eng: 'I had worked all day.'
        },
        tags: [
            'hatten',
            'preterite',
            'active-voice',
            'arbeiten',
            'past-perfect'
        ]
    },
    {
        text: 'Nachdem sie aufgestanden war, hat sie gefrühstückt.',
        stubs: [0, 2, 3, 4, 6],
        translations: {
            eng: 'After she had gotten up, she had breakfast.'
        },
        tags: [
            'nachdem',
            'auf-',
            '-stehen',
            'aufstehen',
            'frühstücken',
            'preterite',
            'active-voice',
            'past-perfect'
        ]
    },
    {
        text: 'Ich musste geküsst werden.',
        stubs: [1, 2, 3],
        translations: {
            eng: 'I had to be kissed.'
        },
        tags: [
            'preterite',
            'past-simple',
            'passive-voice',
            'küssen',
            'mussten',
            'werden'
        ]
    },
    {
        text: 'Er kann die Fragen nicht beantworten.',
        stubs: [1, 2, 5],
        translations: {
            eng: 'He can\'t answer the questions.',
        },
        tags: [
            'können',
            'be-',
            '-antworten',
            'beantworten',
            'active-voice'
        ]
    },
    {
        text: 'Die Fragen können von ihm nicht beantwortet werden.',
        stubs: [2, 3, 4, 6, 7],
        translations: {
            eng: 'The questions can\'t be answered by him.'
        },
        tags: [
            'können',
            'von',
            'pronoun-dative',
            'be-',
            '-antworten',
            'beantworten',
            'passive-voice',
            'werden'
        ]
    },
    {
        text: 'Unsere Freunde konnten das Haus günstig kaufen.',
        stubs: [2, 3, 6],
        translations: {
            eng: 'Our friends could buy the house on good terms.'
        },
        tags: [
            'unser',
            'konnten',
            'kaufen',
            'active-voice'
        ]
    },
    {
        text: 'Das Haus konnte von unseren Freunden günstig gekauft werden.',
        stubs: [2, 3, 4, 7, 8],
        translations: {
            eng: 'The house could be bought on good terms by our friends.'
        },
        tags: [
            'konnten',
            'von',
            'unser',
            'kaufen',
            'werden',
            'passive-voice',
            'preterite'
        ]
    },
    {
        text: 'Ich muss die Rechnung bezahlen.',
        stubs: [1, 4],
        translations: {
            eng: 'I need to pay the bill.'
        },
        tags: [
            'müssen',
            'bezahlen',
            'be-',
            '-zahlen',
            'active-voice'
        ]
    },
    {
        text: 'Ich hätte dich abholen können, wenn ich es gewusst hätte.',
        stubs: [1, 2, 3, 4, 5, 8, 9],
        translations: {
            eng: 'I couldv\'e picked you up if I wouldv\'e known.'
        },
        tags: [
            'hätten',
            'ab-',
            '-holen',
            'abholen',
            'können',
            ', wenn'
        ]
    },
    {
        text: 'Nein, natürlich nur wegen des Studiums.',
        stubs: [3, 4],
        translations: {
            eng: 'No, of course only because of the studies.'
        },
        tags: [
            'wegen',
            'genitive'
        ]
    },
    {
        text: 'Ich habe keine Lust, das immer alleine zu machen.',
        stubs: [4, 7, 8],
        translations: {
            eng: 'I have no desire to always do that alone.'
        },
        tags: [
            'haben',
            ', article',
            'zu',
            'machen'
        ]
    },
    {
        text: 'Im sozialen Netzwerken im Internet kann man leicht Menschen mit gleichen Interessen finden.',
        stubs: [0, 1, 3, 5, 9, 10, 12],
        translations: {
            eng: 'In social networks on the internet, one can easily find people with similar interests.'
        },
        tags: [
            'in',
            'mit',
            'finden',
            'können'
        ]
    },
    {
        text: 'Sie ist unglücklich, obwohl sie die Aufnahmeprüfung bestanden hat.',
        stubs: [3, 7, 8],
        translations: {
            eng: 'She is unhappy though she passed the entrance exam.'
        },
        tags: [
            ', obwohl',
            'be-',
            '-standen',
            'bestanden',
            'haben'
        ]
    },
    {
        text: 'Sie zeigt jetzt ihr wahres Gesicht.',
        stubs: [1, 3, 4],
        translations: {
            eng: 'She is now showing her true face.'
        },
        tags: [
            'pronoun-dative',
            'zeigen'
        ]
    },
    {
        text: 'Hier müssen wir zwischen zwei verschiedenen Spielformen im Islamismus unterschieden.',
        stubs: [1, 3, 5, 7, 9],
        translations: {
            eng: 'Here we need to distinguish between to different variations of Islamism.'
        },
        tags: [
            'unter-',
            '-schieden',
            'unterschieden',
            'müssen',
            'zwischen'
        ]
    },
    {
        text: 'Sie drängen auf einen Marsch durch die Institutionen.',
        stubs: [1, 2, 3, 5, 6],
        translations: {
            eng: 'They are pushing for a march through the institutions.'
        },
        tags: [
            'drängen',
            'auf',
            'durch'
        ]
    },
    {
        text: 'Beide dieser islamistischen Spielformen haben aber ein gemeinsames Ziel: die Etablierung eines islamischen Staates, dessen Verfassung der Scharia beruht.',
        stubs: [0, 1, 4, 5, 6, 7, 11, 14, 16, 18],
        translations: {
            eng: 'But both of these Islamist variations have a common goal: the establishment of an Islamic state whose constitution is based on Sharia law.'
        },
        tags: [
            'aber',
            'genitive',
            'dessen',
            '-ruhen',
            'be-',
            'beruhen',
            'dies'
        ]
    },
    {
        text: 'Der Westen hätte Erdogan mit mehr Vorsicht begegnen sollen?',
        stubs: [0, 2, 4, 7, 8],
        translations: {
            eng: 'Should the West have met Erdogan with more caution?'
        },
        tags: [
            'hätten',
            'mit',
            'begegnen',
            'sollen'
        ]
    },
    {
        text: 'Der Westen hatte Erdogan mit Vorsicht begegnet.',
        stubs: [0, 2, 4, 7],
        translations: {
            eng: 'The west had met Erdogan with caution.'
        },
        tags: [
            'hatten',
            'mit',
            'begegnen'
        ]
    },
    {
        text: 'Am 18. September können die Berlinerinnen und Berliner ihre Wahl treffen, wie sie sich ihre Stadt der Zukunft vorstellen.',
        stubs: [0, 3, 4, 8, 19, 11, 13, 14, 16, 18],
        translations: {
            eng: 'On September 18 (female and male) Berliners can make (literally: meet) their choice, how they imagine their city of the future.'
        },
        tags: [
            'an',
            'können',
            'treffen',
            ', wie',
            'reflexive',
            'vor-',
            '-stellen',
            'vorstellen'
        ]
    },
    {
        text: 'Der Blick in die Sterne hat die Menschen seit jeher fasziniert und ihnen Hoffnung gegeben.',
        stubs: [2, 3, 5, 6, 8, 9, 10, 12, 14],
        translations: {
            eng: 'The glance to the stars has always fascinated mankind and given them hope.'
        },
        tags: [
            'in',
            'haben',
            'seit',
            'jeher',
            'faszinieren',
            'geben',
            'present-perfect',
            'active-voice'
        ]
    },
    {
        text: 'Die Weiten des Weltalls spiegeln unsere Geschichte.',
        stubs: [2, 4, 5],
        translations: {
            eng: 'The vastness of the universe reflects our history.'
        },
        tags: [
            'genitive',
            'spiegeln'
        ]
    },
    {
        text: 'Unser Nahverkehr muss mit der Bevölkerung mitwächst.',
        stubs: [2, 3, 4, 6],
        translations: {
            eng: 'Our mass transit must grow along with the population.'
        },
        tags: [
            'müssen',
            'mit',
            'mit-',
            '-wachsen'
        ]
    },
    {
        text: 'Wir müssen endlich Brücken, Fahradwege und Krankenhäuser sanieren.',
        stubs: [1, 7],
        translations: {
            eng: 'We must finally rehabilitate bridges, bike paths and hospitals.'
        },
        tags: [
            'müssen',
            'sanieren'
        ]
    },
    {
        text: 'Steuergeld muss gerechter ausgegeben werden.',
        stubs: [1, 2, 3, 4],
        translations: {
            eng: 'Tax money must be spent more equitably.'
        },
        tags: [
            'comparison',
            'müssen',
            'werden',
            'aus-',
            '-geben',
            'ausgeben'
        ]
    },
    {
        text: 'Diese Stadt gehört niemandem, auch keiner Partei.',
        stubs: [0, 2, 3, 4, 5],
        translations: {
            eng: 'This city doesn\'t belong to anyone, also to no party.'
        },
        tags: [
            'gehören',
            'ge-',
            '-hören',
            'niemand',
            'auch',
            'dative'
        ]
    },
    {
        text: 'Die größte Aufgabe des nächsten Jahrzehnts besteht in der Integration der geflüchteten Menschen.',
        stubs: [1, 3, 4, 6, 7, 8, 10],
        translations: {
            eng: 'The largest task of the next decade consists of the integration of the refuged people.'
        },
        tags: [
            'comparison',
            'genitive',
            'be-',
            '-stehen',
            'bestehen',
            'in',
            'dative'
        ]
    },
    {
        text: 'Gerade jetzt erfahren wir sehr deutlich, dass wir Teil einer globalisierten Welt sind.',
        stubs: [0, 1, 2, 6, 9, 12],
        translations: {
            eng: 'Right now we are very explicitly finding out that we are part of a globalized world.'
        },
        tags: [
            'gerade',
            'er-',
            '-fahren',
            'erfahren',
            ', dass',
            'genitive'
        ]
    },
    {
        text: 'Natürlich leben wir längst in einer vielfältigen und multikulturellen Gesellschaft.',
        stubs: [1, 2, 3, 4, 5, 6],
        translations: {
            eng: 'Of course, we have been living for a long time in a diverse and multicultural society.'
        },
        tags: [
            'leben',
            'in',
            'dative'
        ]
    },
    // {
    //     text: 'Andere Metropolen aufmachen, Vorreiter für eine moderne Energieversorgung zu sein, Fahrradstadt zu werden und grüne Oasen in verdichteten Innenstädten zu schaffen.',
    //     stubs: [0, 2, 4, 5, 6, 8, 9, 11, 12, 16, 17, 19, 20],
    //     translations: {
    //         eng: 'Other metropoles are rising to be pioneers for a modern energy supply, to becoming a cycling city and to creating green oases in dense inner cities.'
    //     },
    //     tags: [
    //         'auf-',
    //         '-machen',
    //         'aufmachen',
    //         'vor-',
    //         '-reiter',
    //         'für',
    //         'zu',
    //         'sein',
    //         'werden',
    //         'ver-',
    //         'schaffen',
    //         'ander'
    //     ]
    // },
    {
        text: 'Ich trinke vor der Arbeit Kaffee.',
        stubs: [1, 2, 3],
        translations: {
            eng: 'I drink coffee before work.'
        },
        tags: [
            'vor',
            'trinken'
        ]
    },
    {
        text: 'Ich trinke vor dem Büro Kaffee.',
        stubs: [1, 2, 3],
        translations: {
            eng: 'I drink coffee in front of the office.'
        },
        tags: [
            'vor',
            'trinken'
        ]
    },
    {
        text: 'Ich klebe ein paar Aufkleber auf meine Vase.',
        stubs: [1, 5, 6],
        translations: {
            eng: 'I\'m sticking a few stickers on my vase.'
        },
        tags: [
            'kleben',
            'auf'
        ]
    },
    {
        text: 'Ich beklebe meine Vase mit ein paar Stickern.',
        stubs: [1, 2, 4],
        translations: {
            eng: 'I\'m pasting my vase up with some stickers.'
        },
        tags: [
            '-kleben',
            'be-',
            'bekleben',
            'mit'
        ]
    },
    {
        text: 'Ich lege Käse auf meine Pizza.',
        stubs: [1, 3, 4],
        translations: {
            eng: 'I\'m putting cheese on my pizza.'
        },
        tags: [
            'legen',
            'auf'
        ]
    },
    {
        text: 'Ich belege meine Pizza mit Käse.',
        stubs: [1, 2, 4],
        translations: {
            eng: 'I\'m topping my pizza with cheese.'
        },
        tags: [
            'be-',
            '-legen',
            'belegen',
            'mit'
        ]
    },
    {
        text: 'Ich begreife nicht, wieso du dir schon wieder ein neues Auto gekauft hast.',
        stubs: [1, 3, 5, 8, 9, 11, 12],
        translations: {
            eng: 'I don’t grasp why you bought yourself a new car once again.'
        },
        tags: [
            ', wieso',
            'be-',
            '-greifen',
            'begreifen',
            'pronoun-dative',
            'kaufen',
            'active-voice',
            'present-perfect'
        ]
    },
    {
        text: 'Sie beschweren sich immer über das Wetter.',
        stubs: [1, 2, 4, 5],
        translations: {
            eng: 'They always complain about the weather.'
        },
        tags: [
            'be-',
            '-schweren',
            'beschweren',
            'reflexive',
            'über'
        ]
    },
    {
        text: 'Der Wagen hat sie seitlich und mit voller Wucht erfasst.',
        stubs: [2, 6, 7, 9],
        translations: {
            eng: 'The car struck her laterally and with full force.'
        },
        tags: [
            'active-voice',
            'present-perfect',
            'erfassen',
            'er-',
            '-fassen',
            'mit'
        ]
    },
    {
        text: 'Er wurde vermutlich kurz vor seinem Tod geschlagen.',
        stubs: [1, 4, 5, 7],
        translations: {
            eng: 'He was probably beaten shortly before his death.'
        },
        tags: [
            'wurden',
            'vor',
            'schlagen',
            'past-simple',
            'passive-voice'
        ]
    },
    {
        text: 'Ich dachte, ich hätte ihn, aber meine Zeugin wurde überfahren.',
        stubs: [1, 3, 4, 5, 8, 9],
        translations: {
            eng: 'I thought I had him but my witness was run over.'
        },
        tags: [
            'hätten',
            ', aber',
            'wurden',
            'überfahren',
            'über-',
            '-fahren',
            'dachten',
            'past-simple',
            'passive-voice'
        ]
    },
    {
        text: 'Lass uns jetzt nicht über Arbeit reden.',
        stubs: [0, 4, 6],
        translations: {
            eng: 'Let\'s not talk about work right now.'
        },
        tags: [
            'lassen',
            'über',
            'reden'
        ]
    },
    {
        text: 'Wir sind uns nach seiner Einstellung vielleicht zwei, drei Mal begegnet.',
        stubs: [1, 2, 3, 4, 10],
        translations: {
            eng: 'We met over his attitude maybe two or three times.'
        },
        tags: [
            'nach',
            'be-',
            '-gegen',
            'begegnen'
        ]
    },
    {
        text: 'Entscheide, ob du ein Reflexivpronomen verwenden musst oder nicht.',
        stubs: [0, 1, 5, 6],
        translations: {
            eng: 'Decide whether you need to utilize a reflexive pronoun or not.'
        },
        tags: [
            'ent-',
            '-scheiden',
            'entscheiden',
            'ob',
            'ver-',
            '-wenden',
            'verwenden',
            'müssen'
        ]
    },
    {
        text: 'Hast du dir schon etwas zu essen bestellt?',
        stubs: [0, 2, 5, 7],
        translations: {
            eng: 'Have you already ordered something to eat?'
        },
        tags: [
            'pronoun-dative',
            'zu',
            'be-',
            '-stellen',
            'bestellen'
        ]
    },
    {
        text: 'Private Wohnungen sollen vollständig als Ferienwohnung vermietet werden dürfen.',
        stubs: [2, 4, 6, 7, 8],
        translations: {
            eng: 'Private flats should be fully allowed to be rented out as vacation flats.'
        },
        tags: [
            'sollen',
            'double-infinitive',
            'als',
            'vermieten',
            'ver-',
            '-mieten',
            'werden',
            'dürfen'
        ]
    },
    {
        text: 'Alle Spätis sollen auch sonntags öffnen dürfen.',
        stubs: [0, 2, 5, 6],
        translations: {
            eng: 'All Spätis should be allowed to be open on Sundays as well.'
        },
        tags: [
            'all',
            'sollen',
            'öffnen',
            'dürfen'
        ]
    },
    {
        text: 'Hier sollen Förderschulen für Kinder und Jugendliche mit Behinderungen langfristig erhalten bleiben.',
        stubs: [1, 3, 7, 10, 11],
        translations: {
            eng: 'Here, special schools for children and teenagers with disabilities should be preserved (literally: stay preserved) in the long run.'
        },
        tags: [
            'erhalten',
            'er-',
            '-halten',
            'für',
            'mit',
            'bleiben'
        ]
    },
    {
        text: 'Es soll ein kostenfreies Mittagessen für alle Schülerinnen und Schüler an Schulen geben.',
        stubs: [0, 1, 2, 3, 5, 6, 10, 12],
        translations: {
            eng: 'There should be a free lunch for all schoolchildren in schools.'
        },
        tags: [
            'sollen',
            'für',
            'an',
            'geben'
        ]
    },
    {
        text: 'Das Land soll sich für ein bedingungsloses Grundeinkommen einsetzen.',
        stubs: [2, 3, 4, 5, 6, 8],
        translations: {
            eng: 'The country should support (literally: apply itself for) an unconditional basic income.'
        },
        tags: [
            'sollen',
            'für',
            'ein-',
            '-setzen',
            'einsetzen',
            'reflexive'
        ]
    },
    {
        text: 'Die Polizei soll den Einsatz von Kameras, die am Körper getragen werden, erproben.',
        stubs: [2, 3, 5, 7, 8, 10, 11, 12],
        translations: {
            eng: 'The police should test the application of cameras which are worn on the body.'
        },
        tags: [
            'sollen',
            'von',
            ', article',
            'an',
            'tragen',
            'werden',
            'present-simple',
            'passive-voice'
        ]
    },
    {
        text: 'Der Anbau von Cannabis für den Eigenbedarf soll generell erlaubt sein.',
        stubs: [2, 4, 5, 7, 9, 10],
        translations: {
            eng: 'The cultivation of cannabis for personal use should generally be permitted.'
        },
        tags: [
            'von',
            'für',
            'sollen',
            'erlauben',
            'er-',
            '-lauben',
            'sein'
        ]
    },
    {
        text: 'Die Anzahl der erforderlichen Stimmen bei Volksentscheiden soll gesenkt werden.',
        stubs: [2, 3, 5, 6],
        translations: {
            eng: 'The number of required votes in referendums should be lowered.'
        },
        tags: [
            'er-',
            '-fordern',
            'bei',
            'volk-',
            'ent-',
            '-scheiden'
        ]
    },
    {
        text: 'Die Anzahl der erforderlichen Stimmen bei Volksentscheiden soll gesenkt werden.',
        stubs: [7, 8, 9],
        translations: {
            eng: 'The number of required votes in referendums should be lowered.'
        },
        tags: [
            'sollen',
            'senken',
            'werden',
            'present-simple',
            'passive-voice'
        ]
    },
    {
        text: 'Bei der Ausweisung neuer Wohngebiete soll ein höherer Anteil von Sozialwohnungen vorgeschrieben werden.',
        stubs: [0, 1, 3, 5, 6, 7, 9, 11, 12],
        translations: {
            eng: 'In the designation of new housing zones, a higher percentage of public housing should be mandated (literally: prescribed).'
        },
        tags: [
            'bei',
            'sollen',
            'von',
            'vor-',
            '-schreiben',
            'vorschreiben',
            'werden',
            'present-simple',
            'passive-voice'
        ]
    },
    {
        text: 'In Berlin soll die Nutzung des öffentlichen Personennahverkehrs entgeltfrei sein.',
        stubs: [0, 2, 5, 6, 9],
        translations: {
            eng: 'In Berlin, the usage of local public transit should be free of charge (literally: fee-less).'
        },
        tags: [
            'in',
            'sollen',
            'sein'
        ]
    },
    {
        text: 'Über Esperanto sind leider eine Reihe von populären Irrtümern in Umlauf, die immer wieder auch in Zeitungen und anderen Medien auftauchen.',
        stubs: [0, 2, 4, 6, 7, 9, 11, 15, 20],
        translations: {
            eng: 'Unfortunately, a series of popular errors about Esperanto are in circulation, which also surface again and again in newspapers and other media.'
        },
        tags: [
            'über',
            'von',
            'in',
            ', article',
            'ander'
        ]
    },
    {
        text: 'Zu den Grundsätzen einer Demokratie gehört es, miteinander zu reden und Konflikte verbal auszutragen.',
        stubs: [0, 1, 3, 5, 6, 8, 9, 13],
        translations: {
            eng: 'It belongs to the principles of a democracy, talking with each other and resolving conflicts verbally.'
        },
        tags: [
            'zu',
            'hören',
            'reden',
            'aus-',
            'zu-',
            'auszu-',
            '-tragen',
            'auszutragen'
        ]
    },
    {
        text: 'Daher wirkt es auf den ersten Blick durchaus legitim, wenn Rechtsextreme fordern, dass auch mit ihnen geredet wird.',
        stubs: [0, 1, 3, 4, 5, 9, 11, 12, 14, 15, 16, 17],
        translations: {
            eng: 'Therefore, it seems, on first glance, thoroughly legitimate when right-wing extremists demand that they, as well, be discoursed with.'
        },
        tags: [
            'da-',
            'wirken',
            'auf',
            ', wenn',
            ', dass',
            'fordern',
            'mit',
            'pronoun-dative',
            'reden',
            'werden'
        ]
    },
    // {
    //     text: 'Immer wieder stehen Demokraten vor der Frage, ob sie dem nachkommen wollen.',
    //     stubs: [2, 4, 5, 7, 8, 9, 10, 11],
    //     translations: {
    //         eng: 'Democratic people are consistently faced with the question, whether they want to comply with them.'
    //     },
    //     tags: [
    //         'stehen',
    //         'vor',
    //         ', ob',
    //         'pronoun-accusative',
    //         'nachkommen',
    //         'wollen',
    //         'present-simple',
    //         'active-voice'
    //     ]
    // },
    {
        text: 'Manche lehnen dies ab, mit Verweis auf die undemokratischen Ansichten des Gegenübers, oder aus Sorge, sie durch das Gespräch aufzuwerten.',
        stubs: [0, 1, 3, 4, 6, 7, 10, 12, 13, 15, 17, 19],
        translations: {
            eng: 'Some reject this, with reference to the undemocratic views of their counterparts or out of concern of empowering them through the discussion.'
        },
        tags: [
            'manch',
            '-lehnen',
            'ab-',
            'ablehnen',
            'mit',
            'auf',
            'genitive',
            'auf-',
            'zu-',
            'aufzu-',
            '-werten',
            'aufzuwerten',
            ', oder'
        ]
    },
    {
        text: 'Das ist der Bus, worauf wir alle warten.',
        stubs: [1, 4, 6, 7],
        translations: {
            eng: 'That\'s the bus on which we\'re all waiting.'
        },
        tags: [
            ', worauf',
            'all',
            'auf',
            'warten'
        ]
    },
    {
        text: 'Das Erste, wovon sie gesprochen hat, war die Situation in den Schulen.',
        stubs: [2, 4, 5, 6, 9, 10],
        translations: {
            eng: 'The first thing of which she spoke was the situation in the schools.'
        },
        tags: [
            ', wovon',
            'sprechen',
            'von',
            ', war',
            'in'
        ]
    },
    {
        text: 'Das Auto womit wir gefahren sind, war ziemlich alt.',
        stubs: [2, 3, 4, 5, 6],
        translations: {
            eng: 'The car with which we had driven was quite old.'
        },
        tags: [
            'womit',
            'fahren',
            ', war'
        ]
    },
    {
        text: 'Ich gebe dir morgen Bescheid.',
        stubs: [1, 2, 4],
        translations: {
            eng: 'I\'ll let you know tomorrow (literally: I give you information tomorrow)'
        },
        tags: [
            'geben',
            'pronoun-dative'
        ]
    },
    {
        text: 'Ich habe etwas, was ich dir geben möchte.',
        stubs: [3, 5, 6, 7],
        translations: {
            eng: 'I have something which I\'d like to give to you.'
        },
        tags: [
            ', was',
            'pronoun-dative',
            'möchten',
            'geben'
        ]
    },
    {
        text: 'Es gibt nichts, was er jetzt sagen könnte.',
        stubs: [1, 2, 3, 6, 7],
        translations: {
            eng: 'There is nothing which he could say now.'
        },
        tags: [
            ', was',
            'geben',
            'sagen',
            'könnten'
        ]
    },
    {
        text: 'Ich habe nur wenig, was ich Ihnen bieten könnte.',
        stubs: [1, 4, 6, 7, 8],
        translations: {
            eng: 'I have only little which I could offer you (formal).'
        },
        tags: [
            ', was',
            'pronoun-dative',
            'bieten',
            'könnten'
        ]
    },
    {
        text: 'Es gibt viel, was Sie für ihn tun könnten.',
        stubs: [1, 3, 5, 6, 7, 8],
        translations: {
            eng: 'There is a lot which you (formal) could do for him.'
        },
        tags: [
            'geben',
            ', was',
            'für',
            'tun',
            'könnten',
            'pronoun-accusative'
        ]
    },
    {
        text: 'Das ist das Klügste, was du in dieser Situation tun könntest.',
        stubs: [2, 4, 6, 7, 9, 10],
        translations: {
            eng: 'That is the smartest thing which you could do in this situation.'
        },
        tags: [
            ', was',
            'dies',
            'tun',
            'könnten'
        ]
    },
    {
        text: 'Das ist das Letzte, was ich für dich wollte.',
        stubs: [2, 4, 6, 7, 8],
        translations: {
            eng: 'That is the last thing which I would want for you.'
        },
        tags: [
            ', was',
            'für',
            'pronoun-accusative',
            'wollten'
        ]
    },
    {
        text: 'Ich möchte in einer Stadt arbeiten, wo ich kein Auto brauche.',
        stubs: [1, 2, 3, 5, 6, 8, 10],
        translations: {
            eng: 'I would like to work in a city, where I don\'t need a car.'
        },
        tags: [
            'möchten',
            'in',
            'arbeiten',
            ', wo',
            'kein',
            'brauchen'
        ]
    },
    {
        text: 'Die Geschwindigkeit wird von der Polizei kontrolliert.',
        stubs: [2, 3, 4, 6],
        translations: {
            eng: 'The speed is controlled by the police.'
        },
        tags: [
            'present-simple',
            'passive-voice',
            'von',
            'kontrollieren',
            'werden'
        ]
    },
    {
        text: 'Mein Fahrrad wurde vom Mechaniker repariert.',
        stubs: [2, 3, 5],
        translations: {
            eng: 'My bike was fixed by the mechanic.'
        },
        tags: [
            'past-simple',
            'passive-voice',
            'von',
            'reparieren',
            'wurden'
        ]
    },
    {
        text: 'Die Heizung ist nicht abgestellt worden.',
        stubs: [2, 4, 5],
        translations: {
            eng: 'The heater hasn\'t been turned off.'
        },
        tags: [
            'abstellen',
            'worden',
            'present-perfect',
            'passive-voice'
        ]
    },
    {
        text: 'Die Glühbirne wurde von Edison erfunden.',
        stubs: [2, 3, 5],
        translations: {
            eng: 'The lightbulb was invented by Edison.'
        },
        tags: [
            'wurden',
            'er-',
            '-finden',
            'erfinden',
            'von',
            'past-simple',
            'passive-voice'
        ]
    },
    {
        text: 'Daher empfehle ich die Verwendung von Hilfsverben.',
        stubs: [0, 1, 5],
        translations: {
            eng: 'Therefore, I recommend the use of auxiliary verbs.'
        },
        tags: [
            'daher',
            'empfehlen',
            'emp-',
            '-fehlen',
            'von',
            'present-simple',
            'active-voice'
        ]
    },
    {
        text: 'Dieses Buch kann ich dir sehr empfehlen.',
        stubs: [0, 2, 4, 6],
        translations: {
            eng: 'I can really recommend this book to you.'
        },
        tags: [
            'können',
            'pronoun-dative',
            'emp-',
            '-fehlen',
            'empfehlen',
            'dies',
            'present-simple',
            'active-voice'
        ]
    },
    {
        text: 'Der Arzt hat mir empfohlen, viel Wasser zu trinken.',
        stubs: [3, 4, 7, 8],
        translations: {
            eng: 'The doctor has advised me to drink a lot of water.'
        },
        tags: [
            'pronoun-dative',
            'emp-',
            '-fehlen',
            'empfehlen',
            'zu',
            'trinken',
            'present-perfect',
            'active-voice'
        ]
    },
    {
        text: 'Die Milch ist schlecht geworden, sie ist nicht mehr zu verwenden.',
        stubs: [4, 5, 9, 10],
        translations: {
            eng: 'The milk has gone (literally: become) bad, it\'s not to be used anymore.'
        },
        tags: [
            'geworden',
            'ver-',
            '-wenden',
            'verwenden',
            'zu'
        ]
    },
    {
        text: 'Das große Haus wird von ihnen gebaut.',
        stubs: [3, 4, 5, 6],
        translations: {
            eng: 'The large house is being built by them.'
        },
        tags: [
            'passive-voice',
            'present-simple',
            'pronoun-dative',
            'von',
            'werden',
            'bauen'
        ]
    },
    {
        text: 'Das große Haus ist von ihnen gebaut worden.',
        stubs: [3, 4, 5, 6, 7],
        translations: {
            eng: 'The large house has been built by them.'
        },
        tags: [
            'von',
            'pronoun-dative',
            'bauen',
            'worden',
            'passive-voice',
            'present-perfect'
        ]
    },
    {
        text: 'Das große Haus wurde von ihnen gebaut.',
        stubs: [3, 4, 5, 6],
        translations: {
            eng: 'The large house was built by them.'
        },
        tags: [
            'von',
            'wurden',
            'passive-voice',
            'past-simple',
            'bauen',
            'pronoun-dative'
        ]
    },
    {
        text: 'Das große Haus war von ihnen gebaut worden.',
        stubs: [3, 4, 5, 6, 7],
        translations: {
            eng: 'The large house had been built by them.'
        },
        tags: [
            'passive-voice',
            'past-perfect',
            'waren',
            'bauen',
            'worden',
            'von',
            'pronoun-dative'
        ]
    },
    {
        text: 'Das große Haus wird von ihnen gebaut werden.',
        stubs: [3, 4, 5, 6, 7],
        translations: {
            eng: 'The large house will be built by them.'
        },
        tags: [
            'passive-voice',
            'future-simple',
            'werden',
            'von',
            'pronoun-dative',
            'bauen',
            'werden'
        ]
    },
    {
        text: 'Das große Haus wird von ihnen gebaut werden sein.',
        stubs: [3, 4, 5, 6, 7, 8],
        translations: {
            eng: 'The large house will have been built by them.'
        },
        tags: [
            'passive-voice',
            'future-perfect',
            'werden',
            'von',
            'bauen',
            'pronoun-dative'
        ]
    },
    {
        text: 'Sie bauen das große Haus.',
        stubs: [1],
        translations: {
            eng: 'They are building the large house.'
        },
        tags: [
            'active-voice',
            'present-simple',
            'bauen'
        ]
    },
    {
        text: 'Sie haben das große Haus gebaut.',
        stubs: [1, 5],
        translations: {
            eng: 'The have built the large house.'
        },
        tags: [
            'active-voice',
            'present-perfect',
            'bauen'
        ]
    },
    {
        text: 'Sie bauten das große Haus.',
        stubs: [1],
        translations: {
            eng: 'They built the large house.'
        },
        tags: [
            'bauen',
            'preterite',
            'active-voice',
            'past-simple'
        ]
    },
    {
        text: 'Sie hatten das große Haus gebaut.',
        stubs: [1, 5],
        translations: {
            eng: 'They had built the large house.'
        },
        tags: [
            'bauen',
            'hatten',
            'preterite',
            'active-voice',
            'past-perfect'
        ]
    },
    {
        text: 'Sie werden das große Haus bauen.',
        stubs: [1, 5],
        translations: {
            eng: 'They will build the large house.'
        },
        tags: [
            'werden',
            'bauen',
            'active-voice',
            'future-simple'
        ]
    },
    {
        text: 'Sie werden das große Haus gebaut haben.',
        stubs: [1, 5, 6],
        translations: {
            eng: 'They will have built the large house.'
        },
        tags: [
            'werden',
            'bauen',
            'active-voice',
            'future-perfect'
        ]
    },
    {
        text: 'Es ist nie langweilig, mit ihr zussamen zu sein.',
        stubs: [4, 5, 7, 8],
        translations: {
            eng: 'It\'s never boring to be together with her.'
        },
        tags: [
            ', preposition',
            'mit',
            'zu',
            'zu verb',
            'sein',
            'pronoun-dative'
        ]
    },
    {
        text: 'Es war uns nicht möglich, in München zu übernachten.',
        stubs: [1, 2, 5, 7, 8],
        translations: {
            eng: 'It was not possible for us to stay the night in Munich.'
        },
        tags: [
            ', preposition',
            'in',
            'zu',
            'zu verb',
            'past-simple',
            'active-voice',
            'waren',
            'über-',
            '-nachten',
            'übernachten'
        ]
    },
    {
        text: 'Es ist teuer, ein Auto zu mieten.',
        stubs: [3, 5, 6],
        translations: {
            eng: 'It\'s expensive to rent a car.'
        },
        tags: [
            ', article',
            'zu verb',
            'mieten'
        ]
    },
    {
        text: 'Meine Mutter hat das Kind alleine zu Hause gelassen.',
        stubs: [6, 8],
        translations: {
            eng: 'My mother has left the child alone at the house.'
        },
        tags: [
            'lassen',
            'zu'
        ]
    },
    {
        text: 'Sie haben mich kommen lassen.',
        stubs: [2, 3, 4],
        translations: {
            eng: 'They are letting me come.'
        },
        tags: [
            'lassen',
            'kommen'
        ]
    },
    {
        text: 'Sie lassen die Kinder zu Hause.',
        stubs: [1, 4],
        translations: {
            eng: 'They are leaving the children at home.'
        },
        tags: [
            'lassen',
            'zu'
        ]
    },
    {
        text: 'Wir lassen den Artzt kommen.',
        stubs: [1, 4],
        translations: {
            eng: 'We are having (literally: letting) the doctor come.'
        },
        tags: [
            'lassen',
            'kommen'
        ]
    },
    {
        text: 'Sie lässt sich eine Tasse Kaffee machen.',
        stubs: [1, 2, 6],
        translations: {
            eng: 'She\'s having a cup of coffee made for her.'
        },
        tags: [
            'lassen',
            'machen'
        ]
    },
    {
        text: 'Sie lässt ihn den Tisch decken.',
        stubs: [1, 2, 3, 5],
        translations: {
            eng: 'She is having him set the table.'
        },
        tags: [
            'lassen',
            'decken'
        ]
    },
    {
        text: 'Die Mieten sind in den letzten fünf Jahren stark gestiegen.',
        stubs: [2, 3, 4, 5, 9],
        translations: {
            eng: 'The rents have risen sharply in the last five years.'
        },
        tags: [
            'in',
            'present-perfect',
            'active-voice',
            'stiegen'
        ]
    },
    {
        text: 'Wer einen ausländischen Staatschef beleidigt, kann angeklagt werden. Aber nur, wenn das andere Land die deutsche Regierung darum bittet. Und nur, wenn die Regierung einwilligt.',
        stubs: [4, 5, 6, 7, 8, 10, 17, 18, 19, 21, 24],
        translations: {
            eng: 'Anyone who offends a foreign leader can be charged. But only if the other country asks the German government for it. And only if the government consents.'
        },
        tags: [
            'wer',
            'beleidigen',
            'anklagen',
            'an-',
            '-klagen',
            'werden',
            'können',
            'da-',
            'bitten',
            'einwilligen',
            'ein-',
            '-willigen'
        ]
    },
    {
        text: 'Ich habe ein neues Fahrrad und ich fahre gern damit rum.',
        stubs: [2, 3, 7, 9],
        translations: {
            eng: 'I have a new bike and I enjoy riding around with it.'
        },
        tags: [
            'fahren',
            'da-',
            'present-simple',
            'active-voice'
        ]
    },
    {
        text: 'Sie träumt davon, Präsident zu werden.',
        stubs: [1, 2, 4, 5],
        translations: {
            eng: 'She dreams of becoming president.'
        },
        tags: [
            'träumen',
            'da-',
            'zu verb'
        ]
    },
    {
        text: 'Es hat viel geregnet, aber wir hatten Spaß.',
        stubs: [3, 4, 5, 6, 7],
        translations: {
            eng: 'It rained a lot but we had fun.'
        },
        tags: [
            'regnen',
            ', aber',
            'hatten'
        ]
    },
    {
        text: 'Obwohl es viel geregnet hat, hatten wir Spaß.',
        stubs: [0, 3, 4, 5, 6, 7],
        translations: {
            eng: 'Although it rained a lot, we had fun.'
        },
        tags: [
            'regnen',
            ', obwohl',
            'hatten',
            ', verb'
        ]
    },
    {
        text: 'Obwohl wir viele Probleme hatten, hatten wir Spaß.',
        stubs: [0, 2, 4, 5, 6, 7],
        translations: {
            eng: 'Although we had many problems, we had fun.'
        },
        tags: [
            ', obwohl',
            ', verb',
            'hatten'
        ]
    },
    {
        text: 'Wir gehen aus, obwohl es regnet.',
        stubs: [1, 2, 3, 5],
        translations: {
            eng: 'We are going out, although it\'s raining.'
        },
        tags: [
            'aus-',
            '-gehen',
            'ausgehen',
            ', obwohl',
            'regnen'
        ]
    },
    {
        text: 'Wir gehen nicht aus, weil es regnet.',
        stubs: [1, 3, 4, 6],
        translations: {
            eng: 'We aren\'t going out because it\'s raining.'
        },
        tags: [
            'aus-',
            '-gehen',
            'ausgehen',
            ', obwohl',
            'regnen'
        ]
    },
    {
        text: 'Trotz des Regens hatten wir Spaß.',
        stubs: [0, 1, 3],
        translations: {
            eng: 'Despite the rain we had fun.'
        },
        tags: [
            'trotz',
            'hatten',
            'past-simple',
            'active-voice'
        ]
    },
    {
        text: 'Trotz vieler Probleme hatten wir Spaß im Urlaub.',
        stubs: [0, 1, 3, 6],
        translations: {
            eng: 'Despite many problems we had fun on vacation.'
        },
        tags: [
            'trotz',
            'hatten',
            'in'
        ]
    },
    {
        text: 'Trotz des Regens gehen wir aus.',
        stubs: [0, 1, 3, 5],
        translations: {
            eng: 'Despite the rain we are going out.'
        },
        tags: [
            'trotz',
            'aus-',
            '-gehen',
            'ausgehen'
        ]
    },
    {
        text: 'Wegen des Regens gehen wir nicht aus.',
        stubs: [0, 1, 3, 6],
        translations: {
            eng: 'Due to the rain we aren\'t going out.'
        },
        tags: [
            'wegen',
            'aus-',
            '-gehen',
            'ausgehen'
        ]
    },
    {
        text: 'Obwohl es viel geregnet hat, haben wir unseren Urlaub genossen.',
        stubs: [0, 3, 4, 5, 7, 9],
        translations: {
            eng: 'Although it has rained a lot, we have enjoyed our vacation.'
        },
        tags: [
            ', obwohl',
            'regnen',
            'haben',
            'genießen',
            'unser'
        ]
    },
    {
        text: 'Es regnet. Trotzdem gehe ich spazieren.',
        stubs: [1, 2, 3, 5],
        translations: {
            eng: 'It\'s raining. Nevertheless, I\'ll go walking.'
        },
        tags: [
            ', trotzdem',
            'regnen',
            'gehen',
            'spazieren'
        ]
    },
    {
        text: 'Trotz des heftigen Regens führen wir weiter.',
        stubs: [0, 1, 2, 4],
        translations: {
            eng: 'Despite the heavy rain we drove on.'
        },
        tags: [
            'trotz',
            'führen'
        ]
    },
    {
        text: 'Vor dem Spiel gehen wir ein Eis essen.',
        stubs: [0, 1, 3, 7],
        translations: {
            eng: 'Before the game we are going to eat ice cream.'
        },
        tags: [
            'vor',
            'essen',
            'gehen'
        ]
    },
    {
        text: 'Bevor das Spiel beginnt, gehen wir ein Eis essen.',
        stubs: [0, 1, 3, 4, 8],
        translations: {
            eng: 'Before the game begins we are going to east ice cream.'
        },
        tags: [
            ', bevor',
            'beginnen',
            'gehen',
            'essen'
        ]
    },
    {
        text: 'Während man isst, sollte man nicht lesen.',
        stubs: [0, 2, 3, 6],
        translations: {
            eng: 'While one eats, one should not read.'
        },
        tags: [
            ', während',
            'essen',
            'sollten',
            'preterite',
            'lesen'
        ]
    },
    {
        text: 'Während die Gewinner jubelten, verließen die Verlierer enttäuscht das Feld.',
        stubs: [0, 1, 3, 4, 5, 7, 9],
        translations: {
            eng: 'While the winners cheered, the losers left the field disappointed.'
        },
        tags: [
            ', während',
            'jubelten',
            'preterite',
            'verließen',
            'enttäuschen',
            'ent-',
            '-täuschen'
        ]
    },
    {
        text: 'Ich esse eine Pizza, denn ich habe Hunger.',
        stubs: [4, 5, 6],
        translations: {
            eng: 'I\'m eating a pizza because I\'m hungry (literally: have hunger).',
        },
        tags: [
            ', denn',
            'haben'
        ]
    },
    {
        text: 'Ich esse eine Pizza, weil ich Hunger habe.',
        stubs: [4, 5, 6],
        translations: {
            eng: 'I\'m eating pizza because I\'m hungry (literally: have hunger).',
        },
        tags: [
            ', weil',
            'haben'
        ]
    },
    {
        text: 'Ich esse, weil ich Hunger habe, eine Pizza.',
        stubs: [2, 3, 4, 5],
        translations: {
            eng: 'I\'m eating, because I\'m hungry, a pizza.'
        },
        tags: [
            ', weil',
            'haben'
        ]
    },
    {
        text: 'Weil ich Hunger habe, esse ich eine Pizza.',
        stubs: [0, 3, 4, 5],
        translations: {
            eng: 'Because I\'m hungry, I\'m eating a pizza.'
        },
        tags: [
            ', weil',
            'haben'
        ]
    },
    {
        text: 'Ich weinte, denn ich hatte kein Geld.',
        stubs: [2, 3, 4, 5, 6],
        translations: {
            eng: 'I cried because I had no money.'
        },
        tags: [
            ', denn',
            'hatten',
            'preterite'
        ]
    },
    {
        text: 'Sie arbeitet heute nicht, weil sie krank ist.',
        stubs: [4, 5, 6, 7],
        translations: {
            eng: 'She isn\'t working today because she\'s sick.'
        },
        tags: [
            ', weil'
        ]
    },
    {
        text: 'Ich weiß nicht, wie ich es auf Deutsch sagen kann.',
        stubs: [3, 4, 5, 8, 9],
        translations: {
            eng: 'I don\'t know how I can say that in German.'
        },
        tags: [
            ', wie',
            'sagen',
            'können'
        ]
    },
    {
        text: 'Als ich Kind war, wohnte ich in München.',
        stubs: [0, 1, 2, 3],
        translations: {
            eng: 'When I was a child (literally: as a child) I lived in Munich.'
        },
        tags: [
            ', als',
            'waren'
        ]
    },
    {
        text: 'Woran denkst du, bevor du einschläfst?',
        stubs: [3, 4, 5],
        translations: {
            eng: 'What do you think about before you fall asleep?'
        },
        tags: [
            ', bevor'
        ]
    },
    {
        text: 'Das Haus ist nicht alt, sondern neu.',
        stubs: [5],
        translations: {
            eng: 'The house is not old, but new.'
        },
        tags: [
            ', sondern'
        ]
    },
    {
        text: 'Ich bin nicht mit dem Auto gefahren, sondern zu Fuß gegangen.',
        stubs: [7, 8, 9, 10],
        translations: {
            eng: 'I didn\'t go by car (literally: I didn\'t drive with the car), but rather by foot.'
        },
        tags: [
            ', sondern',
            'gehen'
        ]
    },
    {
        text: 'Ich gehe nicht ins Kino, sondern zum Park.',
        stubs: [5, 6, 7],
        translations: {
            eng: 'I\'m not going to the cinema, rather to the park.'
        },
        tags: [
            'gehen',
            'in',
            'zu',
            ', sondern'
        ]
    },
    {
        text: 'Bevor du ins Bett gehst, sollst du dir die Zähne putzen.',
        stubs: [0, 1, 2, 3, 4],
        translations: {
            eng: 'Before you go to bed, you should clean your teeth.'
        },
        tags: [
            ', bevor',
            'in',
            'gehen'
        ]
    },
    {
        text: 'Sie ist sowohl Sängerin als auch Schauspielerin.',
        stubs: [2, 4, 5],
        translations: {
            eng: 'She is both a singer and also an actress.'
        },
        tags: [
            'sowohl als',
        ]
    },
    {
        text: 'Ich mag sowohl die Berge als auch das Meer.',
        stubs: [2, 5, 6],
        translations: {
            eng: 'I like both the mountains and also the sea.'
        },
        tags: [
            'sowohl als'
        ]
    },
    {
        text: 'Er kam anstatt seiner Frau.',
        stubs: [2, 3],
        translations: {
            eng: 'He came in place of his wife.'
        },
        tags: [
            'anstatt'
        ]
    },
    {
        text: 'Anstatt einer Haftstrafe erhielt der Angeklagte eine Geldstrafe.',
        stubs: [0, 1],
        translations: {
            eng: 'Instead of a prison sentence, the defendant received a fine.'
        },
        tags: [
            'anstatt'
        ]
    },
    {
        text: 'Ausserhalb der Sprechstunden wenden Sie sich bitte an den Notdienst.',
        stubs: [0, 1],
        translations: {
            eng: 'Outside of office hours, please utilize the emergency service.'
        },
        tags: [
            'außerhalb'
        ]
    },
    {
        text: 'Der Schiedsrichter sah das Foulspiel außerhalb des Strafraums und gab daher keinen Elfmeter.',
        stubs: [5, 6],
        translations: {
            eng: 'The referee saw the foul play outside of the penalty area and therefore didn\'t award a penalty kick.'
        },
        tags: [
            'außerhalb'
        ]
    },
    {
        text: 'Bitte die Rechnung innerhalb von zwei Wochen begleichen.',
        stubs: [3, 4],
        translations: {
            eng: 'Please pay the bill within two weeks.'
        },
        tags: [
            'innerhalb'
        ]
    },
    {
        text: 'Trotz aller Proteste will er im Amt bleiben.',
        stubs: [0, 1],
        translations: {
            eng: 'Despite all of the protests he wants to stay in the office.'
        },
        tags: [
            'trotz',
            'all'
        ]
    },
    {
        text: 'Während des Festes haben wir uns gestritten.',
        stubs: [0, 1],
        translations: {
            eng: 'We had argued during the party.'
        },
        tags: [
            'während'
        ]
    },
    {
        text: 'Die Kinder waren während der Sommerferien bei ihren Grosseltern auf dem Land.',
        stubs: [3, 4],
        translations: {
            eng: 'The children were, during the summer holidays, with their grandparents in the country.'
        },
        tags: [
            'während'
        ]
    },
    {
        text: 'Wegen des defekten Wagens würde die Strasse blockiert.',
        stubs: [0, 1, 2],
        translations: {
            eng: 'Due to the broken-down car, the street was blocked.'
        },
        tags: [
            'wegen'
        ]
    },
    {
        text: 'Wir mussten wegen des schlechten Wetters zu Hause bleiben.',
        stubs: [2, 3],
        translations: {
            eng: 'We had to stay at home due to the bad weather.'
        },
        tags: [
            'wegen'
        ]
    },
    {
        text: 'Du brauchst dir meinetwegen keine Sorgen zu machen.',
        stubs: [3],
        translations: {
            eng: 'You don’t need to worry about me.'
        },
        tags: [
            'wegen',
            'meinetwegen'
        ]
    },
    {
        text: 'Trotz der schweren Grippe ging der Franziska ins Büro.',
        stubs: [0, 1, 2],
        translations: {
            eng: 'Despite the severe flu, Franziska went to the office.'
        },
        tags: [
            'trotz'
        ]
    },
    {
        text: 'Während des Fussballspiels sahen die Leute einen Streit zwischen zwei Männern.',
        stubs: [0, 1],
        translations: {
            eng: 'During the football game, the people saw a dispute between two men.'
        },
        tags: [
            'während'
        ]
    },
    {
        text: 'Wegen des schlechten Wetters blieben die Mitarbeiter zu Hause.',
        stubs: [0, 1, 2],
        translations: {
            eng: 'Due to the severe weather, the coworkers stayed at home.'
        },
        tags: [
            'wegen'
        ]
    },
    {
        text: 'Während des Skikurses gab es keinen Unfall.',
        stubs: [0, 1],
        translations: {
            eng: 'There were no accident during the ski course.'
        },
        tags: [
            'während'
        ]
    },
    {
        text: 'Anstatt der guten Zeitung las er ein schlechtes Magazin.',
        stubs: [0, 1, 2],
        translations: {
            eng: 'Instead of the good newspaper, he read a poor-quality magazine.'
        },
        tags: [
            'anstatt'
        ]
    },
    {
        text: 'Wegen meiner kranken Oma fahre ich heute ins Spital.',
        stubs: [0, 1, 2],
        translations: {
            eng: 'I\'m driving to the hospital today because of my sick grandmother.'
        },
        tags: [
            'wegen'
        ]
    },
    {
        text: 'Sie rauchten außerhalb der festgesetzten Arbeitszeit.',
        stubs: [2, 3],
        translations: {
            eng: 'They smoked outside of the fixed working hours.'
        },
        tags: [
            'außerhalb'
        ]
    },
    {
        text: 'Den Fluss entlang stehen Bäume.',
        stubs: [0, 2],
        translations: {
            eng: 'There are trees along the river.'
        },
        tags: [
            'entlang'
        ]
    },
    {
        text: 'Er spazierte die Allee entlang.',
        stubs: [2, 4],
        translations: {
            eng: 'He walked along the boulevard.'
        },
        tags: [
            'entlang'
        ]
    },
    {
        text: 'Er lehnte sich gegen die Wand.',
        stubs: [3, 4],
        translations: {
            eng: 'He leaned against the wall.'
        },
        tags: [
            'gegen'
        ]
    },
    {
        text: 'Er fliegt in 80 Tagen mit einem Luftballon um die Welt.',
        stubs: [5, 6, 8, 9],
        translations: {
            eng: 'He\'s flying around the world in 80 days with a hot air balloon.'
        },
        tags: [
            'mit',
            'um'
        ]
    },
    {
        text: 'Ich möchte in Deutschland leben, deshalb lerne ich gerade Deutsch.',
        stubs: [2, 5, 6, 7, 8],
        translations: {
            eng: 'I\'d like to live in Germany, thus I\'m learning German.'
        },
        tags: [
            'deshalb',
            'gerade',
            'lernen'
        ]
    },
    {
        text: 'Ich habe nicht daran gedacht.',
        stubs: [1, 3, 4],
        translations: {
            eng: 'I hadn\'t thought about that.'
        },
        tags: [
            'haben',
            'denken',
            'da-'
        ]
    },
    {
        //     0   1     2   3   4      5         6   7   8    9   10      11   12  13  14   15   16   17      18       19         20 21        22   23  24      25     26    27  28 29     30
        text: 'Ein Wort, das ich häufig brauchte, war das Wort für <Ziel>, weil ich oft über mein Ziel sprach, fließend Chinesisch zu sprechen, wenn ich gefragt wurde, warum ich in Taiwan sei.',
        stubs: [2, 3, 4, 5],
        translations: {
            eng: 'A word that I needed often was the word for "goal" because I often talked about my goal to speak Chinese fluently when I was asked why I was in Taiwan.'
        },
        tags: [
            ', article',
            'brauchen',
            'preterite'
        ]
    },
    {
        //     0   1     2   3   4      5         6   7   8    9   10      11   12  13  14   15   16   17      18       19         20 21        22   23  24      25     26    27  28 29     30
        text: 'Ein Wort, das ich häufig brauchte, war das Wort für <Ziel>, weil ich oft über mein Ziel sprach, fließend Chinesisch zu sprechen, wenn ich gefragt wurde, warum ich in Taiwan sei.',
        stubs: [11, 12, 13, 14, 15, 16, 17],
        translations: {
            eng: 'A word that I had needed often was the word for "goal" because I often talked about my goal to speak Chinese fluently when I was asked why I was in Taiwan.'
        },
        tags: [
            ', weil',
            'sprechen',
            'über',
            'mein',
            'preterite'
        ]
    },
    {
        //     0   1     2   3   4      5         6   7   8    9   10      11   12  13  14   15   16   17      18       19         20 21        22   23  24      25     26    27  28 29     30
        text: 'Ein Wort, das ich häufig brauchte, war das Wort für <Ziel>, weil ich oft über mein Ziel sprach, fließend Chinesisch zu sprechen, wenn ich gefragt wurde, warum ich in Taiwan sei.',
        stubs: [18, 19, 20, 21],
        translations: {
            eng: 'A word that I needed often was the word for "goal" because I often talked about my goal to speak Chinese fluently when I was asked why was in Taiwan.'
        },
        tags: [
            'zu verb'
        ]
    },
    {
        //     0   1     2   3   4      5         6   7   8    9   10      11   12  13  14   15   16   17      18       19         20 21        22   23  24      25     26    27  28 29     30
        text: 'Ein Wort, das ich häufig brauchte, war das Wort für <Ziel>, weil ich oft über mein Ziel sprach, fließend Chinesisch zu sprechen, wenn ich gefragt wurde, warum ich in Taiwan sei.',
        stubs: [22, 23, 24, 25, 26],
        translations: {
            eng: 'A word that I needed often was the word for "goal" because I often talked about my goal to speak Chinese fluently when I was asked why was in Taiwan.'
        },
        tags: [
            ', wenn',
            'wurden',
            ', warum',
            'past-simple',
            'passive-voice'
        ]
    },
    {
        //     0     1      2   3                 4   5   6     7   8        9  10   11       12   13  14   15   16     17  18     19   20         21
        text: 'Falls jedoch die Stichwort-Methode für Sie nicht das Richtige zu sein scheint, habe ich auch viel Erfolg mit echten oder virtuellen Karteikarten.',
        stubs: [0, 1, 4, 8, 9, 10, 11],
        translations: {
            eng: 'However, in case the keyword method doesn\'t seem to be the right one for you (formal), I also have a lot of success with real or virtual index cards.'
        },
        tags: [
            'falls',
            'jedoch',
            'zu verb',
            'scheinen',
            'für',
            'pronoun-accusative'
        ]
    },
    {
        text: 'Wenn wir uns die Liste das nächste Mal anschauen, fangen wir wieder vorne an.',
        stubs: [0, 1, 2, 8, 9, 12, 13],
        translations: {
            eng: 'When we look at the list the next time, we start over again.'
        },
        tags: [
            ', wenn',
            'an-',
            '-schauen',
            'anschauen',
            'anfangen',
            '-fangen',
            'wieder',
            'vorn'
        ]
    },
    {
        //     0         1      2    3        4      5     6         7        8  9     10
        text: 'Innerhalb kurzer Zeit erwachte jedoch meine kindliche Fantasie zu neuem Leben.',
        stubs: [0, 1, 5, 6],
        translations: {
            eng: 'Within a short time, however, my childhood fantasy came alive (literally: had awoken to a new life).'
        },
        tags: [
            'innerhalb',
            'adjective-genitive',
            'mein',
            'adjective-nominative',
        ]
    },
    {
        //     0         1      2    3        4      5     6         7        8  9     10
        text: 'Innerhalb kurzer Zeit erwachte jedoch meine kindliche Fantasie zu neuem Leben.',
        stubs: [3, 4, 8, 9, 10],
        translations: {
            eng: 'Within a short time, however, my childhood fantasy came alive (literally: had awoken to a new life).'
        },
        tags: [
            'erwachen',
            'er-',
            '-wachen',
            'jedoch',
            'zu',
            'adjective-dative'
        ]
    },
    {
        text: 'Es stimmt, dass es anfangs ein oder zwei Minuten dauert, bis man sich eine Geschichte für ein neues Wort ausgedacht hat.',
        stubs: [2, 3, 4, 9, 15, 16, 17, 19, 20],
        translations: {
            eng: 'It\'s true that it initially takes one or two minutes until one has come up with a story for a new word.'
        },
        tags: [
            ', dass',
            'dauern',
            'für',
            'aus-',
            '-denken',
            'ausdenken'
        ]
    },
    {
        //     0     1    2   3    4    5   6           7  8   9     10  11   12   13   14  15  16         17     18    19  20  21   22      23
        text: 'Daher muss ich mich eine neue Geschichte in der Regel nur drei oder vier Mal ins Gedächtnis rufen, bevor ich das Wort einfach weiß.',
        stubs: [0, 1, 2, 3, 4, 5],
        translations: {
            eng: 'Therefore, I only have to recall (literally: call at the brain) a new story, as a rule of thumb (literally: in the rule), three or four times before I simply know the word.'
        },
        tags: [
            'daher',
            'müssen',
            'pronoun-accusative',
            'indefinite-article-accusative',
            'article-accusative'
        ]
    },
    {
        //     0     1    2   3    4    5   6           7  8   9     10  11   12   13   14  15  16         17     18    19  20  21   22      23
        text: 'Daher muss ich mich eine neue Geschichte in der Regel nur drei oder vier Mal ins Gedächtnis rufen, bevor ich das Wort einfach weiß.',
        stubs: [7, 8, 15, 17, 18],
        translations: {
            eng: 'Therefore, I only have to recall (literally: call at the brain) a new story, as a rule of thumb (literally: in the rule), three or four times before I simply know the word.'
        },
        tags: [
            'in',
            'definite-article-dative',
            'wo?',
            'definite-article-accusative',
            'rufen',
            ', bevor'
        ]
    },
    {
        text: 'Das Fremdwort ist ein Teil von mir geworden wie die Entsprechung in meiner Muttersprache.',
        stubs: [5, 6, 7, 11, 12],
        translations: {
            eng: 'The foreign word becomes a part of me, like the equivalent in my mother tongue.'
        },
        tags: [
            'von',
            'pronoun-dative',
            'geworden',
            'in',
            'mein',
            'present-perfect',
            'active-voice'
        ]
    },
    {
        text: 'Als ich diesen Ansatz das erste Mal ausprobierte, stellte ich fest, dass ich die Assoziation zu einem neuen Wort viel langsamer ausarbeitete, als ich gewollt hätte.',
        stubs: [0, 2, 7, 8, 10],
        translations: {
            eng: 'When I tried out this approach for the first time, I realized that I had worked out the association for a new word much slower than I would\'ve liked.'
        },
        tags: [
            ', als',
            'dies',
            'aus-',
            '-probieren',
            'ausprobieren',
            'fest-',
            '-stellen'
        ]
    },
    {
        text: 'Anstelle dieses Wortes können wir ein anderes Wort benutzen.',
        stubs: [0, 1, 2, 3, 4],
        translations: {
            eng: 'Instead of this word we can use another word.'
        },
        tags: [
            'anstelle',
            'dies',
            'können',
            'pronoun-nominative'
        ]
    },
    {
        text: 'Mein Portmonaie ist mir aus meiner Tasche gefallen. Danach hat mich eine Frau darauf aufmerksam gemacht.',
        stubs: [0, 2, 3, 4, 5, 7],
        translations: {
            eng: 'My wallet fell out of my bag. After that, a woman called my attention to that.'
        },
        tags: [
            'mein',
            'pronoun-dative',
            'aus',
            'fallen',
            'present-perfect',
            'active-voice'
        ]
    },
    {
        text: 'Welcher Satz wird öfter im gesprochenen Deutsch verwendet?',
        stubs: [0, 2, 3, 4, 5, 7],
        translations: {
            eng: 'Which sentence is used more often in spoken German?'
        },
        tags: [
            'present-simple',
            'passive-voice'
        ]
    },
    {
        text: 'Im Vergleich zu diesem Hund ist mein Hund dunkel.',
        stubs: [0, 2, 3, 5, 6],
        translations: {
            eng: 'In comparison to this dog, my dog is dark.'
        },
        tags: [
            'in',
            'zu',
            'dies',
            'mein'
        ]
    },
    {
        text: 'Am liebsten mag ich Erdbeeren, am wenigsten Äpfel.',
        stubs: [0, 1, 5, 6],
        translations: {
            eng: 'I like strawberries best, apples the least.'
        },
        tags: [
            'present-simple',
            'active-voice',
            'an',
            'liebsten',
            'wenigsten'
        ]
    },
    {
        text: 'Was für Kuchen haben Sie heute?',
        stubs: [0, 1, 3],
        translations: {
            eng: 'What types of cake do you (formal) have today?'
        },
        tags: [
            'für',
            'haben'
        ]
    },
    {
        text: 'Können Sie mir bitte einen Kuchen empfehlen?',
        stubs: [0, 2, 4, 6],
        translations: {
            eng: 'Can you please recommend me a cake?'
        },
        tags: [
            'pronoun-dative',
            'emp-',
            '-fehlen',
            'empfehlen',
            'present-simple',
            'active-voice'
        ]
    },
    {
        text: 'Claudia und Tobias heiraten, sobald er eine Stelle hat.',
        stubs: [4, 8],
        translations: {
            eng: 'Claudia and Tobias will marry as soon as he has a job.'
        },
        tags: [
            ', sobald'
        ]
    },
    {
        text: 'Sobald Tobias eine Stelle hat, heiraten sie.',
        stubs: [0, 4, 5, 6],
        translations: {
            eng: 'As soon as Tobias has a job, they will marry.'
        },
        tags: [
            ', sobald',
            'verb'
        ]
    },
    {
        text: 'Pedro war froh, als er endlich zu Hause angekommen ist.',
        stubs: [3, 6, 8, 9],
        translations: {
            eng: 'Pedro was glad when we finally arrived at home.'
        },
        tags: [
            ', als',
            'zu',
            'ankommen',
            'an-',
            '-kommen'
        ]
    },
    {
        text: 'Als Pedro endlich zu Hause angekommen ist, war er froh.',
        stubs: [0, 3, 5, 6, 7, 8, 9],
        translations: {
            eng: 'When Pedro finally arrived at home, he was glad.'
        },
        tags: [
            ', als',
            'zu',
            'ankommen',
            'an-',
            '-kommen',
            ', verb'
        ]
    },
    {
        text: 'Wir sind zu Hause geblieben, obwohl die Sonne schien.',
        stubs: [1, 2, 4, 5, 8],
        translations: {
            eng: 'We stayed at home even though the sun shone.'
        },
        tags: [
            ', obwohl',
            'bleiben',
            'zu',
            'preterite',
            'scheinen'
        ]
    },
    {
        text: 'Obwohl die Sonne schien, sind wir zu Hause geblieben.',
        stubs: [0, 3, 4, 5, 6, 8],
        translations: {
            eng: 'Even though the sun shone, we stayed at home.'
        },
        tags: [
            ', obwohl',
            'scheinen',
            'preterite',
            'zu',
            'bleiben',
            ', verb'
        ]
    },
    {
        text: 'Ich muss mich beeilen, weil die Vorlesung gleich beginnt.',
        stubs: [1, 2, 3, 4, 7, 8],
        translations: {
            eng: 'I need to hurry because the lecture starts soon.'
        },
        tags: [
            'müssen',
            'beeilene',
            ', weil',
            'beginnen',
            'adverb'
        ]
    },
    {
        text: 'Weil die Vorlesung gleich beginnt, muss ich mich beeilen.',
        stubs: [0, 3, 4, 5, 6, 7, 8],
        translations: {
            eng: 'Because the lecture begins soon, I need to hurry.'
        },
        tags: [
            'müssen',
            'beeilene',
            ', weil',
            'beginnen',
            'adverb',
            ', verb'
        ]
    },
    {
        text: 'Christine lag zwei Wochen im Krankenhaus, weil sie die Gelbsucht hatte.',
        stubs: [1, 4, 6, 10],
        translations: {
            eng: 'Christine was hospitalized for two weeks because she had jaundice.'
        },
        tags: [
            'liegen',
            'preterite',
            ', weil',
            'hatten',
            'in'
        ]
    },
    {
        text: 'Weil Christine die Gelbsucht hatte, lag sie zwei Wochen im Krankenhaus.',
        stubs: [0, 4, 5, 6, 9],
        translations: {
            eng: 'Because Christine had jaundice, she was hospitalized for two weeks.'
        },
        tags: [
            'liegen',
            'preterite',
            ', weil',
            'hatten',
            'in',
            ', verb'
        ]
    },
    {
        text: 'Anke ist ins Theater gegangen, während ihre Schwester zu Hause blieb.',
        stubs: [1, 2, 4, 5, 6, 8, 10],
        translations: {
            eng: 'Anke went to (literally: in) the theater while her sister stayed at home.'
        },
        tags: [
            'in',
            'gehen',
            ', während',
            'zu',
            'bleiben',
            'preterite'
        ]
    },
    {
        text: 'Während Ankes Schwester zu Hause blieb, ist Anke ins Theater gegangen.',
        stubs: [0, 3, 5, 6, 8, 10],
        translations: {
            eng: 'While Anke\'s sister stayed at home, Anke went to the (literally: in) theater.'
        },
        tags: [
            'in',
            'gehen',
            ', während',
            'zu',
            'bleiben',
            'preterite',
            ', verb'
        ]
    },
    {
        text: 'Trotz vorsichtiger Planung sind viele Sachen schiefgegangen.',
        stubs: [0, 1, 3, 4, 6],
        translations: {
            eng: 'Despite careful plannng, many things have gone wrong.'
        },
        tags: [
            'trotz',
            'schief-',
            '-gehen',
            'schiefgehen',
            'viel'
        ]
    },
    {
        text: 'Obwohl wir alles vorsichtig geplant hatten, sind viele Sachen schiefgegangen.',
        stubs: [0, 2, 4, 5, 6, 7, 9],
        translations: {
            eng: 'Even though we had planned everything carefully, many things have gone wrong.'
        },
        tags: [
            ', obwohl',
            'all',
            'plannen',
            'hatten',
            'preterite',
            'viel',
            'schief-',
            '-gehen',
            'schiefgehen'
        ]
    },
    {
        text: 'Ich bin früher nach Hause gegangen, weil ich mich schlecht gefühlt habe.',
        stubs: [1, 2, 3, 5, 6, 7, 8, 10, 11],
        translations: {
            eng: 'I went home earlier because I felt sick (literally: bad).'
        },
        tags: [
            'gehen',
            'nach',
            ', weil',
            'fühlen',
            'reflexive'
        ]
    },
    {
        text: 'Am nächsten Tag bin ich arbeiten gegangen, obwohl ich mich immer noch schlecht gefühlt habe.',
        stubs: [0, 1, 3, 5, 6, 7, 8, 9, 13, 14],
        translations: {
            eng: 'The next day I went to work even though I still (regretably) felt sick (literally: bad).'
        },
        tags: [
            'an',
            'arbeiten',
            'gehen',
            ', obwohl',
            'fühlen',
            ', article'
        ]
    },
    {
        text: 'Sie hat den Job wegen des Gehalts, das sehr gut war, genommen.',
        stubs: [1, 2, 4, 5, 7, 10, 11],
        translations: {
            eng: 'She took the job due to the salary, which was very good.'
        },
        tags: [
            'wegen',
            ', article',
            'nehmen'
        ]
    },
    {
        text: 'Sie hat den Job trotz des Gehalts, das nicht gut war, genommen.',
        stubs: [1, 2, 4, 5, 7, 10, 11],
        translations: {
            eng: 'She took the job despite the salary, which was not good.'
        },
        tags: [
            'trotz',
            ', article',
            'nehmen',
        ]
    },
    {
        text: 'Ich konnte schlafen, obwohl es sehr laut war.',
        stubs: [1, 2, 3, 4, 7],
        translations: {
            eng: 'I could sleep, even though it was very noisy.'
        },
        tags: [
            'könnten',
            'schlafen',
            ', obwohl'
        ]
    },
    {
        text: 'Ich konnte wegen des Lärms nicht schlafen.',
        stubs: [1, 2, 3, 6],
        translations: {
            eng: 'I could not sleep despite the noise.'
        },
        tags: [
            'könnten',
            'wegen',
            'schlafen'
        ]
    },
    {
        text: 'Obwohl ich müde war, konnte ich nicht schlafen.',
        stubs: [0, 3, 4, 7],
        translations: {
            eng: 'Even though I was tired, I couldn\'t sleep.'
        },
        tags: [
            'könnten',
            'schlafen',
            ', obwohl',
            ', verb'
        ]
    },
    {
        text: 'Obwohl mein Fuß verletzt war, konnte ich zum nächsten Dorf laufen.',
        stubs: [0, 1, 4, 5, 7, 8, 10],
        translations: {
            eng: 'Even though my foot hurt, I could walk to the next village.'
        },
        tags: [
            ', obwohl',
            'mein',
            'könnten',
            'zu',
            'laufen',
            ', verb'
        ]
    },
    {
        text: 'Trotz der dummen Handlung habe ich den Film gesehen.',
        stubs: [0, 1, 2, 4, 6, 8],
        translations: {
            eng: 'Despite the stupid plot, I watched the film.'
        },
        tags: [
            'trotz',
            'sehen',
            ', preposition'
        ]
    },
    {
        text: 'Obwohl ich einen Regenschirm hatte, wurde ich nass im Regen.',
        stubs: [0, 2, 4, 5, 8],
        translations: {
            eng: 'Even though I had an umbrella, I got (literally: became) wet in the rain.'
        },
        tags: [
            ', obwohl',
            'hatten',
            'wurden',
            ', verb',
            'in'
        ]
    },
    {
        text: 'Ich schütze meine Augen, indem ich eine Sonnenbrille trage.',
        stubs: [1, 2, 4, 8],
        translations: {
            eng: 'I protect my eyes by wearing sunglasses.'
        },
        tags: [
            ', indem',
            'tragen',
            'schützen'
        ]
    },
    {
        text: 'Meine Eltern empfinden immer noch viel füreinander.',
        stubs: [1, 2, 4, 6],
        translations: {
            eng: 'My parents still feel a lot for each other.'
        },
        tags: [
            'emp-',
            '-finden',
            'empfinden',
            'possesive-pronoun-nominative',
            'noch',
            'present-simple',
            'active-voice'
        ]
    },
    {
        text: 'Ich empfehle dieses Buch jedem, der an Geschichte interessiert ist.',
        stubs: [1, 2, 4],
        translations: {
            eng: 'I recommend this book to anyone interested in history.'
        },
        tags: [
            'je',
            'emp-',
            '-fehlen',
            'empfehlen',
            'dies',
            'present-simple',
            'active-voice'
        ]
    },
    {
        text: 'Wenn Maria eine Rezeptidee braucht, wendet sie sich an ihre Cousine.',
        stubs: [5, 6, 7, 8, 9],
        translations: {
            eng: 'When Maria needs a recipe idea, she turns to her cousin.'
        },
        tags: [
            'wenden',
            'an',
            'reflexive'
        ]
    },
    {
        text: 'Bitte nur im Freien verwenden.',
        stubs: [2, 4],
        translations: {
            eng: 'Please only use outside.'
        },
        tags: [
            'in',
            'wo?',
            'verwenden',
            'ver-',
            '-wenden'
        ]
    },
    {
        text: 'Ich wende mich dir zu.',
        stubs: [1, 2, 3, 4],
        translations: {
            eng: 'I\'m turning (literally: giving my attention) to you.'
        },
        tags: [
            'zuwenden',
            'zu-',
            '-wenden',
            'reflexive',
            'pronoun-dative'
        ]
    },
    {
        text: 'Das Unternehmen hat die Pleite gerade noch abgewendet.',
        stubs: [5, 6, 7],
        translations: {
            eng: 'The company managed to just barely avert bankruptcy.'
        },
        tags: [
            'abwenden',
            'ab-',
            '-wenden',
            'gerade',
            'noch'
        ]
    },
    {
        text: 'Nudeln selber zu machen, ist mir zu aufwendig.',
        stubs: [1, 2, 3, 5, 6, 7],
        translations: {
            eng: 'Making pasta myself is too much work for me.'
        },
        tags: [
            'selber',
            'zu verb',
            'machen',
            'aufwenden',
            'auf-',
            '-wenden',
            'pronoun-dative'
        ]
    },
    {
        text: 'Der Aufwand für diese eine kurze Szene war obszön.',
        stubs: [0, 1, 2, 3, 4, 5],
        translations: {
            eng: 'The effort for this one short scene was obscene.'
        },
        tags: [
            'aufwenden',
            'auf-',
            '-wenden',
            'dies',
            'für'
        ]
    },
    {
        text: 'Er lädt die neue Kollegin unter einem Vorwand zum Dinner ein.',
        stubs: [1, 5, 6, 7, 8, 10],
        translations: {
            eng: 'He invited the new colleague to dinner under false pretenses.'
        },
        tags: [
            'einladen',
            'ein-',
            '-laden',
            'unter',
            'zu',
            'vor-',
            '-wenden',
            'vorwenden'
        ]
    },
    {
        text: 'In der Grundschule mussten wir Gedichte auswendig lernen.',
        stubs: [0, 1, 6],
        translations: {
            eng: 'In elementary school he had to learn poems by heart.'
        },
        tags: [
            'in',
            'wo?',
            'aus-',
            '-wenden',
            'auswenden'
        ]
    },
    {
        text: 'Ich lege mir eine Decke um die Schultern.',
        stubs: [1, 2, 3, 5, 6],
        translations: {
            eng: 'I put a blanket around my shoulders.'
        },
        tags: [
            'legen',
            'pronoun-dative',
            'um',
            'decken'
        ]
    },
    {
        text: 'Mein Chef gibt mir Rückendeckung für mein Projekt.',
        stubs: [3, 4, 5, 6],
        translations: {
            eng: 'My boss supports me on (literally: gives me support for) this project.'
        },
        tags: [
            'pronoun-dative',
            'decken',
            'für'
        ]
    },
    {
        text: 'Das deckt die Kosten nicht.',
        stubs: [1],
        translations: {
            eng: 'That doesn\'t cover the costs.'
        },
        tags: [
            'decken'
        ]
    },
    {
        text: 'Deine Story deckt sich mit dem, was Thomas erzählt hat.',
        stubs: [2, 3, 4, 5, 6, 8, 9],
        translations: {
            eng: 'Your story matches up with what Thomas has said.'
        },
        tags: [
            'reflexive',
            'decken',
            'mit',
            'erzählen'
        ]
    },
    {
        text: 'Schnee bedeckt das Land.',
        stubs: [1],
        translations: {
            eng: 'Snow covers the land.'
        },
        tags: [
            'be-',
            '-decken'
        ]
    },
    {
        text: 'Ich habe das Blech mit Frischhaltefolie abgedeckt und auf den Balkon gestellt.',
        stubs: [6, 8, 9, 11],
        translations: {
            eng: 'I have covered the baking tray with plastic wrap and set it on the balcony.'
        },
        tags: [
            'ab-',
            '-decken',
            'abdecken',
            'stellen',
            'auf'
        ]
    },
    {
        text: 'Wir haben die Gartenmöbel abgedeckt, damit sie nicht nass werden.',
        stubs: [4, 5, 9],
        translations: {
            eng: 'We have covered the garden furniture so that it doesn\'t get (literally: become) wet.'
        },
        tags: [
            'ab-',
            '-decken',
            'abdecken',
            'da-',
            'werden'
        ]
    },
    {
        text: 'Das neue Hause verdeckt mir die Sicht auf den Sonnenuntergang.',
        stubs: [3, 4, 7, 8],
        translations: {
            eng: 'The new house blocks my view of the sunset.'
        },
        tags: [
            'ver-',
            '-decken',
            'verdecken',
            'pronoun-dative',
            'auf'
        ]
    },
    {
        text: 'Ich mache die Folie weg, mit der ich den Kuchen abgedeckt hatte.',
        stubs: [1, 4, 5, 6, 10, 11],
        translations: {
            eng: 'I am removing the foil, with which I had covered the cake.'
        },
        tags: [
            'weg-',
            '-machen',
            'ab-',
            '-decken',
            'hatten',
            ', preposition'
        ]
    },
    {
        text: 'Aufgrund unserer besonnenen Analyse jeder Situation sind wir unschlagbar.',
        stubs: [0, 1, 2, 4],
        translations: {
            eng: 'Based on our circumspect analysis of every siutation, we are unbeatable.'
        },
        tags: [
            'aufgrund',
            'unser',
            'be-',
            '-sonnen',
            'jed'
        ]
    },
    {
        text: 'Ich wette, dass das Geheimnis ihrer Intuition damit zusammenhängt, wie sie ausgebrütet werden.',
        stubs: [1, 2, 5, 7, 8],
        translations: {
            eng: 'I bet that the secret of their intuition is related to how they are hatched.'
        },
        tags: [
            'wetten',
            ', dass',
            'damit',
            'zusammen-',
            '-hängen',
            'zusammenhängen'
        ]
    },
    {
        text: 'Ich wette, dass das Geheimnis ihrer Intuition damit zusammenhängt, wie sie ausgebrütet werden.',
        stubs: [9, 10, 11, 12],
        translations: {
            eng: 'I bet that the secret of their intuition are related to how they are hatched.'
        },
        tags: [
            ', wie',
            'aus-',
            '-brüten',
            'werden',
            'present-simple',
            'passive-voice'
        ]
    },
    {
        text: 'Sie freuen sich schon, dich als Teammitglied begrüßen zu dürfen.',
        stubs: [4, 5, 7, 8, 9],
        translations: {
            eng: 'They\'re looking forward to welcoming you as a team-member.'
        },
        tags: [
            ', pronoun',
            'als',
            'begrüßen',
            'be-',
            '-grüßen',
            'zu verb',
            'dürfen'
        ]
    },
    {
        text: 'Dein Reich möchte, dass du die größtmögliche Stadt baust.',
        stubs: [3, 4, 5, 6, 8],
        translations: {
            eng: 'Your empire wants you to build the greatest possible city.'
        },
        tags: [
            ', dass',
            'present-simple',
            'active-voice'
        ]
    },
    {
        text: 'Klicke auf ein leeres Feld und platziere das Gras, das du hältst.',
        stubs: [1, 2, 3, 6, 11],
        translations: {
            eng: 'Click on an empty field and place the grass that you are holding.'
        },
        tags: [
            'auf',
            'platzieren',
            'hälten'
        ]
    },
    {
        text: 'Entwickle dein Land weiter, indem du drei einfache Objekte verbindest, um ein wertvolleres Objekt zu erschaffen.',
        stubs: [4, 5, 9],
        translations: {
            eng: 'Develop your land further by connecting three simple items in order to create a more valuable object.'
        },
        tags: [
            ', indem',
            'verbinden',
            'ver-',
            '-binden'
        ]
    },
    {
        text: 'Entwickle dein Land weiter, indem du drei einfache Objekte verbindest, um ein wertvolleres Objekt zu erschaffen.',
        stubs: [10, 11, 12, 14, 15],
        translations: {
            eng: 'Develop your land further by connecting three simple items in order to create a more valuable object.'
        },
        tags: [
            ', um zu',
            'zu verb',
            'erschaffen',
            'er-',
            '-schaffen'
        ]
    },
    {
        text: 'Ich vergaß, den Drucker mit dem Computer zu verbinden.',
        stubs: [1],
        translations: {
            eng: 'I forgot to connect the printer with the computer.'
        },
        tags: [
            'vergessen',
            'preterite'
        ]
    },
    {
        text: 'Ich vergaß, den Drucker mit dem Computer zu verbinden.',
        stubs: [2, 4, 5, 7, 8],
        translations: {
            eng: 'I forgot to connect the printer with the computer.'
        },
        tags: [
            ', article',
            'mit',
            'zu verb',
            'verbinden',
            'ver-',
            '-binden',
            'verbinden'
        ]
    },
    {
        text: 'Das Museum stellt viele wertvolle Gemälde aus.',
        stubs: [2, 3, 4, 6],
        translations: {
            eng: 'The museum exhibits many valuable paintings.'
        },
        tags: [
            '-stellen',
            'aus-',
            'ausstellen',
            'present-simple',
            'active-voice'
        ]
    },
    {
        text: 'Wollen wir uns dann Mittwoch um 11:00 treffen und vielleicht für zwei Stunden?',
        stubs: [0, 1, 2, 3, 5, 7],
        translations: {
            eng: 'Shall we meet then Wednesday at 11 a.m. and perhaps for two hours?'
        },
        tags: [
            'wollen',
            'dann',
            'um',
            'treffen',
            'reflexive'
        ]
    },
    {
        text: 'Doppelkombos erscheinen, wenn du mehrere Verbindungen in einem Zug kreierst.',
        stubs: [1, 2, 6, 7, 9],
        translations: {
            eng: 'Double combos appear when you create more connections in a line.'
        },
        tags: [
            'er-',
            '-scheinen',
            ', wenn',
            'in',
            'kreieren'
        ]
    },
    {
        text: 'Er wurde für sein ausgezeichnetes Verhalten an der Schule beglückwünscht.',
        stubs: [1, 2, 3, 4, 5, 6, 7],
        translations: {
            eng: 'He was congratulated for his excellent conduct at school.'
        },
        tags: [
            'wurden',
            'für',
            'an',
            'aus-',
            '-zeichnen',
            'auszeichnen',
            'ver-',
            '-halten',
            'verhalten',
            'past-simple',
            'passive-voice'
        ]
    },
    {
        text: 'Diese verhalten sich wie gewöhnliche Objekte, sind aber doppelt so viele Punkte wert.',
        stubs: [0, 1, 2, 4, 6, 7, 8, 12],
        translations: {
            eng: 'These conduct themselves like ordinary items, but count for twice as many points.'
        },
        tags: [
            'dies',
            'ver-',
            '-halten',
            'verhalten',
            'wohnen',
            'aber',
            'werten'
        ]
    },
    {
        text: 'Sie laufen herum und behindern dich beim Bauen.',
        stubs: [1, 2, 4, 5, 6],
        translations: {
            eng: 'They run around and hinder you with the construction.'
        },
        tags: [
            'behindern',
            'be-',
            '-hindern',
            'herum',
            'laufen',
            'bei',
            'pronoun-accusative'
        ]
    },
    {
        text: 'Der Hersteller bringt die fertigen Produkte in einem Lager unter.',
        stubs: [1, 2, 6, 7, 9],
        translations: {
            eng: 'The manufacturer stores the finished products in a warehouse.'
        },
        tags: [
            'her-',
            '-stellen',
            'herstellen',
            'in',
            'unter-',
            '-bringen',
            'unterbringen'
        ]
    },
    {
        text: 'Im Lager kannst du Objekten für den späteren Gebrauch ablegen.',
        stubs: [0, 5, 6, 7, 8, 9],
        translations: {
            eng: 'In the warehouse you can set aside items for (literally: for the) later use.'
        },
        tags: [
            'in',
            'für',
            'ge-',
            '-brauchen',
            'gebrauchen',
            'ab-',
            '-legen',
            'ablegen'
        ]
    },
    {
        text: 'Im Laden kannst du Objekte aus dem kaiserlichen Vorrat kaufen.',
        stubs: [0, 5, 6, 7],
        translations: {
            eng: 'In the shop you can buy items from the imperial reserve.'
        },
        tags: [
            'in',
            'aus',
            'woher?'
        ]
    },
    {
        text: 'Lass uns ein paar unserer Münzen benutzen, um einen Kaffee zu kaufen.',
        stubs: [0, 1, 4, 6, 7, 8, 10],
        translations: {
            eng: 'Let\'s use some of our coins in order to buy a coffee.'
        },
        tags: [
            'lassen',
            ', um zu',
            'unser',
            'be-',
            '-nutzen',
            'benutzen'
        ]
    },
    {
        text: 'Mein Mann weiß, dass er mir vertrauen kann.',
        stubs: [3, 5, 6, 7],
        translations: {
            eng: 'My husband knows that he can trust me.'
        },
        tags: [
            'ver-',
            '-trauen',
            'vertrauen',
            ', dass',
            'pronoun-dative'
        ]
    },
    {
        text: 'Geschäftspartner müssen einander vertrauen.',
        stubs: [1, 2, 3],
        translations: {
            eng: 'Business partners have to trust each other.'
        },
        tags: [
            'vertrauen',
            'ver-',
            '-trauen'
        ]
    },
    // {
    //     //     0   1    2      3    4   5   6     7            8    9   10    11    12      13 14     15   16       17
    //     text: 'Vor zwei Wochen habe ich mit Ihnen telefoniert, weil ich viele nasse Stellen an meiner Wand gefunden hatte.',
    //     stubs: [0, 3, 5, 6, 7],
    //     translations: {
    //         eng: 'Two weeks ago I was on the phone with you because I '
    //     }
    // }
    {
        text: 'Sie haben das Dach decken lassen.',
        stubs: [1, 2, 4, 5],
        translations: {
            eng: 'They had someone cover the roof.'
        },
        tags: [
            'decken',
            'lassen',
            'present-perfect',
            'active-voice'
        ]
    },
    {
        text: 'Wir haben das hier gelassen.',
        stubs: [1, 4],
        translations: {
            eng: 'We left it here.'
        },
        tags: [
            'lassen',
            'present-perfect',
            'active-voice'
        ]
    },
    {
        text: 'Er hat die Hausaufgabe im Auto gelassen.',
        stubs: [1, 2, 4, 6],
        translations: {
            eng: 'He left the homework in the car.'
        },
        tags: [
            'in',
            'lassen',
            'present-perfect',
            'active-voice'
        ]
    },
    {
        text: 'Er lässt das Geld auf dem Tisch liegen.',
        stubs: [1, 2, 4, 5, 7],
        translations: {
            eng: 'He forgot the money (literally: he left the money laying) on the table.'
        },
        tags: [
            'lassen',
            'auf',
            'wo?',
            'liegen'
        ]
    },
    {
        //     0   1      2    3     4  5     6              7          8   9       10   11 12  13   14 15    16   17 18
        text: 'Ich musste eine Email an meine Hausverwaltung schreiben, die besagt, dass es ein Leck in einer Wand in meiner Wohnung gibt.',
        stubs: [1, 2, 4, 5, 7, 8, 9],
        translations: {
            eng: 'I had to write an email to my property manager which stated that there\'s a leak in a wall in my apartment.'
        },
        tags: [
            'musste',
            'an',
            'possesive-pronoun-accusative',
            'schreiben',
            'indefinite-article-accusative',
            ', article',
            'besagen',
            'be-',
            '-sagen'
        ]
    },
    {
        text: 'Können Sie bitte den Heimwerker noch mal kontaktieren und einen neuen Termin vereinbaren?',
        stubs: [0, 3, 7, 9, 10, 12],
        translations: {
            eng: 'May you please contact the handyman again and schedule a new appointment?'
        },
        tags: [
            'können',
            'definite-article-accusative',
            'indefinite-article-accusative',
            'kontaktieren',
            'adjective-accusative',
            'ver-',
            'verein-',
            '-baren',
            '-vereinbaren'
        ]
    },
    {
        text: 'Letztes Mal sind wir bis hier gekommen.',
        stubs: [0, 2, 3, 4, 6],
        translations: {
            eng: 'Last time, we came up to here.'
        },
        tags: [
            'letzt',
            'kommen',
            'bis',
            'present-perfect',
            'active-voice'
        ]
    },
    {
        text: 'Ich habe den Rest der Übungen gemacht.',
        stubs: [1, 2, 4, 6],
        translations: {
            eng: 'I did the rest of the exercises.'
        },
        tags: [
            'definite-article-genitive',
            'machen',
            'present-perfect',
            'active-voice'
        ]
    },
    {
        text: 'Ich habe die Zeitformen viel geübt.',
        stubs: [1, 2, 4, 5],
        translations: {
            eng: 'I have practiced the (linguistic) tenses a lot.'
        },
        tags: [
            'form',
            'viel',
            'üben',
            'present-perfect',
            'active-voice'
        ]
    },
    {
        text: 'Ich hoffe, dass ich diese Übungen richtig gemacht habe.',
        stubs: [1, 2, 4, 7, 8],
        translations: {
            eng: 'I hope that I did these exercises correctly.'
        },
        tags: [
            'hoffen',
            ', dass',
            'dies',
            'machen',
            'present-perfect',
            'active-voice'
        ]
    },
    {
        text: 'Gestern habe ich mich mit meiner Chefin getroffen.',
        stubs: [1, 2, 3, 4, 5, 7],
        translations: {
            eng: 'Yesterday I met with my (female) boss.'
        },
        tags: [
            'mit',
            'present-perfect',
            'active-voice',
            'possesive-pronoun-dative'
        ]
    },
    {
        text: 'Gestern habe ich meinem Chef getroffen und dann haben wir einen Kaffee getrunken.',
        stubs: [1, 2, 3, 5, 7, 8, 10, 12],
        translations: {
            eng: 'Yesterday I ran into my boss (literally: I met my boss) and then we had a coffee (literally: we drank a coffee).'
        },
        tags: [
            'possesive-pronoun-dative',
            'treffen',
            'present-perfect',
            'active-voice',
            'dann',
            'trinken',
            'indefinite-article-accusative'
        ]
    },
    {
        text: 'Können wir das Schritt für Schritt machen?',
        stubs: [0, 4, 6],
        translations: {
            eng: 'Can we do it step-by-step?'
        },
        tags: [
            'können',
            'für',
            'machen',
            'present-simple',
            'active-voice'
        ]
    },
    {
        text: 'Jetzt fühle ich mich, als würde ich Schach spielen.',
        stubs: [1, 2, 3, 4, 5, 8],
        translations: {
            eng: 'Now I feel as if I were playing chess.'
        },
        tags: [
            'jetzt',
            'fühlen',
            'reflexive',
            ', als',
            'würden',
            'spielen'
        ]
    },
    {
        text: 'Mein Ziel ist es, Deutsch zum Vergnügen zu lesen.',
        stubs: [0, 2, 3, 5, 7, 8],
        translations: {
            eng: 'My goal is to read German for pleasure.'
        },
        tags: [
            'mein',
            'zu',
            'lesen',
            'zu verb'
        ]
    },
    {
        text: 'Das Leben ändert sich, aber manche Dinge bleiben gleich.',
        stubs: [2, 3, 4, 5, 7],
        translations: {
            eng: 'Life changes, but some things stay the same.'
        },
        tags: [
            'ändern',
            'reflexive',
            ', aber',
            'manch',
            'bleiben',
            'present-simple',
            'active-voice'
        ]
    },
    {
        text: 'Jetzt lerne ich Deutsch, sodass ich in der Lage bin, Deutsch zu meinem Vergnügen zu lesen.',
        stubs: [0, 1, 4, 6, 7, 9],
        translations: {
            eng: 'Right now I\'m learning German so that I can (literally: be in the position to) read German for my own pleasure.'
        },
        tags: [
            'lernen',
            'jetzt',
            ', sodass',
            'in',
            'wo?',
            'present-simple',
            'active-voice'
        ]
    },
    {
        text: 'Jetzt lerne ich Deutsch, sodass ich in der Lage bin, Deutsch zu meinem Vergnügen zu lesen.',
        stubs: [11, 12, 14, 15],
        translations: {
            eng: 'Right now I\'m learning German so that I can (literally: be in the position to) read German for my own pleasure.'
        },
        tags: [
            'zu',
            'possesive-pronoun-dative',
            'zu verb',
            ', noun',
            'present-simple',
            'active-voice'
        ]
    },
    {
        text: 'Jetzt lerne ich Deutsch, weil ich es gerne zu meinem Vergnügen lesen möchte.',
        stubs: [0, 1, 3, 4, 8, 9, 11, 12],
        translations: {
            eng: 'Right now I\'m learning German because I\'d like to read it for my own pleasure.'
        },
        tags: [
            'lernen',
            'jetzt',
            ', weil',
            'zu',
            'possesive-pronoun-dative',
            'lesen',
            'möchten',
            'present-simple',
            'active-voice'
        ]
    },
    {
        text: 'Vor unserem nächsten Treffen, werde ich diese Übungen machen.',
        stubs: [0, 1, 2, 4, 6, 8],
        translations: {
            eng: 'Before our next meeting, I\'ll do these exercises.'
        },
        tags: [
            'vor',
            'unser',
            'adjective-dative',
            'future-simple',
            'active-voice',
            'dies'
        ]
    },
    {
        text: 'Diese Übungen mache ich, bevor wir uns das nächste Mal treffen.',
        stubs: [0, 2, 3, 4, 5, 6, 7, 8, 10],
        translations: {
            eng: 'I\'ll do these exercises before the next time we meet.'
        },
        tags: [
            'dies',
            'machen',
            ', bevor',
            'treffen',
            'reflexive',
            'adjective-accusative'
        ]
    },
    {
        text: 'Ich habe letzte Woche viele Sätze geschrieben, die ich gern mit dir durchgehen möchte.',
        stubs: [2, 4, 6, 7, 8, 10, 11, 13],
        translations: {
            eng: 'Last week I wrote many sentences that I\'d like to go through with you.'
        },
        tags: [
            'viel',
            'schreiben',
            ', article',
            'mit',
            'pronoun-dative',
            'möchten'
        ]
    },
    {
        text: 'Letzten Monat habe ich einen Deutsch-Sprachtest gemacht und mein Ergebnis war B1.',
        stubs: [0, 4, 6, 8, 10],
        translations: {
            eng: 'Last month I took (literally: I did) a German language test and my result was B1.'
        },
        tags: [
            'indefinite-article-accusative',
            'present-perfect',
            'active-voice',
            'possesive-pronoun-nominative',
            'war',
            'machen'
        ]
    },
    {
        text: 'Ich bin noch nicht so viel durch Deutschland gereist.',
        stubs: [1, 2, 3, 6, 8],
        translations: {
            eng: 'I haven\'t traveled very much yet throughout Germany.'
        },
        tags: [
            'noch',
            'present-perfect',
            'active-voice',
            'durch',
            'viel',
            'reisen'
        ]
    },
    {
        text: 'Ich habe noch nicht so viel von Deutschland gesehen.',
        stubs: [1, 2, 3, 6, 8],
        translations: {
            eng: 'I haven\'t seen very much of Germany yet.'
        },
        tags: [
            'noch',
            'viel',
            'present-perfect',
            'active-voice',
            'sehen',
            'von'
        ]
    },
    {
        text: 'Lass mich wissen, wenn du angekommen bist.',
        stubs: [0, 1, 2],
        translations: {
            eng: 'Let me know when you\'ve arrived.'
        },
        tags: [
            'lassen',
            'wissen',
            'pronoun-accusative',
            'present-simple',
            'active-voice'
        ]
    },
    {
        text: 'Lass mich wissen, wenn du angekommen bist.',
        stubs: [3, 4, 5, 6],
        translations: {
            eng: 'Let me know when you\'ve arrived.'
        },
        tags: [
            ', wenn',
            'an-',
            '-kommen',
            'ankommen',
            'present-perfect',
            'active-voice'
        ]
    },
    {
        text: 'Sag mir Bescheid, wenn du angekommen bist.',
        stubs: [3, 4, 5, 6],
        translations: {
            eng: 'Let me know (literally: tell me a note) when you\'ve arrived.'
        },
        tags: [
            ', wenn',
            'an-',
            '-kommen',
            'ankommen',
            'present-perfect',
            'active-voice'
        ]
    },
    {
        text: 'Deutsch ist so geschrieben, wie man es spricht.',
        stubs: [1, 2, 3, 4, 5, 6, 7],
        translations: {
            eng: 'German is written as how one speaks it.'
        },
        tags: [
            'so',
            'schreiben',
            'present-perfect',
            'active-voice',
            ', wie',
            'sprechen'
        ]
    },
    {
        text: 'Ich warte hier in der Schlange, um etwas zu bestellen.',
        stubs: [1, 3, 4, 6, 8, 9],
        translations: {
            eng: 'I\'m waiting in line here in order to order something.',
        },
        tags: [
            'warten',
            'in',
            'definite-article-dative',
            'wo?',
            ', um zu',
            'bestellen',
            'be-',
            '-stellen',
            'present-simple',
            'active-voice'
        ]
    },
    {
        text: 'Er hat mich gefragt, ob dies mein erstes Mal hier ist.',
        stubs: [1, 2, 3, 4, 5, 6, 7, 10],
        translations: {
            eng: 'He asked me whether this is my first time here.'
        },
        tags: [
            'present-perfect',
            'active-voice',
            ', ob',
            'dies',
            'possesive-pronoun-nominative',
            'adjective-nominative'
        ]
    },
    {
        text: 'Dies ist schon mein zweites Mal hier.',
        stubs: [0, 2, 3, 4, 6],
        translations: {
            eng: 'This is already my second time here.'
        },
        tags: [
            'present-simple',
            'active-voice',
            'possesive-pronoun-nominative',
            'adjective-nominative',
            'dies'
        ]
    },
    {
        text: 'Ich habe ein einfaches Buch von der Bibliothek ausgeliehen.',
        stubs: [1, 2, 3, 5, 6, 8],
        translations: {
            eng: 'I borrowed a simple book from the library.'
        },
        tags: [
            'indefinite-article-accusative',
            'adjective-accusative',
            'von',
            'definite-article-dative',
            'aus-',
            'liehen',
            'ausliehen',
            'present-perfect',
            'active-voice'
        ]
    },
    {
        text: 'Aktivisten kämpfen dagegen, dass in Deutschland Braunkohle gefördert wird.',
        stubs: [1, 2, 3, 4, 7, 8],
        translations: {
            eng: 'Activists are fighting against the fact that brown coal is mined in Germany.'
        },
        tags: [
            'kämpfen',
            'da-',
            'gegen',
            ', dass',
            'in',
            'fordern',
            'werden',
            'present-simple',
            'passive-voice'

        ]
    },
    {
        text: 'Nach einem harten Arbeitstag ruhe ich mich gern am Abend aus.',
        stubs: [0, 1, 2, 4, 6, 8, 10],
        translations: {
            eng: 'After a hard day of work, I like to relax in the evening.'
        },
        tags: [
            'nach',
            'indefinite-article-dative',
            'adjective-dative',
            'aus-',
            '-ruhen',
            'ausruhen',
            'reflexive',
            'an',
            'definite-article-dative',
            'pronoun-accusative',
            'present-simple',
            'active-voice',
            'wann?'
        ]
    },
    {
        text: 'Zu Silvester gibt es normalerweise viele Partys.',
        stubs: [0, 2, 3, 5],
        translations: {
            eng: 'On New Year\'s Eve, there are usually many parties.'
        },
        tags: [
            'zu',
            'viel',
            'wann?'
        ]
    },
    {
        text: 'Ich habe jetzt keine Zeit. Ich bin gerade bei Fritz.',
        stubs: [1, 2, 3, 6, 7, 8],
        translations: {
            eng: 'I have no time now. I\'m with Fritz right now.'
        },
        tags: [
            'jetzt',
            'kein',
            'gerade',
            'bei',
            'wo?',
            'present-simple',
            'active-voice'
        ]
    },
    {
        text: 'Die Adresse steht auf der Rückseite des Briefes.',
        stubs: [2, 3, 4, 6],
        translations: {
            eng: 'The address is on the backside of the letter.'
        },
        tags: [
            'stehen',
            'auf',
            'wo?',
            'definite-article-dative',
            'definite-article-genitive'
        ]
    },
    {
        text: 'Er sitzt den ganzen Tag am Fenster in der Küche.',
        stubs: [1, 2, 3, 5, 7, 8],
        translations: {
            eng: 'He sits the whole day by the window in the kitchen.'
        },
        tags: [
            'sitzen',
            'definite-article-accusative',
            'an',
            'wo?',
            'in',
            'definite-article-dative'
        ]
    },
    {
        text: 'Ich mag das Bild, das an der Wand im Flur hängt.',
        stubs: [1, 2, 4, 5, 6, 8, 10],
        translations: {
            eng: 'I like the picture that hangs on the wall in the hallway.'
        },
        tags: [
            'mögen',
            'definite-article-accusative',
            ', article',
            'an',
            'wo?',
            'definite-article-dative',
            'in',
            'hängen',
            'present-simple',
            'active-voice'
        ]
    },
    {
        text: 'Gestern gab es einen Unfall an dieser Kreuzung.',
        stubs: [1, 2, 3, 5, 6],
        translations: {
            eng: 'Yesterday there was an accident at this intersection.'
        },
        tags: [
            'indefinite-article-accusative',
            'an',
            'wo?',
            'dies'
        ]
    },
    {
        text: 'Du findest die Sportnachrichten auf Seite 3.',
        stubs: [1, 2, 4],
        translations: {
            eng: 'You can find the sports news on page 3.'
        },
        tags: [
            'finden',
            'definite-article-accusative',
            'auf',
            'wo?',
            'present-simple',
            'active-voice'
        ]
    },
    {
        text: 'Der Mann, den die Polizei sucht, hat eine Narbe auf der linken Wange.',
        stubs: [0, 2, 3, 5, 6, 7, 9, 10, 11],
        translations: {
            eng: 'The man that the police are looking for has a scar on the left cheek.'
        },
        tags: [
            'definite-article-nominative',
            ', article',
            'definite-article-accusative',
            'suchen',
            ', verb',
            'indefinite-article-accusative',
            'auf',
            'wo?',
            'definite-article-dative',
            'adjective-dative',
            'present-simple',
            'active-voice'
        ]
    },
    {
        text: 'Ich weiß, wo der Schlüssel ist, den die Mutter sucht.',
        stubs: [1, 2, 3, 5, 6, 7, 9],
        translations: {
            eng: 'I know where the key is that the mother is looking for.'
        },
        tags: [
            'wissen',
            ', wo',
            'definite-article-nominative',
            ', article',
            'definite-article-accusative',
            'suchen',
            'present-simple',
            'active-voice'
        ]
    },
    {
        text: 'Das ist mein Freund, dessen Foto dir so gut gefallen hat.',
        stubs: [2, 4, 6, 9, 10],
        translations: {
            eng: 'That\'s my friend whose photo you liked so much.'
        },
        tags: [
            'mein',
            ', article',
            'definite-article-genitive',
            'pronoun-dative',
            'gefallen',
            'present-perfect',
            'active-voice'
        ]
    },
    {
        text: 'Ich wollte mit dem Bus, dessen Fahrer betrunken war, nicht weiterfahren.',
        stubs: [1, 2, 3, 5, 8, 10],
        translations: {
            eng: 'I didn\'t want to ride further with the bus whose driver was drunk.'
        },
        tags: [
            'wollten',
            'mit',
            'definite-article-dative',
            'definite-article-genitive',
            ', article',
            'waren',
            'weiterfahren',
            'weiter-',
            '-fahren',
            'preterite',
            'past-simple',
            'active-voice'
        ]
    },
    {
        text: 'Das ist der Mann, dessen Tochter gestern hier war.',
        stubs: [2, 4, 8],
        translations: {
            eng: 'That\'s the man whose daughter was here yesterday.'
        },
        tags: [
            'definite-article-nominative',
            'definite-article-genitive',
            ', article',
            'waren'
        ]
    },
    {
        text: 'Für mich ist mein Hund ein Freund, mit dem ich mich unterhalten kann.',
        stubs: [0, 1, 3, 5, 7, 8, 10, 11, 12],
        translations: {
            eng: 'For me, my dog is a friend with whom I can talk to.'
        },
        tags: [
            'für',
            'pronoun-accusative',
            'mein',
            'indefinite-article-nominative',
            ', preposition',
            'definite-article-dative',
            'unterhalten',
            'reflexive',
            'können',
            'present-simple',
            'active-voice'
        ]
    },
    {
        text: 'Wo ist das Mädchen, dem du geholfen hast?',
        stubs: [2, 4, 6, 7],
        translations: {
            eng: 'Where is the girl that you helped?'
        },
        tags: [
            'definite-article-nominative',
            ', article',
            'definite-article-dative',
            'helfen',
            'present-perfect',
            'active-voice'
        ]
    },
    {
        text: 'Ich bereite mich auf die Prüfungen vor, indem ich regelmäßig den Stoff wiederhole.',
        stubs: [1, 2, 3, 4, 6, 7, 10, 12],
        translations: {
            eng: 'I\'m preparing myself for the exams by repeating the (learning) material regularly.'
        },
        tags: [
            'vor-',
            '-bereiten',
            'vorbereiten',
            'auf',
            'definite-article-accusative',
            ', indem',
            'wieder-',
            '-holen',
            'wiederholen'
        ]
    },
    {
        text: 'Ich werde warten und sehen, was geschieht.',
        stubs: [1, 5, 6],
        translations: {
            eng: 'I\'ll wait and see what happens.'
        },
        tags: [
            'geschehen',
            'ge-',
            '-schehen',
            ', was',
            'werden',
            'future-simple',
            'active-voice'
        ]
    },
    {
        text: 'Ich rufe dich nachher an, aber vorher muss ich essen.',
        stubs: [3, 6],
        translations: {
            eng: 'I\'ll call you later, but first I need to eat.'
        },
        tags: [
            'nachher',
            'vorher'
        ]
    },
    {
        text: 'Das stecke ich in meine Tasche.',
        stubs: [1, 3, 4],
        translations: {
            eng: 'I am sticking that in my bag.'
        },
        tags: [
            'stecken',
            'in',
            'wohin?',
            'possesive-pronoun-accusative'
        ]
    },
    {
        text: 'Wir haben Ihren Bestellschein erhalten und die Zahlreise von monatlich auf jährlich gewechselt.',
        stubs: [4, 8, 10, 12],
        translations: {
            eng: 'We have received your (formal) order form and have changed the payment method from monthly to yearly.'
        },
        tags: [
            'erhalten',
            'er-',
            '-halten',
            'von',
            'auf',
            'wechseln'
        ]
    },
    {
        text: 'Ich trinke meinen Kaffee nicht mit Zucker, sondern mit Honig.',
        stubs: [2, 7],
        translations: {
            eng: 'I don’t drink my coffee with sugar but with honey.'
        },
        tags: [
            'possesive-pronoun-accusative',
            ', sondern'
        ]
    },
    {
        text: 'Die Diskussion war nicht mehr sachlich, sondern emotional.',
        stubs: [6],
        translations: {
            eng: 'The discussion was no longer factual but emotional.'
        },
        tags: [
            ', sondern'
        ]
    },
    {
        text: 'Ich habe nicht nur mein Zimmer aufgeräumt, sondern auch die Küche und das Bad.',
        stubs: [4, 6, 7],
        translations: {
            eng: 'Not only did I clean my room but also the kitchen and the bathroom.'
        },
        tags: [
            'auf-',
            'aufräumen',
            ', sondern',
            'possesive-pronoun-accusative'
        ]
    },
    {
        text: 'Manchmal fühlt es sich an, als ob sich die ganze Welt gegen mich verschwört.',
        stubs: [1, 4, 5, 6, 7, 11, 12, 13],
        translations: {
            eng: 'Sometimes it feels like the whole world is plotting against me.'
        },
        tags: [
            'an-',
            '-fühlen',
            'anfühlen',
            ', als ob',
            'verschwören',
            'ver-',
            '-schwören',
            'gegen'
        ]
    },
    {
        text: 'In diesem Spiel kann man seinen eigenen Charakter erstellen.',
        stubs: [0, 1, 5, 6, 8],
        translations: {
            eng: 'In this game you can create your own character.'
        },
        tags: [
            'wo?',
            'dies',
            'possesive-pronoun-accusative',
            'er-',
            '-stellen',
            'erstellen',
            'adjective-accusative'
        ]
    },
    {
        text: 'Jedes Land hat Gesetze, um Ordnung zu schaffen.',
        stubs: [0, 4, 6, 7],
        translations: {
            eng: 'Every country has laws to create order.'
        },
        tags: [
            'jed',
            ', um zu',
            'schaffen'
        ]
    },
    {
        //     0      1  2     3   4     5    6       7     8       9    10  11          12
        text: 'Kinder im Alter von einem Jahr stellen einen kleinen Teil der Bevölkerung dar.',
        stubs: [1, 3, 6, 12],
        translations: {
            eng: 'Children at the age of one constitute a small part of the population.'
        },
        tags: [
            'in',
            'von',
            '-stellen',
            'dar-',
            'darstellen'
        ]
    },
    {
        text: 'Der Gewinn des Unternehmens wird in einem Diagramm dargestellt.',
        stubs: [4, 5, 6, 8],
        translations: {
            eng: 'The company\'s profits are presented in a chart.'
        },
        tags: [
            'werden',
            'in',
            'indefinite-article-dative',
            '-stellen',
            'dar-',
            'darstellen'
        ]
    },
    {
        text: 'Diese Grafik stellt die Ergebnisse deutlich dar.',
        stubs: [1, 2, 6],
        translations: {
            eng: 'This graph shows the results clearly.'
        },
        tags: [
            'dies',
            '-stellen',
            'dar-',
            'darstellen'
        ]
    },
    {
        text: 'Der Sturm stellt keine Gefahr mehr für die Stadt dar.',
        stubs: [2, 3, 6, 7, 9],
        translations: {
            eng: 'The storm no longer poses a threat to the city.'
        },
        tags: [
            'kein',
            '-stellen',
            'dar-',
            'darstellen',
            'definite-article-accusative',
            'für'
        ]
    },
    {
        text: 'Der Schauspieler stellte den legendären Boxer sehr realistisch dar.',
        stubs: [2, 8],
        translations: {
            eng: 'The actor portrayed the legendary boxer very realistically.'
        },
        tags: [
            '-stellen',
            'dar-',
            'darstellen'
        ]
    },
    {
        text: 'Er legte die Gründe für seine Entscheidung dar.',
        stubs: [1, 4, 5, 7],
        translations: {
            eng: 'He stated the reasons for his decision.'
        },
        tags: [
            '-legen',
            'dar-',
            'darlegen',
            'für',
            'sein'
        ]
    },
    {
        text: 'Das Internet ist zu einem wichtigen Teil des Alltags geworden.',
        stubs: [2, 3, 4, 5, 7, 9],
        translations: {
            eng: 'The internet has become an essential part of everyday life.'
        },
        tags: [
            'zu',
            'indefinite-article-dative',
            'adjective-dative',
            'definite-article-genitive',
            'geworden'
        ]
    },
    {
        text: 'Mein Freund und ich sind zusammen alt geworden.',
        stubs: [0, 4, 7],
        translations: {
            eng: 'My friend and I have grown old together.'
        },
        tags: [
            'mein',
            'geworden'
        ]
    }
];
